(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4527],{

/***/ 72281:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _category_; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./src/components/atoms/index.js + 38 modules
var atoms = __webpack_require__(52738);
// EXTERNAL MODULE: ./src/config/index.js + 8 modules
var config = __webpack_require__(54176);
// EXTERNAL MODULE: ./src/components/molecules/index.js + 37 modules
var molecules = __webpack_require__(53732);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./helpers/index.js
var helpers = __webpack_require__(60651);
// EXTERNAL MODULE: ./src/components/molecules/CardList/components/CardItem.js + 3 modules
var CardItem = __webpack_require__(51531);
// EXTERNAL MODULE: ./src/modules/explore_search/index.js + 4 modules
var explore_search = __webpack_require__(48306);
// EXTERNAL MODULE: ./src/modules/filter/index.js + 20 modules
var filter = __webpack_require__(8559);
// EXTERNAL MODULE: ./src/modules/explore_search/components/FilterView.js
var FilterView = __webpack_require__(580);
// EXTERNAL MODULE: ./components_web/Footer.js
var Footer = __webpack_require__(52460);
// EXTERNAL MODULE: ./components_web/HeaderSearch.js
var HeaderSearch = __webpack_require__(16087);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/View/index.js
var View = __webpack_require__(79057);
var View_default = /*#__PURE__*/__webpack_require__.n(View);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 3 modules
var useTranslation = __webpack_require__(77058);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react-accessible-dropdown-menu-hook/dist/use-dropdown-menu.js
var use_dropdown_menu = __webpack_require__(19768);
// EXTERNAL MODULE: ./src/helpers/formatHelpers.js
var formatHelpers = __webpack_require__(9465);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/modules/explore_search/components/NavigationSearchView.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }














var NavigationSearchView = function NavigationSearchView(props) {
  var _useTranslation = (0,useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  var isMobileVersion = props.isMobileVersion,
      buttonPropsMenuMore = props.buttonPropsMenuMore;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
    style: styles.container,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
      style: styles.searchContainer,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* IconizedTextInput */.LA, {
        placeholder: t("key_search"),
        bordered: true,
        onChangeText: function onChangeText(text) {
          props.setKeyword(text);
        },
        value: props.keyword,
        maxLength: 64,
        autoCapitalize: "none",
        autoCorrect: false,
        containerStyle: {
          backgroundColor: (0,formatHelpers/* getClass */.ll)("bg-input"),
          borderWidth: 0,
          height: isMobileVersion ? 30 : 40,
          flex: 1
        },
        returnKeyType: "next",
        showClose: props.keyword !== "",
        onPressClose: function onPressClose() {
          return props.setKeyword("");
        },
        isMobileVersion: isMobileVersion
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "flex justify-center items-center relative",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", _objectSpread(_objectSpread({}, buttonPropsMenuMore), {}, {
          style: {
            justifyContent: "center",
            alignItems: "center",
            marginLeft: 8,
            display: "flex"
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: config/* Images.iconMenuMore */.rU.iconMenuMore,
            width: 24,
            height: 24,
            layout: "fixed",
            alt: "more menu"
          })
        }))
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* BackButton */.xE, {
      withoutBG: true,
      isMobileVersion: isMobileVersion
    })]
  });
};

var styles = StyleSheet_default().create({
  container: {
    borderBottomWidth: 1,
    borderBottomColor: (0,formatHelpers/* getClass */.ll)("bg-black2"),
    backgroundColor: (0,formatHelpers/* getClass */.ll)("header"),
    paddingBottom: 16,
    paddingHorizontal: 12,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    position: "relative"
  },
  searchContainer: {
    paddingLeft: 46,
    paddingTop: 14,
    flex: 1,
    flexDirection: "row"
  }
});
/* harmony default export */ var components_NavigationSearchView = (NavigationSearchView);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-swipeable/es/index.js
var es = __webpack_require__(45338);
;// CONCATENATED MODULE: ./pages/explore/[category].js


function _category_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _category_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _category_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : _category_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

























var DynamicMap = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(9269), __webpack_require__.e(3972)]).then(__webpack_require__.bind(__webpack_require__, 53972));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(53972)];
    }
  }
});

var Festivals = function Festivals(props) {
  var _filterCriteriaListSe, _Constants$categoryTy, _Constants$categoryTy2, _Constants$categoryTy3, _Constants$categoryTy4, _Constants$categoryTy5, _Constants$categoryTy6, _typeModeList$find, _viewModeList$find, _sortList$find, _sortList$find2, _sortList$find3, _sortList$find4, _sortList$find5, _sortList$find6, _process$env$NEXT_PUB2, _process$env$NEXT_PUB3;

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  var router = (0,next_router.useRouter)();
  var _router$query = router.query,
      category = _router$query.category,
      search = _router$query.search,
      page = _router$query.page,
      view = _router$query.view;
  var handlers = (0,es/* useSwipeable */.QS)({
    onSwipedLeft: function onSwipedLeft(eventData) {
      if (category === config/* Constants.categoryType.CATEGORY_VENUE */.gT.categoryType.CATEGORY_VENUE) {
        var newIndex = (itemsVenue === null || itemsVenue === void 0 ? void 0 : itemsVenue.findIndex(function (i) {
          return i.id === mapFocused;
        })) + 1;

        if (newIndex < itemsVenue.length) {
          var _itemsVenue$find;

          setMapFocused(itemsVenue === null || itemsVenue === void 0 ? void 0 : (_itemsVenue$find = itemsVenue.find(function (i, index) {
            return index === newIndex;
          })) === null || _itemsVenue$find === void 0 ? void 0 : _itemsVenue$find.id);
        }
      } else if (category === config/* Constants.categoryType.CATEGORY_ROOFTOP */.gT.categoryType.CATEGORY_ROOFTOP) {
        var _newIndex = (itemsRooftop === null || itemsRooftop === void 0 ? void 0 : itemsRooftop.findIndex(function (i) {
          return i.id === mapFocused;
        })) + 1;

        if (_newIndex < itemsRooftop.length) {
          var _itemsRooftop$find;

          setMapFocused(itemsRooftop === null || itemsRooftop === void 0 ? void 0 : (_itemsRooftop$find = itemsRooftop.find(function (i, index) {
            return index === _newIndex;
          })) === null || _itemsRooftop$find === void 0 ? void 0 : _itemsRooftop$find.id);
        }
      } else if (category === config/* Constants.categoryType.CATEGORY_SPA */.gT.categoryType.CATEGORY_SPA) {
        var _newIndex2 = (itemsSpa === null || itemsSpa === void 0 ? void 0 : itemsSpa.findIndex(function (i) {
          return i.id === mapFocused;
        })) + 1;

        if (_newIndex2 < itemsSpa.length) {
          var _itemsSpa$find;

          setMapFocused(itemsSpa === null || itemsSpa === void 0 ? void 0 : (_itemsSpa$find = itemsSpa.find(function (i, index) {
            return index === _newIndex2;
          })) === null || _itemsSpa$find === void 0 ? void 0 : _itemsSpa$find.id);
        }
      } else if (category === config/* Constants.categoryType.CATEGORY_VENUE_BEACHFUL */.gT.categoryType.CATEGORY_VENUE_BEACHFUL) {
        var _newIndex3 = (itemsVenueBeachful === null || itemsVenueBeachful === void 0 ? void 0 : itemsVenueBeachful.findIndex(function (i) {
          return i.id === mapFocused;
        })) + 1;

        if (_newIndex3 < itemsVenueBeachful.length) {
          var _itemsVenueBeachful$f;

          setMapFocused(itemsVenueBeachful === null || itemsVenueBeachful === void 0 ? void 0 : (_itemsVenueBeachful$f = itemsVenueBeachful.find(function (i, index) {
            return index === _newIndex3;
          })) === null || _itemsVenueBeachful$f === void 0 ? void 0 : _itemsVenueBeachful$f.id);
        }
      } else if (category === config/* Constants.categoryType.CATEGORY_PREFAB_COMPANY */.gT.categoryType.CATEGORY_PREFAB_COMPANY) {
        var _newIndex4 = (itemsPrefabCompany === null || itemsPrefabCompany === void 0 ? void 0 : itemsPrefabCompany.findIndex(function (i) {
          return i.id === mapFocused;
        })) + 1;

        if (_newIndex4 < itemsPrefabCompany.length) {
          var _itemsPrefabCompany$f;

          setMapFocused(itemsPrefabCompany === null || itemsPrefabCompany === void 0 ? void 0 : (_itemsPrefabCompany$f = itemsPrefabCompany.find(function (i, index) {
            return index === _newIndex4;
          })) === null || _itemsPrefabCompany$f === void 0 ? void 0 : _itemsPrefabCompany$f.id);
        }
      } else if (category === config/* Constants.categoryType.CATEGORY_PREFAB_HOMES */.gT.categoryType.CATEGORY_PREFAB_HOMES) {
        var _newIndex5 = (itemsPrefabHome === null || itemsPrefabHome === void 0 ? void 0 : itemsPrefabHome.findIndex(function (i) {
          return i.id === mapFocused;
        })) + 1;

        if (_newIndex5 < itemsPrefabHome.length) {
          var _itemsPrefabHome$find;

          setMapFocused(itemsPrefabHome === null || itemsPrefabHome === void 0 ? void 0 : (_itemsPrefabHome$find = itemsPrefabHome.find(function (i, index) {
            return index === _newIndex5;
          })) === null || _itemsPrefabHome$find === void 0 ? void 0 : _itemsPrefabHome$find.id);
        }
      } else if (category === config/* Constants.categoryType.CATEGORY_ZOO */.gT.categoryType.CATEGORY_ZOO) {
        var _newIndex6 = (itemsZoo === null || itemsZoo === void 0 ? void 0 : itemsZoo.findIndex(function (i) {
          return i.id === mapFocused;
        })) + 1;

        if (_newIndex6 < itemsZoo.length) {
          var _itemsZoo$find;

          setMapFocused(itemsZoo === null || itemsZoo === void 0 ? void 0 : (_itemsZoo$find = itemsZoo.find(function (i, index) {
            return index === _newIndex6;
          })) === null || _itemsZoo$find === void 0 ? void 0 : _itemsZoo$find.id);
        }
      } else if (category === config/* Constants.categoryType.CATEGORY_ANIMAL */.gT.categoryType.CATEGORY_ANIMAL) {
        var _newIndex7 = (itemsAnimal === null || itemsAnimal === void 0 ? void 0 : itemsAnimal.findIndex(function (i) {
          return i.id === mapFocused;
        })) + 1;

        if (_newIndex7 < itemsAnimal.length) {
          var _itemsAnimal$find;

          setMapFocused(itemsAnimal === null || itemsAnimal === void 0 ? void 0 : (_itemsAnimal$find = itemsAnimal.find(function (i, index) {
            return index === _newIndex7;
          })) === null || _itemsAnimal$find === void 0 ? void 0 : _itemsAnimal$find.id);
        }
      } else if (category === config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL) {
        var _newIndex8 = (itemsParkful === null || itemsParkful === void 0 ? void 0 : itemsParkful.findIndex(function (i) {
          return i.id === mapFocused;
        })) + 1;

        if (_newIndex8 < itemsParkful.length) {
          var _itemsParkful$find;

          setMapFocused(itemsParkful === null || itemsParkful === void 0 ? void 0 : (_itemsParkful$find = itemsParkful.find(function (i, index) {
            return index === _newIndex8;
          })) === null || _itemsParkful$find === void 0 ? void 0 : _itemsParkful$find.id);
        }
      } else if (category === config/* Constants.categoryType.CATEGORY_CASINO */.gT.categoryType.CATEGORY_CASINO) {
        var _newIndex9 = (itemsCasino === null || itemsCasino === void 0 ? void 0 : itemsCasino.findIndex(function (i) {
          return i.id === mapFocused;
        })) + 1;

        if (_newIndex9 < itemsCasino.length) {
          var _itemsCasino$find;

          setMapFocused(itemsCasino === null || itemsCasino === void 0 ? void 0 : (_itemsCasino$find = itemsCasino.find(function (i, index) {
            return index === _newIndex9;
          })) === null || _itemsCasino$find === void 0 ? void 0 : _itemsCasino$find.id);
        }
      } else if (category === config/* Constants.categoryType.CATEGORY_CASTLE */.gT.categoryType.CATEGORY_CASTLE) {
        var _newIndex10 = (itemsCastle === null || itemsCastle === void 0 ? void 0 : itemsCastle.findIndex(function (i) {
          return i.id === mapFocused;
        })) + 1;

        if (_newIndex10 < itemsCastle.length) {
          var _itemsCastle$find;

          setMapFocused(itemsCastle === null || itemsCastle === void 0 ? void 0 : (_itemsCastle$find = itemsCastle.find(function (i, index) {
            return index === _newIndex10;
          })) === null || _itemsCastle$find === void 0 ? void 0 : _itemsCastle$find.id);
        }
      } else if (category === config/* Constants.categoryType.CATEGORY_RESORT */.gT.categoryType.CATEGORY_RESORT) {
        var _newIndex11 = (itemsResort === null || itemsResort === void 0 ? void 0 : itemsResort.findIndex(function (i) {
          return i.id === mapFocused;
        })) + 1;

        if (_newIndex11 < itemsResort.length) {
          var _itemsResort$find;

          setMapFocused(itemsResort === null || itemsResort === void 0 ? void 0 : (_itemsResort$find = itemsResort.find(function (i, index) {
            return index === _newIndex11;
          })) === null || _itemsResort$find === void 0 ? void 0 : _itemsResort$find.id);
        }
      } else if (category === config/* Constants.categoryType.CATEGORY_APARTHOTEL */.gT.categoryType.CATEGORY_APARTHOTEL) {
        var _newIndex12 = (itemsAparthotel === null || itemsAparthotel === void 0 ? void 0 : itemsAparthotel.findIndex(function (i) {
          return i.id === mapFocused;
        })) + 1;

        if (_newIndex12 < itemsAparthotel.length) {
          var _itemsAparthotel$find;

          setMapFocused(itemsAparthotel === null || itemsAparthotel === void 0 ? void 0 : (_itemsAparthotel$find = itemsAparthotel.find(function (i, index) {
            return index === _newIndex12;
          })) === null || _itemsAparthotel$find === void 0 ? void 0 : _itemsAparthotel$find.id);
        }
      } else if (category === config/* Constants.categoryType.CATEGORY_VENUE_COCKTAIL */.gT.categoryType.CATEGORY_VENUE_COCKTAIL) {
        var _newIndex13 = (itemsVenueCocktail === null || itemsVenueCocktail === void 0 ? void 0 : itemsVenueCocktail.findIndex(function (i) {
          return i.id === mapFocused;
        })) + 1;

        if (_newIndex13 < itemsVenueCocktail.length) {
          var _itemsVenueCocktail$f;

          setMapFocused(itemsVenueCocktail === null || itemsVenueCocktail === void 0 ? void 0 : (_itemsVenueCocktail$f = itemsVenueCocktail.find(function (i, index) {
            return index === _newIndex13;
          })) === null || _itemsVenueCocktail$f === void 0 ? void 0 : _itemsVenueCocktail$f.id);
        }
      }
    },
    onSwipedRight: function onSwipedRight(eventData) {
      if (category === config/* Constants.categoryType.CATEGORY_VENUE */.gT.categoryType.CATEGORY_VENUE) {
        var newIndex = (itemsVenue === null || itemsVenue === void 0 ? void 0 : itemsVenue.findIndex(function (i) {
          return i.id === mapFocused;
        })) - 1;

        if (newIndex >= 0) {
          var _itemsVenue$find2;

          setMapFocused(itemsVenue === null || itemsVenue === void 0 ? void 0 : (_itemsVenue$find2 = itemsVenue.find(function (i, index) {
            return index === newIndex;
          })) === null || _itemsVenue$find2 === void 0 ? void 0 : _itemsVenue$find2.id);
        }
      } else if (category === config/* Constants.categoryType.CATEGORY_ROOFTOP */.gT.categoryType.CATEGORY_ROOFTOP) {
        var _newIndex14 = (itemsRooftop === null || itemsRooftop === void 0 ? void 0 : itemsRooftop.findIndex(function (i) {
          return i.id === mapFocused;
        })) - 1;

        if (_newIndex14 >= 0) {
          var _itemsRooftop$find2;

          setMapFocused(itemsRooftop === null || itemsRooftop === void 0 ? void 0 : (_itemsRooftop$find2 = itemsRooftop.find(function (i, index) {
            return index === _newIndex14;
          })) === null || _itemsRooftop$find2 === void 0 ? void 0 : _itemsRooftop$find2.id);
        }
      } else if (category === config/* Constants.categoryType.CATEGORY_SPA */.gT.categoryType.CATEGORY_SPA) {
        var _newIndex15 = (itemsSpa === null || itemsSpa === void 0 ? void 0 : itemsSpa.findIndex(function (i) {
          return i.id === mapFocused;
        })) - 1;

        if (_newIndex15 >= 0) {
          var _itemsSpa$find2;

          setMapFocused(itemsSpa === null || itemsSpa === void 0 ? void 0 : (_itemsSpa$find2 = itemsSpa.find(function (i, index) {
            return index === _newIndex15;
          })) === null || _itemsSpa$find2 === void 0 ? void 0 : _itemsSpa$find2.id);
        }
      } else if (category === config/* Constants.categoryType.CATEGORY_VENUE_BEACHFUL */.gT.categoryType.CATEGORY_VENUE_BEACHFUL) {
        var _newIndex16 = (itemsVenueBeachful === null || itemsVenueBeachful === void 0 ? void 0 : itemsVenueBeachful.findIndex(function (i) {
          return i.id === mapFocused;
        })) - 1;

        if (_newIndex16 >= 0) {
          var _itemsVenueBeachful$f2;

          setMapFocused(itemsVenueBeachful === null || itemsVenueBeachful === void 0 ? void 0 : (_itemsVenueBeachful$f2 = itemsVenueBeachful.find(function (i, index) {
            return index === _newIndex16;
          })) === null || _itemsVenueBeachful$f2 === void 0 ? void 0 : _itemsVenueBeachful$f2.id);
        }
      } else if (category === config/* Constants.categoryType.CATEGORY_PREFAB_COMPANY */.gT.categoryType.CATEGORY_PREFAB_COMPANY) {
        var _newIndex17 = (itemsPrefabCompany === null || itemsPrefabCompany === void 0 ? void 0 : itemsPrefabCompany.findIndex(function (i) {
          return i.id === mapFocused;
        })) - 1;

        if (_newIndex17 >= 0) {
          var _itemsPrefabCompany$f2;

          setMapFocused(itemsPrefabCompany === null || itemsPrefabCompany === void 0 ? void 0 : (_itemsPrefabCompany$f2 = itemsPrefabCompany.find(function (i, index) {
            return index === _newIndex17;
          })) === null || _itemsPrefabCompany$f2 === void 0 ? void 0 : _itemsPrefabCompany$f2.id);
        }
      } else if (category === config/* Constants.categoryType.CATEGORY_PREFAB_HOMES */.gT.categoryType.CATEGORY_PREFAB_HOMES) {
        var _newIndex18 = (itemsPrefabHome === null || itemsPrefabHome === void 0 ? void 0 : itemsPrefabHome.findIndex(function (i) {
          return i.id === mapFocused;
        })) - 1;

        if (_newIndex18 >= 0) {
          var _itemsPrefabHome$find2;

          setMapFocused(itemsPrefabHome === null || itemsPrefabHome === void 0 ? void 0 : (_itemsPrefabHome$find2 = itemsPrefabHome.find(function (i, index) {
            return index === _newIndex18;
          })) === null || _itemsPrefabHome$find2 === void 0 ? void 0 : _itemsPrefabHome$find2.id);
        }
      } else if (category === config/* Constants.categoryType.CATEGORY_ZOO */.gT.categoryType.CATEGORY_ZOO) {
        var _newIndex19 = (itemsZoo === null || itemsZoo === void 0 ? void 0 : itemsZoo.findIndex(function (i) {
          return i.id === mapFocused;
        })) - 1;

        if (_newIndex19 >= 0) {
          var _itemsZoo$find2;

          setMapFocused(itemsZoo === null || itemsZoo === void 0 ? void 0 : (_itemsZoo$find2 = itemsZoo.find(function (i, index) {
            return index === _newIndex19;
          })) === null || _itemsZoo$find2 === void 0 ? void 0 : _itemsZoo$find2.id);
        }
      } else if (category === config/* Constants.categoryType.CATEGORY_ANIMAL */.gT.categoryType.CATEGORY_ANIMAL) {
        var _newIndex20 = (itemsAnimal === null || itemsAnimal === void 0 ? void 0 : itemsAnimal.findIndex(function (i) {
          return i.id === mapFocused;
        })) - 1;

        if (_newIndex20 >= 0) {
          var _itemsAnimal$find2;

          setMapFocused(itemsAnimal === null || itemsAnimal === void 0 ? void 0 : (_itemsAnimal$find2 = itemsAnimal.find(function (i, index) {
            return index === _newIndex20;
          })) === null || _itemsAnimal$find2 === void 0 ? void 0 : _itemsAnimal$find2.id);
        }
      } else if (category === config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL) {
        var _newIndex21 = (itemsParkful === null || itemsParkful === void 0 ? void 0 : itemsParkful.findIndex(function (i) {
          return i.id === mapFocused;
        })) - 1;

        if (_newIndex21 >= 0) {
          var _itemsParkful$find2;

          setMapFocused(itemsParkful === null || itemsParkful === void 0 ? void 0 : (_itemsParkful$find2 = itemsParkful.find(function (i, index) {
            return index === _newIndex21;
          })) === null || _itemsParkful$find2 === void 0 ? void 0 : _itemsParkful$find2.id);
        }
      } else if (category === config/* Constants.categoryType.CATEGORY_CASINO */.gT.categoryType.CATEGORY_CASINO) {
        var _newIndex22 = (itemsCasino === null || itemsCasino === void 0 ? void 0 : itemsCasino.findIndex(function (i) {
          return i.id === mapFocused;
        })) - 1;

        if (_newIndex22 >= 0) {
          var _itemsCasino$find2;

          setMapFocused(itemsCasino === null || itemsCasino === void 0 ? void 0 : (_itemsCasino$find2 = itemsCasino.find(function (i, index) {
            return index === _newIndex22;
          })) === null || _itemsCasino$find2 === void 0 ? void 0 : _itemsCasino$find2.id);
        }
      } else if (category === config/* Constants.categoryType.CATEGORY_CASTLE */.gT.categoryType.CATEGORY_CASTLE) {
        var _newIndex23 = (itemsCastle === null || itemsCastle === void 0 ? void 0 : itemsCastle.findIndex(function (i) {
          return i.id === mapFocused;
        })) - 1;

        if (_newIndex23 >= 0) {
          var _itemsCastle$find2;

          setMapFocused(itemsCastle === null || itemsCastle === void 0 ? void 0 : (_itemsCastle$find2 = itemsCastle.find(function (i, index) {
            return index === _newIndex23;
          })) === null || _itemsCastle$find2 === void 0 ? void 0 : _itemsCastle$find2.id);
        }
      } else if (category === config/* Constants.categoryType.CATEGORY_RESORT */.gT.categoryType.CATEGORY_RESORT) {
        var _newIndex24 = (itemsResort === null || itemsResort === void 0 ? void 0 : itemsResort.findIndex(function (i) {
          return i.id === mapFocused;
        })) - 1;

        if (_newIndex24 >= 0) {
          var _itemsResort$find2;

          setMapFocused(itemsResort === null || itemsResort === void 0 ? void 0 : (_itemsResort$find2 = itemsResort.find(function (i, index) {
            return index === _newIndex24;
          })) === null || _itemsResort$find2 === void 0 ? void 0 : _itemsResort$find2.id);
        }
      } else if (category === config/* Constants.categoryType.CATEGORY_APARTHOTEL */.gT.categoryType.CATEGORY_APARTHOTEL) {
        var _newIndex25 = (itemsAparthotel === null || itemsAparthotel === void 0 ? void 0 : itemsAparthotel.findIndex(function (i) {
          return i.id === mapFocused;
        })) - 1;

        if (_newIndex25 >= 0) {
          var _itemsAparthotel$find2;

          setMapFocused(itemsAparthotel === null || itemsAparthotel === void 0 ? void 0 : (_itemsAparthotel$find2 = itemsAparthotel.find(function (i, index) {
            return index === _newIndex25;
          })) === null || _itemsAparthotel$find2 === void 0 ? void 0 : _itemsAparthotel$find2.id);
        }
      } else if (category === config/* Constants.categoryType.CATEGORY_VENUE_COCKTAIL */.gT.categoryType.CATEGORY_VENUE_COCKTAIL) {
        var _newIndex26 = (itemsVenueCocktail === null || itemsVenueCocktail === void 0 ? void 0 : itemsVenueCocktail.findIndex(function (i) {
          return i.id === mapFocused;
        })) - 1;

        if (_newIndex26 >= 0) {
          var _itemsVenueCocktail$f2;

          setMapFocused(itemsVenueCocktail === null || itemsVenueCocktail === void 0 ? void 0 : (_itemsVenueCocktail$f2 = itemsVenueCocktail.find(function (i, index) {
            return index === _newIndex26;
          })) === null || _itemsVenueCocktail$f2 === void 0 ? void 0 : _itemsVenueCocktail$f2.id);
        }
      }
    }
  });
  var locationModal = (0,react.useRef)(null);
  var sortMenuModal = (0,react.useRef)(null);
  var sortMenu = [{
    id: config/* Constants.sortByAction.SORT_BY_RECOMMENDED */.gT.sortByAction.SORT_BY_RECOMMENDED,
    label: t("key_sort_option_recommended"),
    isHide: category !== "festivals" && category !== "venues" && category !== "rooftops" && category !== "spas" && category !== "beach-clubs" && category !== "companies" && category !== "homes" && category !== "parks" && category !== "casinos" && category !== "castles" && category !== "resorts" && category !== "aparthotels" && category !== "bars"
  }, {
    id: config/* Constants.sortByAction.SORT_BY_POPULARITY */.gT.sortByAction.SORT_BY_POPULARITY,
    label: t("key_sort_option_popularity"),
    isHide: category === "festivals" || category === "venues" || category === "rooftops" || category === "spas" || category === "beach-clubs" || category === "companies" || category === "homes" || category === "parks" || category === "casinos" || category === "castles" || category === "resorts" || category === "aparthotels" || category === "bars"
  }, {
    id: config/* Constants.sortByAction.SORT_BY_RECENT */.gT.sortByAction.SORT_BY_RECENT,
    label: t("key_sort_option_date"),
    isHide: category !== "festivals" && category !== "events"
  }, // {
  //   id: Constants.sortByAction.SORT_BY_TRENDING,
  //   label: t("key_sort_option_trending"),
  //   isHide: false,
  // },
  {
    id: config/* Constants.sortByAction.SORT_BY_PRICE_LOW */.gT.sortByAction.SORT_BY_PRICE_LOW,
    label: t("key_sort_option_price"),
    suffix: t("key_sort_option_low_high"),
    isHide: category !== "festivals" && category !== "events"
  }, {
    id: config/* Constants.sortByAction.SORT_BY_PRICE_HIGH */.gT.sortByAction.SORT_BY_PRICE_HIGH,
    label: t("key_sort_option_price"),
    suffix: t("key_sort_option_high_low"),
    isHide: category !== "festivals" && category !== "events"
  }, // {
  //   id: Constants.sortByAction.SORT_BY_RATING_LOW,
  //   label: t("key_sort_option_rating"),
  //   suffix: t("key_sort_option_low_high"),
  //   isHide: false,
  // },
  // {
  //   id: Constants.sortByAction.SORT_BY_RATING_HIGH,
  //   label: t("key_sort_option_rating"),
  //   suffix: t("key_sort_option_high_low"),
  //   isHide: false,
  // },
  {
    id: config/* Constants.sortByAction.SORT_BY_NAMEATOZ */.gT.sortByAction.SORT_BY_NAMEATOZ,
    label: t("key_sort_option_name"),
    suffix: t("key_sort_option_a_z"),
    isHide: false
  }, {
    id: config/* Constants.sortByAction.SORT_BY_NAMEZTOA */.gT.sortByAction.SORT_BY_NAMEZTOA,
    label: t("key_sort_option_name"),
    suffix: t("key_sort_option_z_a"),
    isHide: false
  }];

  var _useState = (0,react.useState)(false),
      showFilter = _useState[0],
      setShowFilter = _useState[1];

  var _useState2 = (0,react.useState)(search || ""),
      keyword = _useState2[0],
      setKeyword = _useState2[1];

  var _useState3 = (0,react.useState)(props.dataCategoryProps || null),
      dataCategory = _useState3[0],
      setDataCategory = _useState3[1];

  var _useState4 = (0,react.useState)(null),
      locationSelected = _useState4[0],
      setLocationSelected = _useState4[1];

  var _useState5 = (0,react.useState)(null),
      sortBy = _useState5[0],
      setSortBy = _useState5[1];

  var _useState6 = (0,react.useState)([]),
      sortList = _useState6[0],
      setSortList = _useState6[1]; // Festival


  var _useState7 = (0,react.useState)(null),
      filterCriteriaListOriginalFestival = _useState7[0],
      setFilterCriteriaListOriginalFestival = _useState7[1];

  var _useState8 = (0,react.useState)(null),
      filterCriteriaListSelectedFestival = _useState8[0],
      setFilterCriteriaListSelectedFestival = _useState8[1];

  var _useState9 = (0,react.useState)(null),
      filterTabSelectedFestival = _useState9[0],
      setFilterTabSelectedFestival = _useState9[1]; // Event


  var _useState10 = (0,react.useState)(null),
      filterCriteriaListOriginalEvent = _useState10[0],
      setFilterCriteriaListOriginalEvent = _useState10[1];

  var _useState11 = (0,react.useState)(null),
      filterCriteriaListSelectedEvent = _useState11[0],
      setFilterCriteriaListSelectedEvent = _useState11[1];

  var _useState12 = (0,react.useState)(null),
      filterTabSelectedEvent = _useState12[0],
      setFilterTabSelectedEvent = _useState12[1]; // Artist


  var _useState13 = (0,react.useState)(null),
      filterCriteriaListOriginalArtist = _useState13[0],
      setFilterCriteriaListOriginalArtist = _useState13[1];

  var _useState14 = (0,react.useState)(null),
      filterCriteriaListSelectedArtist = _useState14[0],
      setFilterCriteriaListSelectedArtist = _useState14[1];

  (0,react.useState)(null);

  var _useState15 = (0,react.useState)(null),
      filterTabSelectedArtist = _useState15[0],
      setFilterTabSelectedArtist = _useState15[1]; // Venue


  var _useState16 = (0,react.useState)(null),
      filterCriteriaListOriginalVenue = _useState16[0],
      setFilterCriteriaListOriginalVenue = _useState16[1];

  var _useState17 = (0,react.useState)(null),
      filterCriteriaListSelectedVenue = _useState17[0],
      setFilterCriteriaListSelectedVenue = _useState17[1];

  (0,react.useState)(null);

  var _useState18 = (0,react.useState)(null),
      filterTabSelectedVenue = _useState18[0],
      setFilterTabSelectedVenue = _useState18[1]; // Rooftop


  var _useState19 = (0,react.useState)(null),
      filterCriteriaListOriginalRooftop = _useState19[0],
      setFilterCriteriaListOriginalRooftop = _useState19[1];

  var _useState20 = (0,react.useState)(null),
      filterCriteriaListSelectedRooftop = _useState20[0],
      setFilterCriteriaListSelectedRooftop = _useState20[1];

  (0,react.useState)(null);

  var _useState21 = (0,react.useState)(null),
      filterTabSelectedRooftop = _useState21[0],
      setFilterTabSelectedRooftop = _useState21[1]; // Spa


  var _useState22 = (0,react.useState)(null),
      filterCriteriaListOriginalSpa = _useState22[0],
      setFilterCriteriaListOriginalSpa = _useState22[1];

  var _useState23 = (0,react.useState)(null),
      filterCriteriaListSelectedSpa = _useState23[0],
      setFilterCriteriaListSelectedSpa = _useState23[1];

  (0,react.useState)(null);

  var _useState24 = (0,react.useState)(null),
      filterTabSelectedSpa = _useState24[0],
      setFilterTabSelectedSpa = _useState24[1]; // VenueBeachful


  var _useState25 = (0,react.useState)(null),
      filterCriteriaListOriginalVenueBeachful = _useState25[0],
      setFilterCriteriaListOriginalVenueBeachful = _useState25[1];

  var _useState26 = (0,react.useState)(null),
      filterCriteriaListSelectedVenueBeachful = _useState26[0],
      setFilterCriteriaListSelectedVenueBeachful = _useState26[1];

  (0,react.useState)(null);

  var _useState27 = (0,react.useState)(null),
      filterTabSelectedVenueBeachful = _useState27[0],
      setFilterTabSelectedVenueBeachful = _useState27[1]; // PrefabCompany


  var _useState28 = (0,react.useState)(null),
      filterCriteriaListOriginalPrefabCompany = _useState28[0],
      setFilterCriteriaListOriginalPrefabCompany = _useState28[1];

  var _useState29 = (0,react.useState)(null),
      filterCriteriaListSelectedPrefabCompany = _useState29[0],
      setFilterCriteriaListSelectedPrefabCompany = _useState29[1];

  (0,react.useState)(null);

  var _useState30 = (0,react.useState)(null),
      filterTabSelectedPrefabCompany = _useState30[0],
      setFilterTabSelectedPrefabCompany = _useState30[1]; // PrefabHome


  var _useState31 = (0,react.useState)(null),
      filterCriteriaListOriginalPrefabHome = _useState31[0],
      setFilterCriteriaListOriginalPrefabHome = _useState31[1];

  var _useState32 = (0,react.useState)(null),
      filterCriteriaListSelectedPrefabHome = _useState32[0],
      setFilterCriteriaListSelectedPrefabHome = _useState32[1];

  (0,react.useState)(null);

  var _useState33 = (0,react.useState)(null),
      filterTabSelectedPrefabHome = _useState33[0],
      setFilterTabSelectedPrefabHome = _useState33[1]; // Zoo


  var _useState34 = (0,react.useState)(null),
      filterCriteriaListOriginalZoo = _useState34[0],
      setFilterCriteriaListOriginalZoo = _useState34[1];

  var _useState35 = (0,react.useState)(null),
      filterCriteriaListSelectedZoo = _useState35[0],
      setFilterCriteriaListSelectedZoo = _useState35[1];

  (0,react.useState)(null);

  var _useState36 = (0,react.useState)(null),
      filterTabSelectedZoo = _useState36[0],
      setFilterTabSelectedZoo = _useState36[1]; // Animal


  var _useState37 = (0,react.useState)(null),
      filterCriteriaListOriginalAnimal = _useState37[0],
      setFilterCriteriaListOriginalAnimal = _useState37[1];

  var _useState38 = (0,react.useState)(null),
      filterCriteriaListSelectedAnimal = _useState38[0],
      setFilterCriteriaListSelectedAnimal = _useState38[1];

  (0,react.useState)(null);

  var _useState39 = (0,react.useState)(null),
      filterTabSelectedAnimal = _useState39[0],
      setFilterTabSelectedAnimal = _useState39[1]; // Parkful


  var _useState40 = (0,react.useState)(null),
      filterCriteriaListOriginalParkful = _useState40[0],
      setFilterCriteriaListOriginalParkful = _useState40[1];

  var _useState41 = (0,react.useState)(null),
      filterCriteriaListSelectedParkful = _useState41[0],
      setFilterCriteriaListSelectedParkful = _useState41[1];

  (0,react.useState)(null);

  var _useState42 = (0,react.useState)(null),
      filterTabSelectedParkful = _useState42[0],
      setFilterTabSelectedParkful = _useState42[1]; // Casino


  var _useState43 = (0,react.useState)(null),
      filterCriteriaListOriginalCasino = _useState43[0],
      setFilterCriteriaListOriginalCasino = _useState43[1];

  var _useState44 = (0,react.useState)(null),
      filterCriteriaListSelectedCasino = _useState44[0],
      setFilterCriteriaListSelectedCasino = _useState44[1];

  (0,react.useState)(null);

  var _useState45 = (0,react.useState)(null),
      filterTabSelectedCasino = _useState45[0],
      setFilterTabSelectedCasino = _useState45[1]; // Castle


  var _useState46 = (0,react.useState)(null),
      filterCriteriaListOriginalCastle = _useState46[0],
      setFilterCriteriaListOriginalCastle = _useState46[1];

  var _useState47 = (0,react.useState)(null),
      filterCriteriaListSelectedCastle = _useState47[0],
      setFilterCriteriaListSelectedCastle = _useState47[1];

  (0,react.useState)(null);

  var _useState48 = (0,react.useState)(null),
      filterTabSelectedCastle = _useState48[0],
      setFilterTabSelectedCastle = _useState48[1]; // Resort


  var _useState49 = (0,react.useState)(null),
      filterCriteriaListOriginalResort = _useState49[0],
      setFilterCriteriaListOriginalResort = _useState49[1];

  var _useState50 = (0,react.useState)(null),
      filterCriteriaListSelectedResort = _useState50[0],
      setFilterCriteriaListSelectedResort = _useState50[1];

  (0,react.useState)(null);

  var _useState51 = (0,react.useState)(null),
      filterTabSelectedResort = _useState51[0],
      setFilterTabSelectedResort = _useState51[1]; // Aparthotel


  var _useState52 = (0,react.useState)(null),
      filterCriteriaListOriginalAparthotel = _useState52[0],
      setFilterCriteriaListOriginalAparthotel = _useState52[1];

  var _useState53 = (0,react.useState)(null),
      filterCriteriaListSelectedAparthotel = _useState53[0],
      setFilterCriteriaListSelectedAparthotel = _useState53[1];

  (0,react.useState)(null);

  var _useState54 = (0,react.useState)(null),
      filterTabSelectedAparthotel = _useState54[0],
      setFilterTabSelectedAparthotel = _useState54[1]; // Venue Cocktail


  var _useState55 = (0,react.useState)(null),
      filterCriteriaListOriginalVenueCocktail = _useState55[0],
      setFilterCriteriaListOriginalVenueCocktail = _useState55[1];

  var _useState56 = (0,react.useState)(null),
      filterCriteriaListSelectedVenueCocktail = _useState56[0],
      setFilterCriteriaListSelectedVenueCocktail = _useState56[1];

  (0,react.useState)(null);

  var _useState57 = (0,react.useState)(null),
      filterTabSelectedVenueCocktail = _useState57[0],
      setFilterTabSelectedVenueCocktail = _useState57[1];

  var _useState58 = (0,react.useState)(props.countFestivalProps || 0),
      countFestival = _useState58[0],
      setCountFestival = _useState58[1];

  var _useState59 = (0,react.useState)(0),
      countEvent = _useState59[0],
      setCountEvent = _useState59[1];

  var _useState60 = (0,react.useState)(props.countArtistProps || 0),
      countArtist = _useState60[0],
      setCountArtist = _useState60[1];

  var _useState61 = (0,react.useState)(props.countVenueProps || 0),
      countVenue = _useState61[0],
      setCountVenue = _useState61[1];

  var _useState62 = (0,react.useState)(props.countVenueProps || 0),
      countRooftop = _useState62[0],
      setCountRooftop = _useState62[1];

  var _useState63 = (0,react.useState)(props.countVenueProps || 0),
      countSpa = _useState63[0],
      setCountSpa = _useState63[1];

  var _useState64 = (0,react.useState)(props.countVenueProps || 0),
      countVenueBeachful = _useState64[0],
      setCountVenueBeachful = _useState64[1];

  var _useState65 = (0,react.useState)(props.countVenueProps || 0),
      countPrefabCompany = _useState65[0],
      setCountPrefabCompany = _useState65[1];

  var _useState66 = (0,react.useState)(props.countVenueProps || 0),
      countPrefabHome = _useState66[0],
      setCountPrefabHome = _useState66[1];

  var _useState67 = (0,react.useState)(props.countVenueProps || 0),
      countZoo = _useState67[0],
      setCountZoo = _useState67[1];

  var _useState68 = (0,react.useState)(props.countVenueProps || 0),
      countAnimal = _useState68[0],
      setCountAnimal = _useState68[1];

  var _useState69 = (0,react.useState)(props.countVenueProps || 0),
      countParkful = _useState69[0],
      setCountParkful = _useState69[1];

  var _useState70 = (0,react.useState)(props.countVenueProps || 0),
      countCasino = _useState70[0],
      setCountCasino = _useState70[1];

  var _useState71 = (0,react.useState)(props.countVenueProps || 0),
      countCastle = _useState71[0],
      setCountCastle = _useState71[1];

  var _useState72 = (0,react.useState)(props.countVenueProps || 0),
      countResort = _useState72[0],
      setCountResort = _useState72[1];

  var _useState73 = (0,react.useState)(props.countVenueProps || 0),
      countAparthotel = _useState73[0],
      setCountAparthotel = _useState73[1];

  var _useState74 = (0,react.useState)(props.countVenueProps || 0),
      countVenueCocktail = _useState74[0],
      setCountVenueCocktail = _useState74[1];

  var _useDropdownMenu = (0,use_dropdown_menu/* default */.Z)(1),
      buttonPropsTypeMode = _useDropdownMenu.buttonProps,
      itemPropsTypeMode = _useDropdownMenu.itemProps,
      isOpenTypeMode = _useDropdownMenu.isOpen,
      setIsOpenTypeMode = _useDropdownMenu.setIsOpen;

  var _useDropdownMenu2 = (0,use_dropdown_menu/* default */.Z)(1),
      buttonPropsMenuMore = _useDropdownMenu2.buttonProps,
      itemPropsMenuMore = _useDropdownMenu2.itemProps,
      isOpenMenuMore = _useDropdownMenu2.isOpen,
      setIsOpenMenuMore = _useDropdownMenu2.setIsOpen;

  var _useState75 = (0,react.useState)(null),
      typeMode = _useState75[0],
      setTypeMode = _useState75[1];

  var _useState76 = (0,react.useState)([{
    title: "All",
    count: 0,
    value: null,
    onClick: function onClick() {
      setTypeMode(null);
      setFilterTabSelectedFestival(null);
      setIsOpenTypeMode(false);
    }
  }, {
    title: "Followed",
    count: 0,
    value: 1,
    onClick: function onClick() {
      setTypeMode(1);
      setFilterTabSelectedFestival(1);
      setIsOpenTypeMode(false);
    }
  }, // {
  //   title: "Related",
  //   count: 0,
  //   value: 2,
  //   onClick: () => {
  //     setFilterTabSelectedFestival(2);
  //     setTypeMode(2);
  //     setIsOpenTypeMode(false);
  //   },
  // },
  {
    title: "Other",
    count: 0,
    value: 3,
    onClick: function onClick() {
      setTypeMode(3);
      setFilterTabSelectedFestival(3);
      setIsOpenTypeMode(false);
    }
  }]),
      typeModeList = _useState76[0],
      setTypeModeList = _useState76[1];

  var _useDropdownMenu3 = (0,use_dropdown_menu/* default */.Z)(1),
      buttonPropsViewMode = _useDropdownMenu3.buttonProps,
      itemPropsViewMode = _useDropdownMenu3.itemProps,
      isOpenViewMode = _useDropdownMenu3.isOpen,
      setIsOpenViewMode = _useDropdownMenu3.setIsOpen;

  var _useState77 = (0,react.useState)(view || config/* Constants.viewType.VIEW_TYPE_GRID */.gT.viewType.VIEW_TYPE_GRID),
      viewMode = _useState77[0],
      setViewMode = _useState77[1];

  var _useState78 = (0,react.useState)(props.venueProps || []),
      itemsVenue = _useState78[0],
      setItemsVenue = _useState78[1];

  var _useState79 = (0,react.useState)(props.venueProps || []),
      itemsRooftop = _useState79[0],
      setItemsRooftop = _useState79[1];

  var _useState80 = (0,react.useState)(props.venueProps || []),
      itemsSpa = _useState80[0],
      setItemsSpa = _useState80[1];

  var _useState81 = (0,react.useState)(props.venueProps || []),
      itemsVenueBeachful = _useState81[0],
      setItemsVenueBeachful = _useState81[1];

  var _useState82 = (0,react.useState)(props.venueProps || []),
      itemsPrefabCompany = _useState82[0],
      setItemsPrefabCompany = _useState82[1];

  var _useState83 = (0,react.useState)(props.venueProps || []),
      itemsPrefabHome = _useState83[0],
      setItemsPrefabHome = _useState83[1];

  var _useState84 = (0,react.useState)(props.venueProps || []),
      itemsZoo = _useState84[0],
      setItemsZoo = _useState84[1];

  var _useState85 = (0,react.useState)(props.venueProps || []),
      itemsAnimal = _useState85[0],
      setItemsAnimal = _useState85[1];

  var _useState86 = (0,react.useState)(props.venueProps || []),
      itemsParkful = _useState86[0],
      setItemsParkful = _useState86[1];

  var _useState87 = (0,react.useState)(props.venueProps || []),
      itemsCasino = _useState87[0],
      setItemsCasino = _useState87[1];

  var _useState88 = (0,react.useState)(props.venueProps || []),
      itemsCastle = _useState88[0],
      setItemsCastle = _useState88[1];

  var _useState89 = (0,react.useState)(props.venueProps || []),
      itemsResort = _useState89[0],
      setItemsResort = _useState89[1];

  var _useState90 = (0,react.useState)(props.venueProps || []),
      itemsAparthotel = _useState90[0],
      setItemsAparthotel = _useState90[1];

  var _useState91 = (0,react.useState)(props.venueProps || []),
      itemsVenueCocktail = _useState91[0],
      setItemsVenueCocktail = _useState91[1];

  var _useState92 = (0,react.useState)(props.festivalProps || []),
      itemsFestival = _useState92[0],
      setItemsFestival = _useState92[1];

  var _useState93 = (0,react.useState)(props.artistProps || []),
      itemsArtist = _useState93[0],
      setItemsArtist = _useState93[1];

  var _useState94 = (0,react.useState)([]),
      itemsEvent = _useState94[0],
      setItemsEvent = _useState94[1];

  var _useState95 = (0,react.useState)([]),
      viewModeList = _useState95[0],
      setViewModeList = _useState95[1];

  var _useState96 = (0,react.useState)(null),
      mapFocused = _useState96[0],
      setMapFocused = _useState96[1];

  var _useDropdownMenu4 = (0,use_dropdown_menu/* default */.Z)(1),
      buttonPropsSort = _useDropdownMenu4.buttonProps,
      itemPropsSort = _useDropdownMenu4.itemProps,
      isOpenSort = _useDropdownMenu4.isOpen,
      setIsOpenSort = _useDropdownMenu4.setIsOpen;

  var categoryMobile = [{
    count: countVenue,
    id: config/* Constants.categoryType.CATEGORY_VENUE */.gT.categoryType.CATEGORY_VENUE,
    slug: "venues",
    title: "Venues",
    isHide: !"Venue Cocktail".split(",").find(function (i) {
      return i === "Venues";
    })
  }, {
    count: countRooftop,
    id: config/* Constants.categoryType.CATEGORY_ROOFTOP */.gT.categoryType.CATEGORY_ROOFTOP,
    slug: "rooftops",
    title: "Rooftops",
    isHide: !"Venue Cocktail".split(",").find(function (i) {
      return i === "Rooftops";
    })
  }, {
    count: countSpa,
    id: config/* Constants.categoryType.CATEGORY_SPA */.gT.categoryType.CATEGORY_SPA,
    slug: "spas",
    title: "Spas",
    isHide: !"Venue Cocktail".split(",").find(function (i) {
      return i === "Spas";
    })
  }, {
    count: countVenueBeachful,
    id: config/* Constants.categoryType.CATEGORY_VENUE_BEACHFUL */.gT.categoryType.CATEGORY_VENUE_BEACHFUL,
    slug: "beach-clubs",
    title: "Beach Clubs",
    isHide: !"Venue Cocktail".split(",").find(function (i) {
      return i === "Venue Beachful";
    })
  }, {
    count: countPrefabHome,
    id: config/* Constants.categoryType.CATEGORY_PREFAB_HOMES */.gT.categoryType.CATEGORY_PREFAB_HOMES,
    slug: "homes",
    title: "Homes",
    isHide: !"Venue Cocktail".split(",").find(function (i) {
      return i === "Prefab Home";
    })
  }, {
    count: countPrefabCompany,
    id: config/* Constants.categoryType.CATEGORY_PREFAB_COMPANY */.gT.categoryType.CATEGORY_PREFAB_COMPANY,
    slug: "companies",
    title: "Companies",
    isHide: !"Venue Cocktail".split(",").find(function (i) {
      return i === "Prefab Company";
    })
  }, {
    count: countZoo,
    id: config/* Constants.categoryType.CATEGORY_ZOO */.gT.categoryType.CATEGORY_ZOO,
    slug: "zoos",
    title: "Zoos",
    isHide: !"Venue Cocktail".split(",").find(function (i) {
      return i === "Zoos";
    })
  }, {
    count: countAnimal,
    id: config/* Constants.categoryType.CATEGORY_ANIMAL */.gT.categoryType.CATEGORY_ANIMAL,
    slug: "animals",
    title: "Animals",
    isHide: !"Venue Cocktail".split(",").find(function (i) {
      return i === "Animals";
    })
  }, {
    count: countParkful,
    id: config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL,
    slug: "parks",
    title: "Parks",
    isHide: !"Venue Cocktail".split(",").find(function (i) {
      return i === "Parks";
    })
  }, {
    count: countCasino,
    id: config/* Constants.categoryType.CATEGORY_CASINO */.gT.categoryType.CATEGORY_CASINO,
    slug: "casinos",
    title: "Casinos",
    isHide: !"Venue Cocktail".split(",").find(function (i) {
      return i === "Casinos";
    })
  }, {
    count: countCastle,
    id: config/* Constants.categoryType.CATEGORY_CASTLE */.gT.categoryType.CATEGORY_CASTLE,
    slug: "castles",
    title: "Castles",
    isHide: !"Venue Cocktail".split(",").find(function (i) {
      return i === "Castles";
    })
  }, {
    count: countResort,
    id: config/* Constants.categoryType.CATEGORY_RESORT */.gT.categoryType.CATEGORY_RESORT,
    slug: "resorts",
    title: "Resorts",
    isHide: !"Venue Cocktail".split(",").find(function (i) {
      return i === "Resorts";
    })
  }, {
    count: countAparthotel,
    id: config/* Constants.categoryType.CATEGORY_APARTHOTEL */.gT.categoryType.CATEGORY_APARTHOTEL,
    slug: "aparthotels",
    title: "Aparthotels",
    isHide: !"Venue Cocktail".split(",").find(function (i) {
      return i === "Aparthotels";
    })
  }, {
    count: countVenueCocktail,
    id: config/* Constants.categoryType.CATEGORY_VENUE_COCKTAIL */.gT.categoryType.CATEGORY_VENUE_COCKTAIL,
    slug: "bars",
    title: "Bars",
    isHide: !"Venue Cocktail".split(",").find(function (i) {
      return i === "Venue Cocktail";
    })
  }, {
    count: countFestival,
    id: config/* Constants.categoryType.CATEGORY_FESTIVAL */.gT.categoryType.CATEGORY_FESTIVAL,
    slug: "festivals",
    title: "Festivals",
    isHide: !"Venue Cocktail".split(",").find(function (i) {
      return i === "Festivals";
    })
  }, {
    count: countEvent,
    id: config/* Constants.categoryType.CATEGORY_EVENT */.gT.categoryType.CATEGORY_EVENT,
    slug: "events",
    title: "Events",
    isHide: !"Venue Cocktail".split(",").find(function (i) {
      return i === "Events";
    })
  }, {
    count: countArtist,
    id: config/* Constants.categoryType.CATEGORY_ARTIST */.gT.categoryType.CATEGORY_ARTIST,
    slug: "artists",
    title: "Artists",
    isHide: !"Venue Cocktail".split(",").find(function (i) {
      return i === "Artists";
    })
  }];

  var getSortBy = function getSortBy() {
    return sortBy || (dataCategory === config/* Constants.categoryType.CATEGORY_FESTIVAL */.gT.categoryType.CATEGORY_FESTIVAL || dataCategory === config/* Constants.categoryType.CATEGORY_EVENT */.gT.categoryType.CATEGORY_EVENT ? config/* Constants.sortByAction.SORT_BY_RECENT */.gT.sortByAction.SORT_BY_RECENT : dataCategory === config/* Constants.categoryType.CATEGORY_VENUE */.gT.categoryType.CATEGORY_VENUE || dataCategory === config/* Constants.categoryType.CATEGORY_ROOFTOP */.gT.categoryType.CATEGORY_ROOFTOP || dataCategory === config/* Constants.categoryType.CATEGORY_SPA */.gT.categoryType.CATEGORY_SPA || dataCategory === config/* Constants.categoryType.CATEGORY_VENUE_BEACHFUL */.gT.categoryType.CATEGORY_VENUE_BEACHFUL || dataCategory === config/* Constants.categoryType.CATEGORY_PREFAB_COMPANY */.gT.categoryType.CATEGORY_PREFAB_COMPANY || dataCategory === config/* Constants.categoryType.CATEGORY_PREFAB_HOMES */.gT.categoryType.CATEGORY_PREFAB_HOMES || dataCategory === config/* Constants.categoryType.CATEGORY_ZOO */.gT.categoryType.CATEGORY_ZOO || dataCategory === config/* Constants.categoryType.CATEGORY_ANIMAL */.gT.categoryType.CATEGORY_ANIMAL || dataCategory === config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL || dataCategory === config/* Constants.categoryType.CATEGORY_CASINO */.gT.categoryType.CATEGORY_CASINO || dataCategory === config/* Constants.categoryType.CATEGORY_CASTLE */.gT.categoryType.CATEGORY_CASTLE || dataCategory === config/* Constants.categoryType.CATEGORY_RESORT */.gT.categoryType.CATEGORY_RESORT || dataCategory === config/* Constants.categoryType.CATEGORY_APARTHOTEL */.gT.categoryType.CATEGORY_APARTHOTEL || dataCategory === config/* Constants.categoryType.CATEGORY_VENUE_COCKTAIL */.gT.categoryType.CATEGORY_VENUE_COCKTAIL ? config/* Constants.sortByAction.SORT_BY_RECOMMENDED */.gT.sortByAction.SORT_BY_RECOMMENDED : config/* Constants.sortByAction.SORT_BY_POPULARITY */.gT.sortByAction.SORT_BY_POPULARITY);
  }; // Set Sorting and View mode


  (0,react.useEffect)(function () {
    if (category === "festivals" || category === "events") {
      setSortBy(config/* Constants.sortByAction.SORT_BY_RECENT */.gT.sortByAction.SORT_BY_RECENT);
      setSortList([{
        title: "Recommended",
        subtitle: null,
        value: config/* Constants.sortByAction.SORT_BY_RECOMMENDED */.gT.sortByAction.SORT_BY_RECOMMENDED,
        onClick: function onClick() {
          setSortBy(config/* Constants.sortByAction.SORT_BY_RECOMMENDED */.gT.sortByAction.SORT_BY_RECOMMENDED);
          setIsOpenSort(false);
        }
      }, {
        title: "Date",
        subtitle: null,
        value: config/* Constants.sortByAction.SORT_BY_RECENT */.gT.sortByAction.SORT_BY_RECENT,
        onClick: function onClick() {
          setSortBy(config/* Constants.sortByAction.SORT_BY_RECENT */.gT.sortByAction.SORT_BY_RECENT);
          setIsOpenSort(false);
        }
      }, // {
      //   title: "Trending",
      //   subtitle: null,
      //   value: Constants.sortByAction.SORT_BY_TRENDING,
      //   onClick: () => {
      //     setSortBy(Constants.sortByAction.SORT_BY_TRENDING);
      //     setIsOpenSort(false);
      //   },
      // },
      {
        title: "Price",
        subtitle: "Low-High",
        value: config/* Constants.sortByAction.SORT_BY_PRICE_LOW */.gT.sortByAction.SORT_BY_PRICE_LOW,
        onClick: function onClick() {
          setSortBy(config/* Constants.sortByAction.SORT_BY_PRICE_LOW */.gT.sortByAction.SORT_BY_PRICE_LOW);
          setIsOpenSort(false);
        }
      }, {
        title: "Price",
        subtitle: "High-Low",
        value: config/* Constants.sortByAction.SORT_BY_PRICE_HIGH */.gT.sortByAction.SORT_BY_PRICE_HIGH,
        onClick: function onClick() {
          setSortBy(config/* Constants.sortByAction.SORT_BY_PRICE_HIGH */.gT.sortByAction.SORT_BY_PRICE_HIGH);
          setIsOpenSort(false);
        }
      }, // {
      //   title: "Rating",
      //   subtitle: "Low-High",
      //   value: Constants.sortByAction.SORT_BY_RATING_LOW,
      //   onClick: () => {
      //     setSortBy(Constants.sortByAction.SORT_BY_RATING_LOW);
      //     setIsOpenSort(false);
      //   },
      // },
      // {
      //   title: "Rating",
      //   subtitle: "High-Low",
      //   value: Constants.sortByAction.SORT_BY_RATING_HIGH,
      //   onClick: () => {
      //     setSortBy(Constants.sortByAction.SORT_BY_RATING_HIGH);
      //     setIsOpenSort(false);
      //   },
      // },
      {
        title: "Name",
        subtitle: "A-Z",
        value: config/* Constants.sortByAction.SORT_BY_NAMEATOZ */.gT.sortByAction.SORT_BY_NAMEATOZ,
        onClick: function onClick() {
          setSortBy(config/* Constants.sortByAction.SORT_BY_NAMEATOZ */.gT.sortByAction.SORT_BY_NAMEATOZ);
          setIsOpenSort(false);
        }
      }, {
        title: "Name",
        subtitle: "Z-A",
        value: config/* Constants.sortByAction.SORT_BY_NAMEZTOA */.gT.sortByAction.SORT_BY_NAMEZTOA,
        onClick: function onClick() {
          setSortBy(config/* Constants.sortByAction.SORT_BY_NAMEZTOA */.gT.sortByAction.SORT_BY_NAMEZTOA);
          setIsOpenSort(false);
        }
      }]);
      setViewModeList([{
        title: "Grid",
        value: config/* Constants.viewType.VIEW_TYPE_GRID */.gT.viewType.VIEW_TYPE_GRID,
        onClick: function onClick() {
          setViewMode(config/* Constants.viewType.VIEW_TYPE_GRID */.gT.viewType.VIEW_TYPE_GRID);
          setIsOpenViewMode(false);
          router.push({
            query: _category_objectSpread(_category_objectSpread({}, router.query), {}, {
              page: 1,
              view: "grid"
            })
          });
        }
      }, {
        title: "List",
        value: config/* Constants.viewType.VIEW_TYPE_LIST */.gT.viewType.VIEW_TYPE_LIST,
        onClick: function onClick() {
          setViewMode(config/* Constants.viewType.VIEW_TYPE_LIST */.gT.viewType.VIEW_TYPE_LIST);
          setIsOpenViewMode(false);
          router.push({
            query: _category_objectSpread(_category_objectSpread({}, router.query), {}, {
              page: 1,
              view: "list"
            })
          });
        }
      }, // {
      //   title: "Overview",
      //   value: Constants.viewType.VIEW_TYPE_OVERVIEW,
      //   onClick: () => {
      //     setViewMode(Constants.viewType.VIEW_TYPE_OVERVIEW);
      //     setIsOpenViewMode(false);
      //     router.push({
      //       query: { ...router.query, page: 1, view: "overview" },
      //     });
      //   },
      // },
      {
        title: "Map",
        value: config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP,
        onClick: function onClick() {
          setViewMode(config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP);
          setIsOpenViewMode(false);
          router.push({
            query: _category_objectSpread(_category_objectSpread({}, router.query), {}, {
              page: 1,
              view: "map"
            })
          });
        }
      }]);
      setViewMode(config/* Constants.viewType.VIEW_TYPE_GRID */.gT.viewType.VIEW_TYPE_GRID);
    } else if (category === "artists") {
      setSortBy(config/* Constants.sortByAction.SORT_BY_POPULARITY */.gT.sortByAction.SORT_BY_POPULARITY);
      setSortList([{
        title: "Popularity",
        subtitle: null,
        value: config/* Constants.sortByAction.SORT_BY_POPULARITY */.gT.sortByAction.SORT_BY_POPULARITY,
        onClick: function onClick() {
          setSortBy(config/* Constants.sortByAction.SORT_BY_POPULARITY */.gT.sortByAction.SORT_BY_POPULARITY);
          setIsOpenSort(false);
        }
      },
      /*{
          title: "Trending",
          subtitle: null,
          value: Constants.sortByAction.SORT_BY_TRENDING,
          onClick: () => {
            setSortBy(Constants.sortByAction.SORT_BY_TRENDING);
            setIsOpenSort(false);
          },
        },*/
      // {
      //   title: "Rating",
      //   subtitle: "Low-High",
      //   value: Constants.sortByAction.SORT_BY_RATING_LOW,
      //   onClick: () => {
      //     setSortBy(Constants.sortByAction.SORT_BY_RATING_LOW);
      //     setIsOpenSort(false);
      //   },
      // },
      // {
      //   title: "Rating",
      //   subtitle: "High-Low",
      //   value: Constants.sortByAction.SORT_BY_RATING_HIGH,
      //   onClick: () => {
      //     setSortBy(Constants.sortByAction.SORT_BY_RATING_HIGH);
      //     setIsOpenSort(false);
      //   },
      // },
      {
        title: "Name",
        subtitle: "A-Z",
        value: config/* Constants.sortByAction.SORT_BY_NAMEATOZ */.gT.sortByAction.SORT_BY_NAMEATOZ,
        onClick: function onClick() {
          setSortBy(config/* Constants.sortByAction.SORT_BY_NAMEATOZ */.gT.sortByAction.SORT_BY_NAMEATOZ);
          setIsOpenSort(false);
        }
      }, {
        title: "Name",
        subtitle: "Z-A",
        value: config/* Constants.sortByAction.SORT_BY_NAMEZTOA */.gT.sortByAction.SORT_BY_NAMEZTOA,
        onClick: function onClick() {
          setSortBy(config/* Constants.sortByAction.SORT_BY_NAMEZTOA */.gT.sortByAction.SORT_BY_NAMEZTOA);
          setIsOpenSort(false);
        }
      }]);
      setViewModeList([{
        title: "Grid",
        value: config/* Constants.viewType.VIEW_TYPE_GRID */.gT.viewType.VIEW_TYPE_GRID,
        onClick: function onClick() {
          setViewMode(config/* Constants.viewType.VIEW_TYPE_GRID */.gT.viewType.VIEW_TYPE_GRID);
          setIsOpenViewMode(false);
          router.push({
            query: _category_objectSpread(_category_objectSpread({}, router.query), {}, {
              page: 1,
              view: "grid"
            })
          });
        }
      }, {
        title: "List",
        value: config/* Constants.viewType.VIEW_TYPE_LIST */.gT.viewType.VIEW_TYPE_LIST,
        onClick: function onClick() {
          setViewMode(config/* Constants.viewType.VIEW_TYPE_LIST */.gT.viewType.VIEW_TYPE_LIST);
          setIsOpenViewMode(false);
          router.push({
            query: _category_objectSpread(_category_objectSpread({}, router.query), {}, {
              page: 1,
              view: "list"
            })
          });
        }
      } // {
      //   title: "Overview",
      //   value: Constants.viewType.VIEW_TYPE_OVERVIEW,
      //   onClick: () => {
      //     setViewMode(Constants.viewType.VIEW_TYPE_OVERVIEW);
      //     setIsOpenViewMode(false);
      //     router.push({
      //       query: { ...router.query, page: 1, view: "overview" },
      //     });
      //   },
      // },
      ]);
      setViewMode(config/* Constants.viewType.VIEW_TYPE_GRID */.gT.viewType.VIEW_TYPE_GRID);
    } else if (category === "venues") {
      setSortBy(config/* Constants.sortByAction.SORT_BY_RECOMMENDED */.gT.sortByAction.SORT_BY_RECOMMENDED);
      setSortList([{
        title: "Recommended",
        subtitle: null,
        value: config/* Constants.sortByAction.SORT_BY_RECOMMENDED */.gT.sortByAction.SORT_BY_RECOMMENDED,
        onClick: function onClick() {
          setSortBy(config/* Constants.sortByAction.SORT_BY_RECOMMENDED */.gT.sortByAction.SORT_BY_RECOMMENDED);
          setIsOpenSort(false);
        }
      }, // {
      //   title: "Popularity",
      //   subtitle: null,
      //   value: Constants.sortByAction.SORT_BY_POPULARITY,
      //   onClick: () => {
      //     setSortBy(Constants.sortByAction.SORT_BY_POPULARITY);
      //     setIsOpenSort(false);
      //   },
      // },

      /*{
        title: "Trending",
        subtitle: null,
        value: Constants.sortByAction.SORT_BY_TRENDING,
        onClick: () => {
          setSortBy(Constants.sortByAction.SORT_BY_TRENDING);
          setIsOpenSort(false);
        },
      },*/
      // {
      //   title: "Rating",
      //   subtitle: "Low-High",
      //   value: Constants.sortByAction.SORT_BY_RATING_LOW,
      //   onClick: () => {
      //     setSortBy(Constants.sortByAction.SORT_BY_RATING_LOW);
      //     setIsOpenSort(false);
      //   },
      // },
      // {
      //   title: "Rating",
      //   subtitle: "High-Low",
      //   value: Constants.sortByAction.SORT_BY_RATING_HIGH,
      //   onClick: () => {
      //     setSortBy(Constants.sortByAction.SORT_BY_RATING_HIGH);
      //     setIsOpenSort(false);
      //   },
      // },
      {
        title: "Name",
        subtitle: "A-Z",
        value: config/* Constants.sortByAction.SORT_BY_NAMEATOZ */.gT.sortByAction.SORT_BY_NAMEATOZ,
        onClick: function onClick() {
          setSortBy(config/* Constants.sortByAction.SORT_BY_NAMEATOZ */.gT.sortByAction.SORT_BY_NAMEATOZ);
          setIsOpenSort(false);
        }
      }, {
        title: "Name",
        subtitle: "Z-A",
        value: config/* Constants.sortByAction.SORT_BY_NAMEZTOA */.gT.sortByAction.SORT_BY_NAMEZTOA,
        onClick: function onClick() {
          setSortBy(config/* Constants.sortByAction.SORT_BY_NAMEZTOA */.gT.sortByAction.SORT_BY_NAMEZTOA);
          setIsOpenSort(false);
        }
      }]);
      setViewModeList([{
        title: "Grid",
        value: config/* Constants.viewType.VIEW_TYPE_GRID */.gT.viewType.VIEW_TYPE_GRID,
        onClick: function onClick() {
          setViewMode(config/* Constants.viewType.VIEW_TYPE_GRID */.gT.viewType.VIEW_TYPE_GRID);
          setIsOpenViewMode(false);
          router.push({
            query: _category_objectSpread(_category_objectSpread({}, router.query), {}, {
              page: 1,
              view: "grid"
            })
          });
        }
      }, {
        title: "List",
        value: config/* Constants.viewType.VIEW_TYPE_LIST */.gT.viewType.VIEW_TYPE_LIST,
        onClick: function onClick() {
          setViewMode(config/* Constants.viewType.VIEW_TYPE_LIST */.gT.viewType.VIEW_TYPE_LIST);
          setIsOpenViewMode(false);
          router.push({
            query: _category_objectSpread(_category_objectSpread({}, router.query), {}, {
              page: 1,
              view: "list"
            })
          });
        }
      }, // {
      //   title: "Overview",
      //   value: Constants.viewType.VIEW_TYPE_OVERVIEW,
      //   onClick: () => {
      //     setViewMode(Constants.viewType.VIEW_TYPE_OVERVIEW);
      //     setIsOpenViewMode(false);
      //     router.push({
      //       query: { ...router.query, page: 1, view: "overview" },
      //     });
      //   },
      // },
      {
        title: "Map",
        value: config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP,
        onClick: function onClick() {
          setViewMode(config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP);
          setIsOpenViewMode(false);
          router.push({
            query: _category_objectSpread(_category_objectSpread({}, router.query), {}, {
              page: 1,
              view: "map"
            })
          });
        }
      }]);
      setViewMode(config/* Constants.viewType.VIEW_TYPE_GRID */.gT.viewType.VIEW_TYPE_GRID);
    } else if (category === "homes" || category === "animals") {
      setSortBy(config/* Constants.sortByAction.SORT_BY_RECOMMENDED */.gT.sortByAction.SORT_BY_RECOMMENDED);
      setSortList([{
        title: "Recommended",
        subtitle: null,
        value: config/* Constants.sortByAction.SORT_BY_RECOMMENDED */.gT.sortByAction.SORT_BY_RECOMMENDED,
        onClick: function onClick() {
          setSortBy(config/* Constants.sortByAction.SORT_BY_RECOMMENDED */.gT.sortByAction.SORT_BY_RECOMMENDED);
          setIsOpenSort(false);
        }
      }, // {
      //   title: "Popularity",
      //   subtitle: null,
      //   value: Constants.sortByAction.SORT_BY_POPULARITY,
      //   onClick: () => {
      //     setSortBy(Constants.sortByAction.SORT_BY_POPULARITY);
      //     setIsOpenSort(false);
      //   },
      // },

      /*{
          title: "Trending",
          subtitle: null,
          value: Constants.sortByAction.SORT_BY_TRENDING,
          onClick: () => {
            setSortBy(Constants.sortByAction.SORT_BY_TRENDING);
            setIsOpenSort(false);
          },
        },*/
      // {
      //   title: "Rating",
      //   subtitle: "Low-High",
      //   value: Constants.sortByAction.SORT_BY_RATING_LOW,
      //   onClick: () => {
      //     setSortBy(Constants.sortByAction.SORT_BY_RATING_LOW);
      //     setIsOpenSort(false);
      //   },
      // },
      // {
      //   title: "Rating",
      //   subtitle: "High-Low",
      //   value: Constants.sortByAction.SORT_BY_RATING_HIGH,
      //   onClick: () => {
      //     setSortBy(Constants.sortByAction.SORT_BY_RATING_HIGH);
      //     setIsOpenSort(false);
      //   },
      // },
      {
        title: "Name",
        subtitle: "A-Z",
        value: config/* Constants.sortByAction.SORT_BY_NAMEATOZ */.gT.sortByAction.SORT_BY_NAMEATOZ,
        onClick: function onClick() {
          setSortBy(config/* Constants.sortByAction.SORT_BY_NAMEATOZ */.gT.sortByAction.SORT_BY_NAMEATOZ);
          setIsOpenSort(false);
        }
      }, {
        title: "Name",
        subtitle: "Z-A",
        value: config/* Constants.sortByAction.SORT_BY_NAMEZTOA */.gT.sortByAction.SORT_BY_NAMEZTOA,
        onClick: function onClick() {
          setSortBy(config/* Constants.sortByAction.SORT_BY_NAMEZTOA */.gT.sortByAction.SORT_BY_NAMEZTOA);
          setIsOpenSort(false);
        }
      }]);
      setViewModeList([{
        title: "Grid",
        value: config/* Constants.viewType.VIEW_TYPE_GRID */.gT.viewType.VIEW_TYPE_GRID,
        onClick: function onClick() {
          setViewMode(config/* Constants.viewType.VIEW_TYPE_GRID */.gT.viewType.VIEW_TYPE_GRID);
          setIsOpenViewMode(false);
          router.push({
            query: _category_objectSpread(_category_objectSpread({}, router.query), {}, {
              page: 1,
              view: "grid"
            })
          });
        }
      }, {
        title: "List",
        value: config/* Constants.viewType.VIEW_TYPE_LIST */.gT.viewType.VIEW_TYPE_LIST,
        onClick: function onClick() {
          setViewMode(config/* Constants.viewType.VIEW_TYPE_LIST */.gT.viewType.VIEW_TYPE_LIST);
          setIsOpenViewMode(false);
          router.push({
            query: _category_objectSpread(_category_objectSpread({}, router.query), {}, {
              page: 1,
              view: "list"
            })
          });
        }
      }]);
      setViewMode(config/* Constants.viewType.VIEW_TYPE_GRID */.gT.viewType.VIEW_TYPE_GRID);
    } else if (category === "rooftops" || category === "spas" || category === "beach-clubs" || category === "companies" || category === "zoos" || category === "parks" || category === "casinos" || category === "castles" || category === "resorts" || category === "aparthotels" || category === "bars") {
      setSortBy(config/* Constants.sortByAction.SORT_BY_RECOMMENDED */.gT.sortByAction.SORT_BY_RECOMMENDED);
      setSortList([{
        title: "Recommended",
        subtitle: null,
        value: config/* Constants.sortByAction.SORT_BY_RECOMMENDED */.gT.sortByAction.SORT_BY_RECOMMENDED,
        onClick: function onClick() {
          setSortBy(config/* Constants.sortByAction.SORT_BY_RECOMMENDED */.gT.sortByAction.SORT_BY_RECOMMENDED);
          setIsOpenSort(false);
        }
      }, // {
      //   title: "Popularity",
      //   subtitle: null,
      //   value: Constants.sortByAction.SORT_BY_POPULARITY,
      //   onClick: () => {
      //     setSortBy(Constants.sortByAction.SORT_BY_POPULARITY);
      //     setIsOpenSort(false);
      //   },
      // },

      /*{
        title: "Trending",
        subtitle: null,
        value: Constants.sortByAction.SORT_BY_TRENDING,
        onClick: () => {
          setSortBy(Constants.sortByAction.SORT_BY_TRENDING);
          setIsOpenSort(false);
        },
      },*/
      // {
      //   title: "Rating",
      //   subtitle: "Low-High",
      //   value: Constants.sortByAction.SORT_BY_RATING_LOW,
      //   onClick: () => {
      //     setSortBy(Constants.sortByAction.SORT_BY_RATING_LOW);
      //     setIsOpenSort(false);
      //   },
      // },
      // {
      //   title: "Rating",
      //   subtitle: "High-Low",
      //   value: Constants.sortByAction.SORT_BY_RATING_HIGH,
      //   onClick: () => {
      //     setSortBy(Constants.sortByAction.SORT_BY_RATING_HIGH);
      //     setIsOpenSort(false);
      //   },
      // },
      {
        title: "Name",
        subtitle: "A-Z",
        value: config/* Constants.sortByAction.SORT_BY_NAMEATOZ */.gT.sortByAction.SORT_BY_NAMEATOZ,
        onClick: function onClick() {
          setSortBy(config/* Constants.sortByAction.SORT_BY_NAMEATOZ */.gT.sortByAction.SORT_BY_NAMEATOZ);
          setIsOpenSort(false);
        }
      }, {
        title: "Name",
        subtitle: "Z-A",
        value: config/* Constants.sortByAction.SORT_BY_NAMEZTOA */.gT.sortByAction.SORT_BY_NAMEZTOA,
        onClick: function onClick() {
          setSortBy(config/* Constants.sortByAction.SORT_BY_NAMEZTOA */.gT.sortByAction.SORT_BY_NAMEZTOA);
          setIsOpenSort(false);
        }
      }]);
      setViewModeList([{
        title: "Grid",
        value: config/* Constants.viewType.VIEW_TYPE_GRID */.gT.viewType.VIEW_TYPE_GRID,
        onClick: function onClick() {
          setViewMode(config/* Constants.viewType.VIEW_TYPE_GRID */.gT.viewType.VIEW_TYPE_GRID);
          setIsOpenViewMode(false);
          router.push({
            query: _category_objectSpread(_category_objectSpread({}, router.query), {}, {
              page: 1,
              view: "grid"
            })
          });
        }
      }, {
        title: "List",
        value: config/* Constants.viewType.VIEW_TYPE_LIST */.gT.viewType.VIEW_TYPE_LIST,
        onClick: function onClick() {
          setViewMode(config/* Constants.viewType.VIEW_TYPE_LIST */.gT.viewType.VIEW_TYPE_LIST);
          setIsOpenViewMode(false);
          router.push({
            query: _category_objectSpread(_category_objectSpread({}, router.query), {}, {
              page: 1,
              view: "list"
            })
          });
        }
      }, // {
      //   title: "Overview",
      //   value: Constants.viewType.VIEW_TYPE_OVERVIEW,
      //   onClick: () => {
      //     setViewMode(Constants.viewType.VIEW_TYPE_OVERVIEW);
      //     setIsOpenViewMode(false);
      //     router.push({
      //       query: { ...router.query, page: 1, view: "overview" },
      //     });
      //   },
      // },
      {
        title: "Map",
        value: config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP,
        onClick: function onClick() {
          setViewMode(config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP);
          setIsOpenViewMode(false);
          router.push({
            query: _category_objectSpread(_category_objectSpread({}, router.query), {}, {
              page: 1,
              view: "map"
            })
          });
        }
      }]);
      setViewMode(config/* Constants.viewType.VIEW_TYPE_GRID */.gT.viewType.VIEW_TYPE_GRID);
    }
  }, [category]); // Keyword search

  (0,react.useEffect)(function () {
    if (search) {
      setKeyword(search);
    }
  }, [search]); // View Mode

  (0,react.useEffect)(function () {
    // Get the button
    var mybutton = document.getElementById("btn-back-to-top"); // When the user scrolls down 20px from the top of the document, show the button

    window.onscroll = function () {
      scrollFunction();
    };

    function scrollFunction() {
      if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        var _mybutton$classList, _mybutton$classList2;

        mybutton === null || mybutton === void 0 ? void 0 : (_mybutton$classList = mybutton.classList) === null || _mybutton$classList === void 0 ? void 0 : _mybutton$classList.add("flex");
        mybutton === null || mybutton === void 0 ? void 0 : (_mybutton$classList2 = mybutton.classList) === null || _mybutton$classList2 === void 0 ? void 0 : _mybutton$classList2.remove("hidden");
      } else {
        var _mybutton$classList3, _mybutton$classList4;

        mybutton === null || mybutton === void 0 ? void 0 : (_mybutton$classList3 = mybutton.classList) === null || _mybutton$classList3 === void 0 ? void 0 : _mybutton$classList3.remove("flex");
        mybutton === null || mybutton === void 0 ? void 0 : (_mybutton$classList4 = mybutton.classList) === null || _mybutton$classList4 === void 0 ? void 0 : _mybutton$classList4.add("hidden");
      }
    }
  }, [viewMode]);
  (0,react.useEffect)(function () {
    if (view) {
      setViewMode(view);
    }
  }, [view]);

  var metaCategoryName = function metaCategoryName(category) {
    var results = category === null || category === void 0 ? void 0 : category.toLowerCase();

    if (results === "bars") {
      results = "cocktail bars";
    } else if (results === "beach-clubs") {
      results = "beach clubs";
    } else if (results === "companies") {
      results = "prefab companies";
    } else if (results === "homes") {
      results = "prefab homes";
    } else if (results === "zoos") {
      results = "zoos & animal parks";
    } else if (results === "parks") {
      results = "amusement parks";
    } else if (results === "resorts") {
      results = "luxury resorts";
    }

    return results;
  };

  var metaTitle = "Discover ".concat(metaCategoryName(category), " - ").concat("Cocktayl");
  var metaDescription = category === "artists" ? "Discover artists on ".concat("Cocktayl", " - events, tickets and much more.") : category === "festivals" ? "Discover festivals on ".concat("Cocktayl", " - dates, venue, tickets, lineup and much more.") : category === "events" ? "Discover events on ".concat("Cocktayl", " - dates, venue, tickets, lineup and much more.") : "Discover ".concat(metaCategoryName(category), " on ").concat("Cocktayl", " - ").concat( false ? 0 : category === "companies" ? "homes, features" : category === "homes" ? "price, features" : category === "animals" ? "habitat, features" : "location, features", " and much more.");

  var buildCanonicalUrl = function buildCanonicalUrl() {
    var _router$query2, _router$query3;

    var baseUrl = "https://".concat("www.cocktayl.co", "/explore/").concat(category);
    return router !== null && router !== void 0 && (_router$query2 = router.query) !== null && _router$query2 !== void 0 && _router$query2.page ? "".concat(baseUrl, "?page=").concat(router === null || router === void 0 ? void 0 : (_router$query3 = router.query) === null || _router$query3 === void 0 ? void 0 : _router$query3.page) : baseUrl;
  };

  var buildPaginationLinks = function buildPaginationLinks() {
    var _router$query4;

    var links = [];
    var currentPage = parseInt((router === null || router === void 0 ? void 0 : (_router$query4 = router.query) === null || _router$query4 === void 0 ? void 0 : _router$query4.page) || 1);

    if (currentPage > 1) {
      links.push({
        rel: "prev",
        href: "https://".concat("www.cocktayl.co", "/explore/").concat(category).concat(currentPage > 2 ? "?page=".concat(currentPage - 1) : "")
      });
    }

    var totalPages = Math.ceil(countArtist / 36) || 1;

    if (currentPage < totalPages) {
      links.push({
        rel: "next",
        href: "https://".concat("www.cocktayl.co", "/explore/").concat(category, "?page=").concat(currentPage + 1)
      });
    }

    return links;
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "".concat((0,formatHelpers/* getClass */.ll)("background", true), " relative"),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
      noindex: false,
      nofollow: false,
      title: metaTitle,
      description: metaDescription,
      canonical: buildCanonicalUrl(),
      additionalLinkTags: buildPaginationLinks(),
      openGraph: {
        type: "website",
        locale: "en_EN",
        url: buildCanonicalUrl(),
        title: metaTitle,
        description: metaDescription,
        images: [{
          url: "https://".concat("www.cocktayl.co").concat("/images/og-cocktayl.png"),
          width: 1200,
          height: 630,
          alt: "".concat("Cocktayl").concat(" - The Cocktail Bar You Need"),
          type: "image/png"
        }],
        siteName: "".concat("Cocktayl").concat(" - The Cocktail Bar You Need")
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "sm:block hidden",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(HeaderSearch/* default */.Z, {
        defaultValue: keyword,
        onPress: function onPress(result) {
          var _process$env$NEXT_PUB;

          setKeyword(result);
          router.push("/explore/".concat((_process$env$NEXT_PUB = "Venue Cocktail".split(",")[0]) === null || _process$env$NEXT_PUB === void 0 ? void 0 : _process$env$NEXT_PUB.toLowerCase(), "?search=").concat(result));
        }
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
      className: "hidden",
      children: metaTitle
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "mx-auto min-h-screen",
      children: config/* Values.deviceWidth */.$m.deviceWidth < 640 ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "sm:hidden block wrapper-mobile mx-auto min-h-screen",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_NavigationSearchView, {
          keyword: keyword,
          setKeyword: setKeyword,
          isMobileVersion: true,
          buttonPropsMenuMore: buttonPropsMenuMore
        }), "Venue Cocktail".split(",").find(function (i) {
          return i === "Festivals" || i === "Artists";
        }) ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "".concat(isOpenMenuMore ? "visible" : "", " flex flex-col ").concat((0,formatHelpers/* getClass */.ll)("background", true), " absolute top-[45px] right-4 rounded-2xl z-[999] w-190px border ").concat((0,formatHelpers/* getClass */.ll)("border-spliterLine", true), " overflow-hidden"),
          role: "menu",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "/guides",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              className: "px-4 py-3 text-xs font-regular ".concat((0,formatHelpers/* getClass */.ll)("text-white", true), " cursor-pointer transition-all ").concat((0,formatHelpers/* getClass */.ll)("hover:bg-grayBackground")),
              children: "Guides"
            })
          })
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "".concat(isOpenMenuMore ? "visible" : "", " flex flex-col ").concat((0,formatHelpers/* getClass */.ll)("background", true), " absolute top-[45px] right-4 rounded-2xl z-[999] w-190px border ").concat((0,formatHelpers/* getClass */.ll)("border-spliterLine", true), " overflow-hidden"),
          role: "menu",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "/guides",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              className: "px-4 py-3 text-xs font-regular ".concat((0,formatHelpers/* getClass */.ll)("text-white", true), " cursor-pointer transition-all ").concat((0,formatHelpers/* getClass */.ll)("hover:bg-grayBackground")),
              children: "Guides"
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(FilterView/* default */.Z, {
          dataCategory: dataCategory,
          isFiltered: dataCategory === config/* Constants.categoryType.CATEGORY_FESTIVAL */.gT.categoryType.CATEGORY_FESTIVAL ? filterCriteriaListSelectedFestival !== null && (filterCriteriaListSelectedFestival === null || filterCriteriaListSelectedFestival === void 0 ? void 0 : filterCriteriaListSelectedFestival.length) > 0 : dataCategory === config/* Constants.categoryType.CATEGORY_EVENT */.gT.categoryType.CATEGORY_EVENT ? filterCriteriaListSelectedEvent !== null && (filterCriteriaListSelectedEvent === null || filterCriteriaListSelectedEvent === void 0 ? void 0 : filterCriteriaListSelectedEvent.length) > 0 : dataCategory === config/* Constants.categoryType.CATEGORY_ARTIST */.gT.categoryType.CATEGORY_ARTIST ? filterCriteriaListSelectedArtist !== null && (filterCriteriaListSelectedArtist === null || filterCriteriaListSelectedArtist === void 0 ? void 0 : filterCriteriaListSelectedArtist.length) > 0 : dataCategory === config/* Constants.categoryType.CATEGORY_VENUE */.gT.categoryType.CATEGORY_VENUE ? filterCriteriaListSelectedVenue !== null && (filterCriteriaListSelectedVenue === null || filterCriteriaListSelectedVenue === void 0 ? void 0 : filterCriteriaListSelectedVenue.length) > 0 : dataCategory === config/* Constants.categoryType.CATEGORY_ROOFTOP */.gT.categoryType.CATEGORY_ROOFTOP ? filterCriteriaListSelectedRooftop !== null && (filterCriteriaListSelectedRooftop === null || filterCriteriaListSelectedRooftop === void 0 ? void 0 : filterCriteriaListSelectedRooftop.length) > 0 : dataCategory === config/* Constants.categoryType.CATEGORY_SPA */.gT.categoryType.CATEGORY_SPA ? filterCriteriaListSelectedSpa !== null && (filterCriteriaListSelectedSpa === null || filterCriteriaListSelectedSpa === void 0 ? void 0 : filterCriteriaListSelectedSpa.length) > 0 : dataCategory === config/* Constants.categoryType.CATEGORY_VENUE_BEACHFUL */.gT.categoryType.CATEGORY_VENUE_BEACHFUL ? filterCriteriaListSelectedVenueBeachful !== null && (filterCriteriaListSelectedVenueBeachful === null || filterCriteriaListSelectedVenueBeachful === void 0 ? void 0 : filterCriteriaListSelectedVenueBeachful.length) > 0 : dataCategory === config/* Constants.categoryType.CATEGORY_PREFAB_COMPANY */.gT.categoryType.CATEGORY_PREFAB_COMPANY ? filterCriteriaListSelectedPrefabCompany !== null && (filterCriteriaListSelectedPrefabCompany === null || filterCriteriaListSelectedPrefabCompany === void 0 ? void 0 : filterCriteriaListSelectedPrefabCompany.length) > 0 : dataCategory === config/* Constants.categoryType.CATEGORY_PREFAB_HOMES */.gT.categoryType.CATEGORY_PREFAB_HOMES ? filterCriteriaListSelectedPrefabHome !== null && (filterCriteriaListSelectedPrefabHome === null || filterCriteriaListSelectedPrefabHome === void 0 ? void 0 : filterCriteriaListSelectedPrefabHome.length) > 0 : dataCategory === config/* Constants.categoryType.CATEGORY_ZOO */.gT.categoryType.CATEGORY_ZOO ? filterCriteriaListSelectedZoo !== null && (filterCriteriaListSelectedZoo === null || filterCriteriaListSelectedZoo === void 0 ? void 0 : filterCriteriaListSelectedZoo.length) > 0 : dataCategory === config/* Constants.categoryType.CATEGORY_ANIMAL */.gT.categoryType.CATEGORY_ANIMAL ? filterCriteriaListSelectedAnimal !== null && (filterCriteriaListSelectedAnimal === null || filterCriteriaListSelectedAnimal === void 0 ? void 0 : filterCriteriaListSelectedAnimal.length) > 0 : dataCategory === config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL ? filterCriteriaListSelectedParkful !== null && (filterCriteriaListSelectedParkful === null || filterCriteriaListSelectedParkful === void 0 ? void 0 : filterCriteriaListSelectedParkful.length) > 0 : dataCategory === config/* Constants.categoryType.CATEGORY_CASINO */.gT.categoryType.CATEGORY_CASINO ? filterCriteriaListSelectedCasino !== null && (filterCriteriaListSelectedCasino === null || filterCriteriaListSelectedCasino === void 0 ? void 0 : filterCriteriaListSelectedCasino.length) > 0 : dataCategory === config/* Constants.categoryType.CATEGORY_CASTLE */.gT.categoryType.CATEGORY_CASTLE ? filterCriteriaListSelectedCastle !== null && (filterCriteriaListSelectedCastle === null || filterCriteriaListSelectedCastle === void 0 ? void 0 : filterCriteriaListSelectedCastle.length) > 0 : dataCategory === config/* Constants.categoryType.CATEGORY_RESORT */.gT.categoryType.CATEGORY_RESORT ? filterCriteriaListSelectedResort !== null && (filterCriteriaListSelectedResort === null || filterCriteriaListSelectedResort === void 0 ? void 0 : filterCriteriaListSelectedResort.length) > 0 : dataCategory === config/* Constants.categoryType.CATEGORY_APARTHOTEL */.gT.categoryType.CATEGORY_APARTHOTEL ? filterCriteriaListSelectedAparthotel !== null && (filterCriteriaListSelectedAparthotel === null || filterCriteriaListSelectedAparthotel === void 0 ? void 0 : filterCriteriaListSelectedAparthotel.length) > 0 : dataCategory === config/* Constants.categoryType.CATEGORY_VENUE_COCKTAIL */.gT.categoryType.CATEGORY_VENUE_COCKTAIL ? filterCriteriaListSelectedVenueCocktail !== null && (filterCriteriaListSelectedVenueCocktail === null || filterCriteriaListSelectedVenueCocktail === void 0 ? void 0 : filterCriteriaListSelectedVenueCocktail.length) > 0 : filterCriteriaListSelectedOther !== null && ((_filterCriteriaListSe = filterCriteriaListSelectedOther) === null || _filterCriteriaListSe === void 0 ? void 0 : _filterCriteriaListSe.length) > 0,
          onPressLocation: function onPressLocation() {
            if (locationModal) {
              locationModal.current.showModal();
            }
          },
          onPressFilter: function onPressFilter() {
            setShowFilter(true);
          },
          onPressSort: function onPressSort() {
            if (sortMenuModal) {
              sortMenuModal.current.showModal();
            }
          },
          isMobileVersion: true
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CTabSelector */.Qv, {
          withoutMax: true,
          items: categoryMobile.filter(function (i) {
            return i.isHide === false;
          }),
          selectedIndex: categoryMobile.filter(function (i) {
            return i.isHide === false;
          }).findIndex(function (i) {
            return i.id === dataCategory;
          }),
          onSelectTab: function onSelectTab(item, index) {
            if (item.id === config/* Constants.categoryType.CATEGORY_FESTIVAL */.gT.categoryType.CATEGORY_FESTIVAL) {
              router.replace("/explore/festivals");
              setDataCategory(config/* Constants.categoryType.CATEGORY_FESTIVAL */.gT.categoryType.CATEGORY_FESTIVAL);
            } else if (item.id === config/* Constants.categoryType.CATEGORY_EVENT */.gT.categoryType.CATEGORY_EVENT) {
              router.replace("/explore/events");
              setDataCategory(config/* Constants.categoryType.CATEGORY_EVENT */.gT.categoryType.CATEGORY_EVENT);
            } else if (item.id === config/* Constants.categoryType.CATEGORY_ARTIST */.gT.categoryType.CATEGORY_ARTIST) {
              router.replace("/explore/artists");
              setDataCategory(config/* Constants.categoryType.CATEGORY_ARTIST */.gT.categoryType.CATEGORY_ARTIST);
            } else if (item.id === config/* Constants.categoryType.CATEGORY_VENUE */.gT.categoryType.CATEGORY_VENUE) {
              router.replace("/explore/venues");
              setDataCategory(config/* Constants.categoryType.CATEGORY_VENUE */.gT.categoryType.CATEGORY_VENUE);
            } else if (item.id === config/* Constants.categoryType.CATEGORY_ROOFTOP */.gT.categoryType.CATEGORY_ROOFTOP) {
              router.replace("/explore/rooftops");
              setDataCategory(config/* Constants.categoryType.CATEGORY_ROOFTOP */.gT.categoryType.CATEGORY_ROOFTOP);
            } else if (item.id === config/* Constants.categoryType.CATEGORY_SPA */.gT.categoryType.CATEGORY_SPA) {
              router.replace("/explore/spas");
              setDataCategory(config/* Constants.categoryType.CATEGORY_SPA */.gT.categoryType.CATEGORY_SPA);
            } else if (item.id === config/* Constants.categoryType.CATEGORY_VENUE_BEACHFUL */.gT.categoryType.CATEGORY_VENUE_BEACHFUL) {
              router.replace("/explore/beach-clubs");
              setDataCategory(config/* Constants.categoryType.CATEGORY_VENUE_BEACHFUL */.gT.categoryType.CATEGORY_VENUE_BEACHFUL);
            } else if (item.id === config/* Constants.categoryType.CATEGORY_PREFAB_COMPANY */.gT.categoryType.CATEGORY_PREFAB_COMPANY) {
              router.replace("/explore/companies");
              setDataCategory(config/* Constants.categoryType.CATEGORY_PREFAB_COMPANY */.gT.categoryType.CATEGORY_PREFAB_COMPANY);
            } else if (item.id === config/* Constants.categoryType.CATEGORY_PREFAB_HOMES */.gT.categoryType.CATEGORY_PREFAB_HOMES) {
              router.replace("/explore/homes");
              setDataCategory(config/* Constants.categoryType.CATEGORY_PREFAB_HOMES */.gT.categoryType.CATEGORY_PREFAB_HOMES);
            } else if (item.id === config/* Constants.categoryType.CATEGORY_ZOO */.gT.categoryType.CATEGORY_ZOO) {
              router.replace("/explore/zoos");
              setDataCategory(config/* Constants.categoryType.CATEGORY_ZOO */.gT.categoryType.CATEGORY_ZOO);
            } else if (item.id === config/* Constants.categoryType.CATEGORY_ANIMAL */.gT.categoryType.CATEGORY_ANIMAL) {
              router.replace("/explore/animals");
              setDataCategory(config/* Constants.categoryType.CATEGORY_ANIMAL */.gT.categoryType.CATEGORY_ANIMAL);
            } else if (item.id === config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL) {
              router.replace("/explore/parks");
              setDataCategory(config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL);
            } else if (item.id === config/* Constants.categoryType.CATEGORY_CASINO */.gT.categoryType.CATEGORY_CASINO) {
              router.replace("/explore/casinos");
              setDataCategory(config/* Constants.categoryType.CATEGORY_CASINO */.gT.categoryType.CATEGORY_CASINO);
            } else if (item.id === config/* Constants.categoryType.CATEGORY_CASTLE */.gT.categoryType.CATEGORY_CASTLE) {
              router.replace("/explore/castles");
              setDataCategory(config/* Constants.categoryType.CATEGORY_CASTLE */.gT.categoryType.CATEGORY_CASTLE);
            } else if (item.id === config/* Constants.categoryType.CATEGORY_RESORT */.gT.categoryType.CATEGORY_RESORT) {
              router.replace("/explore/resorts");
              setDataCategory(config/* Constants.categoryType.CATEGORY_RESORT */.gT.categoryType.CATEGORY_RESORT);
            } else if (item.id === config/* Constants.categoryType.CATEGORY_APARTHOTEL */.gT.categoryType.CATEGORY_APARTHOTEL) {
              router.replace("/explore/aparthotels");
              setDataCategory(config/* Constants.categoryType.CATEGORY_APARTHOTEL */.gT.categoryType.CATEGORY_APARTHOTEL);
            } else if (item.id === config/* Constants.categoryType.CATEGORY_VENUE_COCKTAIL */.gT.categoryType.CATEGORY_VENUE_COCKTAIL) {
              router.replace("/explore/bars");
              setDataCategory(config/* Constants.categoryType.CATEGORY_VENUE_COCKTAIL */.gT.categoryType.CATEGORY_VENUE_COCKTAIL);
            }
          },
          containerStyle: {
            marginTop: 16,
            paddingHorizontal: 16
          },
          isMobileVersion: true,
          showMax: true
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(explore_search/* default */.Z, {
          mapFocused: mapFocused,
          setMapFocused: setMapFocused,
          listFestival: itemsFestival,
          setListFestival: setItemsFestival,
          listArtist: itemsArtist,
          setListArtist: setItemsArtist,
          listEvent: itemsEvent,
          setListEvent: setItemsEvent,
          listVenue: itemsVenue,
          setListVenue: setItemsVenue,
          listRooftop: itemsRooftop,
          setListRooftop: setItemsRooftop,
          listSpa: itemsSpa,
          setListSpa: setItemsSpa,
          listVenueBeachful: itemsVenueBeachful,
          setListVenueBeachful: setItemsVenueBeachful,
          listPrefabCompany: itemsPrefabCompany,
          setListPrefabCompany: setItemsPrefabCompany,
          listPrefabHome: itemsPrefabHome,
          setListPrefabHome: setItemsPrefabHome,
          listZoo: itemsZoo,
          setListZoo: setItemsZoo,
          listAnimal: itemsAnimal,
          setListAnimal: setItemsAnimal,
          listParkful: itemsParkful,
          setListParkful: setItemsParkful,
          listCasino: itemsCasino,
          setListCasino: setItemsCasino,
          listCastle: itemsCastle,
          setListCastle: setItemsCastle,
          listResort: itemsResort,
          setListResort: setItemsResort,
          listAparthotel: itemsAparthotel,
          setListAparthotel: setItemsAparthotel,
          listVenueCocktail: itemsVenueCocktail,
          setListVenueCocktail: setItemsVenueCocktail,
          currentPageIndex: props.pageProps || page || 1,
          countFestival: countFestival,
          setCountFestival: setCountFestival,
          countEvent: countEvent,
          setCountEvent: setCountEvent,
          countArtist: countArtist,
          setCountArtist: setCountArtist,
          countVenue: countVenue,
          setCountVenue: setCountVenue,
          countRooftop: countRooftop,
          setCountRooftop: setCountRooftop,
          countSpa: countSpa,
          setCountSpa: setCountSpa,
          countVenueBeachful: countVenueBeachful,
          setCountVenueBeachful: setCountVenueBeachful,
          countPrefabCompany: countPrefabCompany,
          setCountPrefabCompany: setCountPrefabCompany,
          countPrefabHome: countPrefabHome,
          setCountPrefabHome: setCountPrefabHome,
          countZoo: countZoo,
          setCountZoo: setCountZoo,
          countAnimal: countAnimal,
          setCountAnimal: setCountAnimal,
          countParkful: countParkful,
          setCountParkful: setCountParkful,
          countCasino: countCasino,
          setCountCasino: setCountCasino,
          countCastle: countCastle,
          setCountCastle: setCountCastle,
          countResort: countResort,
          setCountResort: setCountResort,
          countAparthotel: countAparthotel,
          setCountAparthotel: setCountAparthotel,
          countVenueCocktail: countVenueCocktail,
          setCountVenueCocktail: setCountVenueCocktail,
          passViewMode: config/* Constants.viewType.VIEW_TYPE_LIST */.gT.viewType.VIEW_TYPE_LIST,
          keyword: keyword,
          setKeyword: setKeyword,
          dataCategory: dataCategory,
          setDataCategory: setDataCategory,
          locationSelected: locationSelected,
          setLocationSelected: setLocationSelected,
          isMobileVersion: true,
          sortBy: getSortBy(),
          typeMode: typeMode,
          setSortBy: setSortBy // Festival
          ,
          filterCriteriaListOriginalFestival: filterCriteriaListOriginalFestival,
          setFilterCriteriaListOriginalFestival: setFilterCriteriaListOriginalFestival,
          filterCriteriaListSelectedFestival: filterCriteriaListSelectedFestival,
          setFilterCriteriaListSelectedFestival: setFilterCriteriaListSelectedFestival,
          filterTabSelectedFestival: typeMode,
          setFilterTabSelectedFestival: setFilterTabSelectedFestival // Artist
          ,
          filterCriteriaListOriginalArtist: filterCriteriaListOriginalArtist,
          setFilterCriteriaListOriginalArtist: setFilterCriteriaListOriginalArtist,
          filterCriteriaListSelectedArtist: filterCriteriaListSelectedArtist,
          setFilterCriteriaListSelectedArtist: setFilterCriteriaListSelectedArtist,
          filterTabSelectedArtist: typeMode,
          setFilterTabSelectedArtist: setFilterTabSelectedArtist // Venue
          ,
          filterCriteriaListOriginalVenue: filterCriteriaListOriginalVenue,
          setFilterCriteriaListOriginalVenue: setFilterCriteriaListOriginalVenue,
          filterCriteriaListSelectedVenue: filterCriteriaListSelectedVenue,
          setFilterCriteriaListSelectedVenue: setFilterCriteriaListSelectedVenue,
          filterTabSelectedVenue: typeMode,
          setFilterTabSelectedVenue: setFilterTabSelectedVenue // Rooftop
          ,
          filterCriteriaListOriginalRooftop: filterCriteriaListOriginalRooftop,
          setFilterCriteriaListOriginalRooftop: setFilterCriteriaListOriginalRooftop,
          filterCriteriaListSelectedRooftop: filterCriteriaListSelectedRooftop,
          setFilterCriteriaListSelectedRooftop: setFilterCriteriaListSelectedRooftop,
          filterTabSelectedRooftop: typeMode,
          setFilterTabSelectedRooftop: setFilterTabSelectedRooftop // Spa
          ,
          filterCriteriaListOriginalSpa: filterCriteriaListOriginalSpa,
          setFilterCriteriaListOriginalSpa: setFilterCriteriaListOriginalSpa,
          filterCriteriaListSelectedSpa: filterCriteriaListSelectedSpa,
          setFilterCriteriaListSelectedSpa: setFilterCriteriaListSelectedSpa,
          filterTabSelectedSpa: typeMode,
          setFilterTabSelectedSpa: setFilterTabSelectedSpa // Venue Beachful
          ,
          filterCriteriaListOriginalVenueBeachful: filterCriteriaListOriginalVenueBeachful,
          setFilterCriteriaListOriginalVenueBeachful: setFilterCriteriaListOriginalVenueBeachful,
          filterCriteriaListSelectedVenueBeachful: filterCriteriaListSelectedVenueBeachful,
          setFilterCriteriaListSelectedVenueBeachful: setFilterCriteriaListSelectedVenueBeachful,
          filterTabSelectedVenueBeachful: typeMode,
          setFilterTabSelectedVenueBeachful: setFilterTabSelectedVenueBeachful // Prefab Company
          ,
          filterCriteriaListOriginalPrefabCompany: filterCriteriaListOriginalPrefabCompany,
          setFilterCriteriaListOriginalPrefabCompany: setFilterCriteriaListOriginalPrefabCompany,
          filterCriteriaListSelectedPrefabCompany: filterCriteriaListSelectedPrefabCompany,
          setFilterCriteriaListSelectedPrefabCompany: setFilterCriteriaListSelectedPrefabCompany,
          filterTabSelectedPrefabCompany: typeMode,
          setFilterTabSelectedPrefabCompany: setFilterTabSelectedPrefabCompany // Prefab Home
          ,
          filterCriteriaListOriginalPrefabHome: filterCriteriaListOriginalPrefabHome,
          setFilterCriteriaListOriginalPrefabHome: setFilterCriteriaListOriginalPrefabHome,
          filterCriteriaListSelectedPrefabHome: filterCriteriaListSelectedPrefabHome,
          setFilterCriteriaListSelectedPrefabHome: setFilterCriteriaListSelectedPrefabHome,
          filterTabSelectedPrefabHome: typeMode,
          setFilterTabSelectedPrefabHome: setFilterTabSelectedPrefabHome // Zoo
          ,
          filterCriteriaListOriginalZoo: filterCriteriaListOriginalZoo,
          setFilterCriteriaListOriginalZoo: setFilterCriteriaListOriginalZoo,
          filterCriteriaListSelectedZoo: filterCriteriaListSelectedZoo,
          setFilterCriteriaListSelectedZoo: setFilterCriteriaListSelectedZoo,
          filterTabSelectedZoo: typeMode,
          setFilterTabSelectedZoo: setFilterTabSelectedZoo // Animal
          ,
          filterCriteriaListOriginalAnimal: filterCriteriaListOriginalAnimal,
          setFilterCriteriaListOriginalAnimal: setFilterCriteriaListOriginalAnimal,
          filterCriteriaListSelectedAnimal: filterCriteriaListSelectedAnimal,
          setFilterCriteriaListSelectedAnimal: setFilterCriteriaListSelectedAnimal,
          filterTabSelectedAnimal: typeMode,
          setFilterTabSelectedAnimal: setFilterTabSelectedAnimal // Parkful
          ,
          filterCriteriaListOriginalParkful: filterCriteriaListOriginalParkful,
          setFilterCriteriaListOriginalParkful: setFilterCriteriaListOriginalParkful,
          filterCriteriaListSelectedParkful: filterCriteriaListSelectedParkful,
          setFilterCriteriaListSelectedParkful: setFilterCriteriaListSelectedParkful,
          filterTabSelectedParkful: typeMode,
          setFilterTabSelectedParkful: setFilterTabSelectedParkful // Casino
          ,
          filterCriteriaListOriginalCasino: filterCriteriaListOriginalCasino,
          setFilterCriteriaListOriginalCasino: setFilterCriteriaListOriginalCasino,
          filterCriteriaListSelectedCasino: filterCriteriaListSelectedCasino,
          setFilterCriteriaListSelectedCasino: setFilterCriteriaListSelectedCasino,
          filterTabSelectedCasino: typeMode,
          setFilterTabSelectedCasino: setFilterTabSelectedCasino // Castle
          ,
          filterCriteriaListOriginalCastle: filterCriteriaListOriginalCastle,
          setFilterCriteriaListOriginalCastle: setFilterCriteriaListOriginalCastle,
          filterCriteriaListSelectedCastle: filterCriteriaListSelectedCastle,
          setFilterCriteriaListSelectedCastle: setFilterCriteriaListSelectedCastle,
          filterTabSelectedCastle: typeMode,
          setFilterTabSelectedCastle: setFilterTabSelectedCastle // Resort
          ,
          filterCriteriaListOriginalResort: filterCriteriaListOriginalResort,
          setFilterCriteriaListOriginalResort: setFilterCriteriaListOriginalResort,
          filterCriteriaListSelectedResort: filterCriteriaListSelectedResort,
          setFilterCriteriaListSelectedResort: setFilterCriteriaListSelectedResort,
          filterTabSelectedResort: typeMode,
          setFilterTabSelectedResort: setFilterTabSelectedResort // Aparthotel
          ,
          filterCriteriaListOriginalAparthotel: filterCriteriaListOriginalAparthotel,
          setFilterCriteriaListOriginalAparthotel: setFilterCriteriaListOriginalAparthotel,
          filterCriteriaListSelectedAparthotel: filterCriteriaListSelectedAparthotel,
          setFilterCriteriaListSelectedAparthotel: setFilterCriteriaListSelectedAparthotel,
          filterTabSelectedAparthotel: typeMode,
          setFilterTabSelectedAparthotel: setFilterTabSelectedAparthotel // Venue Cocktail
          ,
          filterCriteriaListOriginalVenueCocktail: filterCriteriaListOriginalVenueCocktail,
          setFilterCriteriaListOriginalVenueCocktail: setFilterCriteriaListOriginalVenueCocktail,
          filterCriteriaListSelectedVenueCocktail: filterCriteriaListSelectedVenueCocktail,
          setFilterCriteriaListSelectedVenueCocktail: setFilterCriteriaListSelectedVenueCocktail,
          filterTabSelectedVenueCocktail: typeMode,
          setFilterTabSelectedVenueCocktail: setFilterTabSelectedVenueCocktail
        }), (dataCategory === config/* Constants.categoryType.CATEGORY_FESTIVAL */.gT.categoryType.CATEGORY_FESTIVAL || dataCategory === config/* Constants.categoryType.CATEGORY_VENUE */.gT.categoryType.CATEGORY_VENUE || dataCategory === config/* Constants.categoryType.CATEGORY_ROOFTOP */.gT.categoryType.CATEGORY_ROOFTOP || dataCategory === config/* Constants.categoryType.CATEGORY_SPA */.gT.categoryType.CATEGORY_SPA || dataCategory === config/* Constants.categoryType.CATEGORY_VENUE_BEACHFUL */.gT.categoryType.CATEGORY_VENUE_BEACHFUL || dataCategory === config/* Constants.categoryType.CATEGORY_PREFAB_COMPANY */.gT.categoryType.CATEGORY_PREFAB_COMPANY || dataCategory === config/* Constants.categoryType.CATEGORY_ZOO */.gT.categoryType.CATEGORY_ZOO || dataCategory === config/* Constants.categoryType.CATEGORY_ANIMAL */.gT.categoryType.CATEGORY_ANIMAL || dataCategory === config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL || dataCategory === config/* Constants.categoryType.CATEGORY_CASINO */.gT.categoryType.CATEGORY_CASINO || dataCategory === config/* Constants.categoryType.CATEGORY_CASTLE */.gT.categoryType.CATEGORY_CASTLE || dataCategory === config/* Constants.categoryType.CATEGORY_RESORT */.gT.categoryType.CATEGORY_RESORT || dataCategory === config/* Constants.categoryType.CATEGORY_APARTHOTEL */.gT.categoryType.CATEGORY_APARTHOTEL || dataCategory === config/* Constants.categoryType.CATEGORY_VENUE_COCKTAIL */.gT.categoryType.CATEGORY_VENUE_COCKTAIL) && viewMode !== config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "fixed bottom-[100px] right-[16px]",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "w-[60px] h-[60px] rounded-full ".concat((0,formatHelpers/* getClass */.ll)("bg-btn-map", true), " flex justify-center items-center cursor-pointer"),
            onClick: function onClick() {
              setViewMode(config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP);
              document.body.style.overflow = "hidden";
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
              source: config/* Images.iconWorldwide */.rU.iconWorldwide,
              width: 32,
              height: 32,
              layout: "fixed"
            })
          })
        }), viewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP && dataCategory === config/* Constants.categoryType.CATEGORY_FESTIVAL */.gT.categoryType.CATEGORY_FESTIVAL && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "fixed left-0 top-0 h-full w-full",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "absolute left-0 top-0 w-full h-full z-10",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(DynamicMap, {
              borderRadius: 0,
              region: {
                latitude: 51.495907,
                longitude: -0.180144,
                latitudeDelta: 0.0922,
                longitudeDelta: 0.0421
              },
              items: itemsFestival.filter(function (i) {
                return i.latitude;
              }),
              category: dataCategory,
              selectedItem: mapFocused,
              setSelectedItem: setMapFocused
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "absolute bottom-0 left-0 z-20 py-[30px]",
            children: (itemsFestival === null || itemsFestival === void 0 ? void 0 : itemsFestival.find(function (i) {
              return i.id === mapFocused;
            })) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", _category_objectSpread(_category_objectSpread({}, handlers), {}, {
              className: "flex flex-row",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                prefetch: false,
                href: (0,helpers/* generateURLSlug */.ZF)(itemsFestival === null || itemsFestival === void 0 ? void 0 : itemsFestival.find(function (i) {
                  return i.id === mapFocused;
                }).id, (itemsFestival === null || itemsFestival === void 0 ? void 0 : itemsFestival.find(function (i) {
                  return i.id === mapFocused;
                }).title) || (itemsFestival === null || itemsFestival === void 0 ? void 0 : itemsFestival.find(function (i) {
                  return i.id === mapFocused;
                }).displayName) || (itemsFestival === null || itemsFestival === void 0 ? void 0 : itemsFestival.find(function (i) {
                  return i.id === mapFocused;
                }).nickname), itemsFestival === null || itemsFestival === void 0 ? void 0 : itemsFestival.find(function (i) {
                  return i.id === mapFocused;
                }).startDate, dataCategory, "about"),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "pl-[8px]",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "w-screen-custom rounded-lg overflow-hidden",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(CardItem/* default */.Z, {
                      item: itemsFestival === null || itemsFestival === void 0 ? void 0 : itemsFestival.find(function (i) {
                        return i.id === mapFocused;
                      }),
                      category: dataCategory,
                      portrait: false,
                      fullWidth: false,
                      mapView: true,
                      isMobileVersion: true,
                      marginBottom: 0 // mapFocused={props.mapFocused}
                      // setMapFocused={props.setMapFocused}
                      // firstIndex={index === 0}
                      // lastIndex={index === itemsFestival.length - 1}
                      // onItemAction={onItemAction}

                    })
                  })
                })
              })
            }))
          })]
        }), viewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP && dataCategory === config/* Constants.categoryType.CATEGORY_VENUE */.gT.categoryType.CATEGORY_VENUE && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "fixed left-0 top-0 h-full w-full",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "absolute left-0 top-0 w-full h-full z-10",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(DynamicMap, {
              borderRadius: 0,
              region: {
                latitude: 51.495907,
                longitude: -0.180144,
                latitudeDelta: 0.0922,
                longitudeDelta: 0.0421
              },
              items: itemsVenue.filter(function (i) {
                return i.latitude;
              }),
              category: dataCategory,
              selectedItem: mapFocused,
              setSelectedItem: setMapFocused
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "absolute bottom-0 left-0 z-20 py-[30px]",
            children: (itemsVenue === null || itemsVenue === void 0 ? void 0 : itemsVenue.find(function (i) {
              return i.id === mapFocused;
            })) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", _category_objectSpread(_category_objectSpread({}, handlers), {}, {
              className: "flex flex-row",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                prefetch: false,
                href: (0,helpers/* generateURLSlug */.ZF)(itemsVenue === null || itemsVenue === void 0 ? void 0 : itemsVenue.find(function (i) {
                  return i.id === mapFocused;
                }).id, (itemsVenue === null || itemsVenue === void 0 ? void 0 : itemsVenue.find(function (i) {
                  return i.id === mapFocused;
                }).title) || (itemsVenue === null || itemsVenue === void 0 ? void 0 : itemsVenue.find(function (i) {
                  return i.id === mapFocused;
                }).displayName) || (itemsVenue === null || itemsVenue === void 0 ? void 0 : itemsVenue.find(function (i) {
                  return i.id === mapFocused;
                }).nickname), itemsVenue === null || itemsVenue === void 0 ? void 0 : itemsVenue.find(function (i) {
                  return i.id === mapFocused;
                }).startDate, dataCategory, "about"),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "pl-[8px]",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "w-screen-custom rounded-lg overflow-hidden",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(CardItem/* default */.Z, {
                      item: itemsVenue === null || itemsVenue === void 0 ? void 0 : itemsVenue.find(function (i) {
                        return i.id === mapFocused;
                      }),
                      category: dataCategory,
                      portrait: false,
                      fullWidth: false,
                      mapView: true,
                      isMobileVersion: true,
                      marginBottom: 0 // mapFocused={props.mapFocused}
                      // setMapFocused={props.setMapFocused}
                      // firstIndex={index === 0}
                      // lastIndex={index === itemsVenue.length - 1}
                      // onItemAction={onItemAction}

                    })
                  })
                })
              })
            }))
          })]
        }), viewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP && dataCategory === config/* Constants.categoryType.CATEGORY_ROOFTOP */.gT.categoryType.CATEGORY_ROOFTOP && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "fixed left-0 top-0 h-full w-full",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "absolute left-0 top-0 w-full h-full z-10",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(DynamicMap, {
              borderRadius: 0,
              region: {
                latitude: 51.495907,
                longitude: -0.180144,
                latitudeDelta: 0.0922,
                longitudeDelta: 0.0421
              },
              items: itemsRooftop.filter(function (i) {
                return i.latitude;
              }),
              category: dataCategory,
              selectedItem: mapFocused,
              setSelectedItem: setMapFocused
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "absolute bottom-0 left-0 z-20 py-[30px]",
            children: (itemsRooftop === null || itemsRooftop === void 0 ? void 0 : itemsRooftop.find(function (i) {
              return i.id === mapFocused;
            })) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", _category_objectSpread(_category_objectSpread({}, handlers), {}, {
              className: "flex flex-row",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                prefetch: false,
                href: (0,helpers/* generateURLSlug */.ZF)(itemsRooftop === null || itemsRooftop === void 0 ? void 0 : itemsRooftop.find(function (i) {
                  return i.id === mapFocused;
                }).id, (itemsRooftop === null || itemsRooftop === void 0 ? void 0 : itemsRooftop.find(function (i) {
                  return i.id === mapFocused;
                }).title) || (itemsRooftop === null || itemsRooftop === void 0 ? void 0 : itemsRooftop.find(function (i) {
                  return i.id === mapFocused;
                }).displayName) || (itemsRooftop === null || itemsRooftop === void 0 ? void 0 : itemsRooftop.find(function (i) {
                  return i.id === mapFocused;
                }).nickname), itemsRooftop === null || itemsRooftop === void 0 ? void 0 : itemsRooftop.find(function (i) {
                  return i.id === mapFocused;
                }).startDate, dataCategory, "about"),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "pl-[8px]",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "w-screen-custom rounded-lg overflow-hidden",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(CardItem/* default */.Z, {
                      item: itemsRooftop === null || itemsRooftop === void 0 ? void 0 : itemsRooftop.find(function (i) {
                        return i.id === mapFocused;
                      }),
                      category: dataCategory,
                      portrait: false,
                      fullWidth: false,
                      mapView: true,
                      isMobileVersion: true,
                      marginBottom: 0 // mapFocused={props.mapFocused}
                      // setMapFocused={props.setMapFocused}
                      // firstIndex={index === 0}
                      // lastIndex={index === itemsRooftop.length - 1}
                      // onItemAction={onItemAction}

                    })
                  })
                })
              })
            }))
          })]
        }), viewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP && dataCategory === config/* Constants.categoryType.CATEGORY_SPA */.gT.categoryType.CATEGORY_SPA && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "fixed left-0 top-0 h-full w-full",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "absolute left-0 top-0 w-full h-full z-10",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(DynamicMap, {
              borderRadius: 0,
              region: {
                latitude: 51.495907,
                longitude: -0.180144,
                latitudeDelta: 0.0922,
                longitudeDelta: 0.0421
              },
              items: itemsSpa.filter(function (i) {
                return i.latitude;
              }),
              category: dataCategory,
              selectedItem: mapFocused,
              setSelectedItem: setMapFocused
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "absolute bottom-0 left-0 z-20 py-[30px]",
            children: (itemsSpa === null || itemsSpa === void 0 ? void 0 : itemsSpa.find(function (i) {
              return i.id === mapFocused;
            })) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", _category_objectSpread(_category_objectSpread({}, handlers), {}, {
              className: "flex flex-row",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                prefetch: false,
                href: (0,helpers/* generateURLSlug */.ZF)(itemsSpa === null || itemsSpa === void 0 ? void 0 : itemsSpa.find(function (i) {
                  return i.id === mapFocused;
                }).id, (itemsSpa === null || itemsSpa === void 0 ? void 0 : itemsSpa.find(function (i) {
                  return i.id === mapFocused;
                }).title) || (itemsSpa === null || itemsSpa === void 0 ? void 0 : itemsSpa.find(function (i) {
                  return i.id === mapFocused;
                }).displayName) || (itemsSpa === null || itemsSpa === void 0 ? void 0 : itemsSpa.find(function (i) {
                  return i.id === mapFocused;
                }).nickname), itemsSpa === null || itemsSpa === void 0 ? void 0 : itemsSpa.find(function (i) {
                  return i.id === mapFocused;
                }).startDate, dataCategory, "about"),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "pl-[8px]",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "w-screen-custom rounded-lg overflow-hidden",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(CardItem/* default */.Z, {
                      item: itemsSpa === null || itemsSpa === void 0 ? void 0 : itemsSpa.find(function (i) {
                        return i.id === mapFocused;
                      }),
                      category: dataCategory,
                      portrait: false,
                      fullWidth: false,
                      mapView: true,
                      isMobileVersion: true,
                      marginBottom: 0 // mapFocused={props.mapFocused}
                      // setMapFocused={props.setMapFocused}
                      // firstIndex={index === 0}
                      // lastIndex={index === itemsSpa.length - 1}
                      // onItemAction={onItemAction}

                    })
                  })
                })
              })
            }))
          })]
        }), viewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP && dataCategory === config/* Constants.categoryType.CATEGORY_VENUE_BEACHFUL */.gT.categoryType.CATEGORY_VENUE_BEACHFUL && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "fixed left-0 top-0 h-full w-full",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "absolute left-0 top-0 w-full h-full z-10",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(DynamicMap, {
              borderRadius: 0,
              region: {
                latitude: 51.495907,
                longitude: -0.180144,
                latitudeDelta: 0.0922,
                longitudeDelta: 0.0421
              },
              items: itemsVenueBeachful.filter(function (i) {
                return i.latitude;
              }),
              category: dataCategory,
              selectedItem: mapFocused,
              setSelectedItem: setMapFocused
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "absolute bottom-0 left-0 z-20 py-[30px]",
            children: (itemsVenueBeachful === null || itemsVenueBeachful === void 0 ? void 0 : itemsVenueBeachful.find(function (i) {
              return i.id === mapFocused;
            })) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", _category_objectSpread(_category_objectSpread({}, handlers), {}, {
              className: "flex flex-row",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                prefetch: false,
                href: (0,helpers/* generateURLSlug */.ZF)(itemsVenueBeachful === null || itemsVenueBeachful === void 0 ? void 0 : itemsVenueBeachful.find(function (i) {
                  return i.id === mapFocused;
                }).id, (itemsVenueBeachful === null || itemsVenueBeachful === void 0 ? void 0 : itemsVenueBeachful.find(function (i) {
                  return i.id === mapFocused;
                }).title) || (itemsVenueBeachful === null || itemsVenueBeachful === void 0 ? void 0 : itemsVenueBeachful.find(function (i) {
                  return i.id === mapFocused;
                }).displayName) || (itemsVenueBeachful === null || itemsVenueBeachful === void 0 ? void 0 : itemsVenueBeachful.find(function (i) {
                  return i.id === mapFocused;
                }).nickname), itemsVenueBeachful === null || itemsVenueBeachful === void 0 ? void 0 : itemsVenueBeachful.find(function (i) {
                  return i.id === mapFocused;
                }).startDate, dataCategory, "about"),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "pl-[8px]",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "w-screen-custom rounded-lg overflow-hidden",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(CardItem/* default */.Z, {
                      item: itemsVenueBeachful === null || itemsVenueBeachful === void 0 ? void 0 : itemsVenueBeachful.find(function (i) {
                        return i.id === mapFocused;
                      }),
                      category: dataCategory,
                      portrait: false,
                      fullWidth: false,
                      mapView: true,
                      isMobileVersion: true,
                      marginBottom: 0 // mapFocused={props.mapFocused}
                      // setMapFocused={props.setMapFocused}
                      // firstIndex={index === 0}
                      // lastIndex={index === itemsVenueBeachful.length - 1}
                      // onItemAction={onItemAction}

                    })
                  })
                })
              })
            }))
          })]
        }), viewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP && dataCategory === config/* Constants.categoryType.CATEGORY_PREFAB_COMPANY */.gT.categoryType.CATEGORY_PREFAB_COMPANY && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "fixed left-0 top-0 h-full w-full",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "absolute left-0 top-0 w-full h-full z-10",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(DynamicMap, {
              borderRadius: 0,
              region: {
                latitude: 51.495907,
                longitude: -0.180144,
                latitudeDelta: 0.0922,
                longitudeDelta: 0.0421
              },
              items: itemsPrefabCompany.filter(function (i) {
                return i.latitude;
              }),
              category: dataCategory,
              selectedItem: mapFocused,
              setSelectedItem: setMapFocused
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "absolute bottom-0 left-0 z-20 py-[30px]",
            children: (itemsPrefabCompany === null || itemsPrefabCompany === void 0 ? void 0 : itemsPrefabCompany.find(function (i) {
              return i.id === mapFocused;
            })) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", _category_objectSpread(_category_objectSpread({}, handlers), {}, {
              className: "flex flex-row",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                prefetch: false,
                href: (0,helpers/* generateURLSlug */.ZF)(itemsPrefabCompany === null || itemsPrefabCompany === void 0 ? void 0 : itemsPrefabCompany.find(function (i) {
                  return i.id === mapFocused;
                }).id, (itemsPrefabCompany === null || itemsPrefabCompany === void 0 ? void 0 : itemsPrefabCompany.find(function (i) {
                  return i.id === mapFocused;
                }).title) || (itemsPrefabCompany === null || itemsPrefabCompany === void 0 ? void 0 : itemsPrefabCompany.find(function (i) {
                  return i.id === mapFocused;
                }).displayName) || (itemsPrefabCompany === null || itemsPrefabCompany === void 0 ? void 0 : itemsPrefabCompany.find(function (i) {
                  return i.id === mapFocused;
                }).nickname), itemsPrefabCompany === null || itemsPrefabCompany === void 0 ? void 0 : itemsPrefabCompany.find(function (i) {
                  return i.id === mapFocused;
                }).startDate, dataCategory, "about"),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "pl-[8px]",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "w-screen-custom rounded-lg overflow-hidden",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(CardItem/* default */.Z, {
                      item: itemsPrefabCompany === null || itemsPrefabCompany === void 0 ? void 0 : itemsPrefabCompany.find(function (i) {
                        return i.id === mapFocused;
                      }),
                      category: dataCategory,
                      portrait: false,
                      fullWidth: false,
                      mapView: true,
                      isMobileVersion: true,
                      marginBottom: 0 // mapFocused={props.mapFocused}
                      // setMapFocused={props.setMapFocused}
                      // firstIndex={index === 0}
                      // lastIndex={index === itemsPrefabCompany.length - 1}
                      // onItemAction={onItemAction}

                    })
                  })
                })
              })
            }))
          })]
        }), viewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP && dataCategory === config/* Constants.categoryType.CATEGORY_ZOO */.gT.categoryType.CATEGORY_ZOO && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "fixed left-0 top-0 h-full w-full",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "absolute left-0 top-0 w-full h-full z-10",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(DynamicMap, {
              borderRadius: 0,
              region: {
                latitude: 51.495907,
                longitude: -0.180144,
                latitudeDelta: 0.0922,
                longitudeDelta: 0.0421
              },
              items: itemsZoo.filter(function (i) {
                return i.latitude;
              }),
              category: dataCategory,
              selectedItem: mapFocused,
              setSelectedItem: setMapFocused
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "absolute bottom-0 left-0 z-20 py-[30px]",
            children: (itemsZoo === null || itemsZoo === void 0 ? void 0 : itemsZoo.find(function (i) {
              return i.id === mapFocused;
            })) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", _category_objectSpread(_category_objectSpread({}, handlers), {}, {
              className: "flex flex-row",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                prefetch: false,
                href: (0,helpers/* generateURLSlug */.ZF)(itemsZoo === null || itemsZoo === void 0 ? void 0 : itemsZoo.find(function (i) {
                  return i.id === mapFocused;
                }).id, (itemsZoo === null || itemsZoo === void 0 ? void 0 : itemsZoo.find(function (i) {
                  return i.id === mapFocused;
                }).title) || (itemsZoo === null || itemsZoo === void 0 ? void 0 : itemsZoo.find(function (i) {
                  return i.id === mapFocused;
                }).displayName) || (itemsZoo === null || itemsZoo === void 0 ? void 0 : itemsZoo.find(function (i) {
                  return i.id === mapFocused;
                }).nickname), itemsZoo === null || itemsZoo === void 0 ? void 0 : itemsZoo.find(function (i) {
                  return i.id === mapFocused;
                }).startDate, dataCategory, "about"),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "pl-[8px]",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "w-screen-custom rounded-lg overflow-hidden",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(CardItem/* default */.Z, {
                      item: itemsZoo === null || itemsZoo === void 0 ? void 0 : itemsZoo.find(function (i) {
                        return i.id === mapFocused;
                      }),
                      category: dataCategory,
                      portrait: false,
                      fullWidth: false,
                      mapView: true,
                      isMobileVersion: true,
                      marginBottom: 0 // mapFocused={props.mapFocused}
                      // setMapFocused={props.setMapFocused}
                      // firstIndex={index === 0}
                      // lastIndex={index === itemsZoo.length - 1}
                      // onItemAction={onItemAction}

                    })
                  })
                })
              })
            }))
          })]
        }), viewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP && dataCategory === config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "fixed left-0 top-0 h-full w-full",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "absolute left-0 top-0 w-full h-full z-10",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(DynamicMap, {
              borderRadius: 0,
              region: {
                latitude: 51.495907,
                longitude: -0.180144,
                latitudeDelta: 0.0922,
                longitudeDelta: 0.0421
              },
              items: itemsParkful.filter(function (i) {
                return i.latitude;
              }),
              category: dataCategory,
              selectedItem: mapFocused,
              setSelectedItem: setMapFocused
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "absolute bottom-0 left-0 z-20 py-[30px]",
            children: (itemsParkful === null || itemsParkful === void 0 ? void 0 : itemsParkful.find(function (i) {
              return i.id === mapFocused;
            })) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", _category_objectSpread(_category_objectSpread({}, handlers), {}, {
              className: "flex flex-row",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                prefetch: false,
                href: (0,helpers/* generateURLSlug */.ZF)(itemsParkful === null || itemsParkful === void 0 ? void 0 : itemsParkful.find(function (i) {
                  return i.id === mapFocused;
                }).id, (itemsParkful === null || itemsParkful === void 0 ? void 0 : itemsParkful.find(function (i) {
                  return i.id === mapFocused;
                }).title) || (itemsParkful === null || itemsParkful === void 0 ? void 0 : itemsParkful.find(function (i) {
                  return i.id === mapFocused;
                }).displayName) || (itemsParkful === null || itemsParkful === void 0 ? void 0 : itemsParkful.find(function (i) {
                  return i.id === mapFocused;
                }).nickname), itemsParkful === null || itemsParkful === void 0 ? void 0 : itemsParkful.find(function (i) {
                  return i.id === mapFocused;
                }).startDate, dataCategory, "about"),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "pl-[8px]",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "w-screen-custom rounded-lg overflow-hidden",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(CardItem/* default */.Z, {
                      item: itemsParkful === null || itemsParkful === void 0 ? void 0 : itemsParkful.find(function (i) {
                        return i.id === mapFocused;
                      }),
                      category: dataCategory,
                      portrait: false,
                      fullWidth: false,
                      mapView: true,
                      isMobileVersion: true,
                      marginBottom: 0 // mapFocused={props.mapFocused}
                      // setMapFocused={props.setMapFocused}
                      // firstIndex={index === 0}
                      // lastIndex={index === itemsZoo.length - 1}
                      // onItemAction={onItemAction}

                    })
                  })
                })
              })
            }))
          })]
        }), viewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP && dataCategory === config/* Constants.categoryType.CATEGORY_CASINO */.gT.categoryType.CATEGORY_CASINO && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "fixed left-0 top-0 h-full w-full",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "absolute left-0 top-0 w-full h-full z-10",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(DynamicMap, {
              borderRadius: 0,
              region: {
                latitude: 51.495907,
                longitude: -0.180144,
                latitudeDelta: 0.0922,
                longitudeDelta: 0.0421
              },
              items: itemsCasino.filter(function (i) {
                return i.latitude;
              }),
              category: dataCategory,
              selectedItem: mapFocused,
              setSelectedItem: setMapFocused
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "absolute bottom-0 left-0 z-20 py-[30px]",
            children: (itemsCasino === null || itemsCasino === void 0 ? void 0 : itemsCasino.find(function (i) {
              return i.id === mapFocused;
            })) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", _category_objectSpread(_category_objectSpread({}, handlers), {}, {
              className: "flex flex-row",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                prefetch: false,
                href: (0,helpers/* generateURLSlug */.ZF)(itemsCasino === null || itemsCasino === void 0 ? void 0 : itemsCasino.find(function (i) {
                  return i.id === mapFocused;
                }).id, (itemsCasino === null || itemsCasino === void 0 ? void 0 : itemsCasino.find(function (i) {
                  return i.id === mapFocused;
                }).title) || (itemsCasino === null || itemsCasino === void 0 ? void 0 : itemsCasino.find(function (i) {
                  return i.id === mapFocused;
                }).displayName) || (itemsCasino === null || itemsCasino === void 0 ? void 0 : itemsCasino.find(function (i) {
                  return i.id === mapFocused;
                }).nickname), itemsCasino === null || itemsCasino === void 0 ? void 0 : itemsCasino.find(function (i) {
                  return i.id === mapFocused;
                }).startDate, dataCategory, "about"),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "pl-[8px]",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "w-screen-custom rounded-lg overflow-hidden",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(CardItem/* default */.Z, {
                      item: itemsCasino === null || itemsCasino === void 0 ? void 0 : itemsCasino.find(function (i) {
                        return i.id === mapFocused;
                      }),
                      category: dataCategory,
                      portrait: false,
                      fullWidth: false,
                      mapView: true,
                      isMobileVersion: true,
                      marginBottom: 0 // mapFocused={props.mapFocused}
                      // setMapFocused={props.setMapFocused}
                      // firstIndex={index === 0}
                      // lastIndex={index === itemsZoo.length - 1}
                      // onItemAction={onItemAction}

                    })
                  })
                })
              })
            }))
          })]
        }), viewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP && dataCategory === config/* Constants.categoryType.CATEGORY_CASTLE */.gT.categoryType.CATEGORY_CASTLE && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "fixed left-0 top-0 h-full w-full",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "absolute left-0 top-0 w-full h-full z-10",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(DynamicMap, {
              borderRadius: 0,
              region: {
                latitude: 51.495907,
                longitude: -0.180144,
                latitudeDelta: 0.0922,
                longitudeDelta: 0.0421
              },
              items: itemsCastle.filter(function (i) {
                return i.latitude;
              }),
              category: dataCategory,
              selectedItem: mapFocused,
              setSelectedItem: setMapFocused
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "absolute bottom-0 left-0 z-20 py-[30px]",
            children: (itemsCastle === null || itemsCastle === void 0 ? void 0 : itemsCastle.find(function (i) {
              return i.id === mapFocused;
            })) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", _category_objectSpread(_category_objectSpread({}, handlers), {}, {
              className: "flex flex-row",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                prefetch: false,
                href: (0,helpers/* generateURLSlug */.ZF)(itemsCastle === null || itemsCastle === void 0 ? void 0 : itemsCastle.find(function (i) {
                  return i.id === mapFocused;
                }).id, (itemsCastle === null || itemsCastle === void 0 ? void 0 : itemsCastle.find(function (i) {
                  return i.id === mapFocused;
                }).title) || (itemsCastle === null || itemsCastle === void 0 ? void 0 : itemsCastle.find(function (i) {
                  return i.id === mapFocused;
                }).displayName) || (itemsCastle === null || itemsCastle === void 0 ? void 0 : itemsCastle.find(function (i) {
                  return i.id === mapFocused;
                }).nickname), itemsCastle === null || itemsCastle === void 0 ? void 0 : itemsCastle.find(function (i) {
                  return i.id === mapFocused;
                }).startDate, dataCategory, "about"),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "pl-[8px]",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "w-screen-custom rounded-lg overflow-hidden",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(CardItem/* default */.Z, {
                      item: itemsCastle === null || itemsCastle === void 0 ? void 0 : itemsCastle.find(function (i) {
                        return i.id === mapFocused;
                      }),
                      category: dataCategory,
                      portrait: false,
                      fullWidth: false,
                      mapView: true,
                      isMobileVersion: true,
                      marginBottom: 0 // mapFocused={props.mapFocused}
                      // setMapFocused={props.setMapFocused}
                      // firstIndex={index === 0}
                      // lastIndex={index === itemsZoo.length - 1}
                      // onItemAction={onItemAction}

                    })
                  })
                })
              })
            }))
          })]
        }), viewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP && dataCategory === config/* Constants.categoryType.CATEGORY_RESORT */.gT.categoryType.CATEGORY_RESORT && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "fixed left-0 top-0 h-full w-full",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "absolute left-0 top-0 w-full h-full z-10",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(DynamicMap, {
              borderRadius: 0,
              region: {
                latitude: 51.495907,
                longitude: -0.180144,
                latitudeDelta: 0.0922,
                longitudeDelta: 0.0421
              },
              items: itemsResort.filter(function (i) {
                return i.latitude;
              }),
              category: dataCategory,
              selectedItem: mapFocused,
              setSelectedItem: setMapFocused
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "absolute bottom-0 left-0 z-20 py-[30px]",
            children: (itemsResort === null || itemsResort === void 0 ? void 0 : itemsResort.find(function (i) {
              return i.id === mapFocused;
            })) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", _category_objectSpread(_category_objectSpread({}, handlers), {}, {
              className: "flex flex-row",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                prefetch: false,
                href: (0,helpers/* generateURLSlug */.ZF)(itemsResort === null || itemsResort === void 0 ? void 0 : itemsResort.find(function (i) {
                  return i.id === mapFocused;
                }).id, (itemsResort === null || itemsResort === void 0 ? void 0 : itemsResort.find(function (i) {
                  return i.id === mapFocused;
                }).title) || (itemsResort === null || itemsResort === void 0 ? void 0 : itemsResort.find(function (i) {
                  return i.id === mapFocused;
                }).displayName) || (itemsResort === null || itemsResort === void 0 ? void 0 : itemsResort.find(function (i) {
                  return i.id === mapFocused;
                }).nickname), itemsResort === null || itemsResort === void 0 ? void 0 : itemsResort.find(function (i) {
                  return i.id === mapFocused;
                }).startDate, dataCategory, "about"),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "pl-[8px]",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "w-screen-custom rounded-lg overflow-hidden",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(CardItem/* default */.Z, {
                      item: itemsResort === null || itemsResort === void 0 ? void 0 : itemsResort.find(function (i) {
                        return i.id === mapFocused;
                      }),
                      category: dataCategory,
                      portrait: false,
                      fullWidth: false,
                      mapView: true,
                      isMobileVersion: true,
                      marginBottom: 0 // mapFocused={props.mapFocused}
                      // setMapFocused={props.setMapFocused}
                      // firstIndex={index === 0}
                      // lastIndex={index === itemsZoo.length - 1}
                      // onItemAction={onItemAction}

                    })
                  })
                })
              })
            }))
          })]
        }), viewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP && dataCategory === config/* Constants.categoryType.CATEGORY_APARTHOTEL */.gT.categoryType.CATEGORY_APARTHOTEL && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "fixed left-0 top-0 h-full w-full",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "absolute left-0 top-0 w-full h-full z-10",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(DynamicMap, {
              borderRadius: 0,
              region: {
                latitude: 51.495907,
                longitude: -0.180144,
                latitudeDelta: 0.0922,
                longitudeDelta: 0.0421
              },
              items: itemsAparthotel.filter(function (i) {
                return i.latitude;
              }),
              category: dataCategory,
              selectedItem: mapFocused,
              setSelectedItem: setMapFocused
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "absolute bottom-0 left-0 z-20 py-[30px]",
            children: (itemsAparthotel === null || itemsAparthotel === void 0 ? void 0 : itemsAparthotel.find(function (i) {
              return i.id === mapFocused;
            })) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", _category_objectSpread(_category_objectSpread({}, handlers), {}, {
              className: "flex flex-row",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                prefetch: false,
                href: (0,helpers/* generateURLSlug */.ZF)(itemsAparthotel === null || itemsAparthotel === void 0 ? void 0 : itemsAparthotel.find(function (i) {
                  return i.id === mapFocused;
                }).id, (itemsAparthotel === null || itemsAparthotel === void 0 ? void 0 : itemsAparthotel.find(function (i) {
                  return i.id === mapFocused;
                }).title) || (itemsAparthotel === null || itemsAparthotel === void 0 ? void 0 : itemsAparthotel.find(function (i) {
                  return i.id === mapFocused;
                }).displayName) || (itemsAparthotel === null || itemsAparthotel === void 0 ? void 0 : itemsAparthotel.find(function (i) {
                  return i.id === mapFocused;
                }).nickname), itemsAparthotel === null || itemsAparthotel === void 0 ? void 0 : itemsAparthotel.find(function (i) {
                  return i.id === mapFocused;
                }).startDate, dataCategory, "about"),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "pl-[8px]",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "w-screen-custom rounded-lg overflow-hidden",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(CardItem/* default */.Z, {
                      item: itemsAparthotel === null || itemsAparthotel === void 0 ? void 0 : itemsAparthotel.find(function (i) {
                        return i.id === mapFocused;
                      }),
                      category: dataCategory,
                      portrait: false,
                      fullWidth: false,
                      mapView: true,
                      isMobileVersion: true,
                      marginBottom: 0 // mapFocused={props.mapFocused}
                      // setMapFocused={props.setMapFocused}
                      // firstIndex={index === 0}
                      // lastIndex={index === itemsZoo.length - 1}
                      // onItemAction={onItemAction}

                    })
                  })
                })
              })
            }))
          })]
        }), viewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP && dataCategory === config/* Constants.categoryType.CATEGORY_VENUE_COCKTAIL */.gT.categoryType.CATEGORY_VENUE_COCKTAIL && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "fixed left-0 top-0 h-full w-full",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "absolute left-0 top-0 w-full h-full z-10",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(DynamicMap, {
              borderRadius: 0,
              region: {
                latitude: 51.495907,
                longitude: -0.180144,
                latitudeDelta: 0.0922,
                longitudeDelta: 0.0421
              },
              items: itemsVenueCocktail.filter(function (i) {
                return i.latitude;
              }),
              category: dataCategory,
              selectedItem: mapFocused,
              setSelectedItem: setMapFocused
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "absolute bottom-0 left-0 z-20 py-[30px]",
            children: (itemsVenueCocktail === null || itemsVenueCocktail === void 0 ? void 0 : itemsVenueCocktail.find(function (i) {
              return i.id === mapFocused;
            })) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", _category_objectSpread(_category_objectSpread({}, handlers), {}, {
              className: "flex flex-row",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                prefetch: false,
                href: (0,helpers/* generateURLSlug */.ZF)(itemsVenueCocktail === null || itemsVenueCocktail === void 0 ? void 0 : itemsVenueCocktail.find(function (i) {
                  return i.id === mapFocused;
                }).id, (itemsVenueCocktail === null || itemsVenueCocktail === void 0 ? void 0 : itemsVenueCocktail.find(function (i) {
                  return i.id === mapFocused;
                }).title) || (itemsVenueCocktail === null || itemsVenueCocktail === void 0 ? void 0 : itemsVenueCocktail.find(function (i) {
                  return i.id === mapFocused;
                }).displayName) || (itemsVenueCocktail === null || itemsVenueCocktail === void 0 ? void 0 : itemsVenueCocktail.find(function (i) {
                  return i.id === mapFocused;
                }).nickname), itemsVenueCocktail === null || itemsVenueCocktail === void 0 ? void 0 : itemsVenueCocktail.find(function (i) {
                  return i.id === mapFocused;
                }).startDate, dataCategory, "about"),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "pl-[8px]",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "w-screen-custom rounded-lg overflow-hidden",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(CardItem/* default */.Z, {
                      item: itemsVenueCocktail === null || itemsVenueCocktail === void 0 ? void 0 : itemsVenueCocktail.find(function (i) {
                        return i.id === mapFocused;
                      }),
                      category: dataCategory,
                      portrait: false,
                      fullWidth: false,
                      mapView: true,
                      isMobileVersion: true,
                      marginBottom: 0 // mapFocused={props.mapFocused}
                      // setMapFocused={props.setMapFocused}
                      // firstIndex={index === 0}
                      // lastIndex={index === itemsVenueCocktail.length - 1}
                      // onItemAction={onItemAction}

                    })
                  })
                })
              })
            }))
          })]
        }), (dataCategory === config/* Constants.categoryType.CATEGORY_VENUE */.gT.categoryType.CATEGORY_VENUE || dataCategory === config/* Constants.categoryType.CATEGORY_ROOFTOP */.gT.categoryType.CATEGORY_ROOFTOP || dataCategory === config/* Constants.categoryType.CATEGORY_SPA */.gT.categoryType.CATEGORY_SPA || dataCategory === config/* Constants.categoryType.CATEGORY_VENUE_BEACHFUL */.gT.categoryType.CATEGORY_VENUE_BEACHFUL || dataCategory === config/* Constants.categoryType.CATEGORY_PREFAB_COMPANY */.gT.categoryType.CATEGORY_PREFAB_COMPANY || dataCategory === config/* Constants.categoryType.CATEGORY_PREFAB_HOMES */.gT.categoryType.CATEGORY_PREFAB_HOMES || dataCategory === config/* Constants.categoryType.CATEGORY_ZOO */.gT.categoryType.CATEGORY_ZOO || dataCategory === config/* Constants.categoryType.CATEGORY_ANIMAL */.gT.categoryType.CATEGORY_ANIMAL || dataCategory === config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL || dataCategory === config/* Constants.categoryType.CATEGORY_CASINO */.gT.categoryType.CATEGORY_CASINO || dataCategory === config/* Constants.categoryType.CATEGORY_CASTLE */.gT.categoryType.CATEGORY_CASTLE || dataCategory === config/* Constants.categoryType.CATEGORY_RESORT */.gT.categoryType.CATEGORY_RESORT || dataCategory === config/* Constants.categoryType.CATEGORY_APARTHOTEL */.gT.categoryType.CATEGORY_APARTHOTEL || dataCategory === config/* Constants.categoryType.CATEGORY_VENUE_COCKTAIL */.gT.categoryType.CATEGORY_VENUE_COCKTAIL) && viewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "fixed bottom-[170px] right-[16px]",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "w-[60px] h-[60px] rounded-full ".concat((0,formatHelpers/* getClass */.ll)("bg-btn-map", true), " flex justify-center items-center cursor-pointer"),
            onClick: function onClick() {
              setViewMode(config/* Constants.viewType.VIEW_TYPE_LIST */.gT.viewType.VIEW_TYPE_LIST);
              document.body.style.overflow = "auto";
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
              source: config/* Images.iconListColored */.rU.iconListColored,
              width: 32,
              height: 32,
              layout: "fixed"
            })
          })
        })]
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "sm:block hidden wrapper mx-auto",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "flex flex-row flex-1 items-center justify-between ".concat((0,formatHelpers/* getClass */.ll)("background", true)),
          children: ["Venue Cocktail".split(",").find(function (i) {
            return i === "Prefab Home";
          }) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "".concat((dataCategory === null || dataCategory === void 0 ? void 0 : dataCategory.toString()) === ((_Constants$categoryTy = config/* Constants.categoryType.CATEGORY_PREFAB_HOMES */.gT.categoryType.CATEGORY_PREFAB_HOMES) === null || _Constants$categoryTy === void 0 ? void 0 : _Constants$categoryTy.toString()) ? "text-white ".concat((0,formatHelpers/* getClass */.ll)("bg-gray1-active-category", true), " font-bold") : "text-spliterLine font-bold", " text-lg text-center py-4 flex-1 rounded-full cursor-pointer"),
            onClick: function onClick() {
              setSortBy(config/* Constants.sortByAction.SORT_BY_RECOMMENDED */.gT.sortByAction.SORT_BY_RECOMMENDED);
              router.push("/explore/homes");
              setDataCategory(config/* Constants.categoryType.CATEGORY_PREFAB_HOMES */.gT.categoryType.CATEGORY_PREFAB_HOMES);
            },
            children: "HOMES"
          }), "Venue Cocktail".split(",").find(function (i) {
            return i === "Prefab Company";
          }) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "".concat((dataCategory === null || dataCategory === void 0 ? void 0 : dataCategory.toString()) === ((_Constants$categoryTy2 = config/* Constants.categoryType.CATEGORY_PREFAB_COMPANY */.gT.categoryType.CATEGORY_PREFAB_COMPANY) === null || _Constants$categoryTy2 === void 0 ? void 0 : _Constants$categoryTy2.toString()) ? "text-white ".concat((0,formatHelpers/* getClass */.ll)("bg-gray1-active-category", true), " font-bold") : "text-spliterLine font-bold", " text-lg text-center py-4 flex-1 rounded-full cursor-pointer"),
            onClick: function onClick() {
              setSortBy(config/* Constants.sortByAction.SORT_BY_RECOMMENDED */.gT.sortByAction.SORT_BY_RECOMMENDED);
              router.push("/explore/companies");
              setDataCategory(config/* Constants.categoryType.CATEGORY_PREFAB_COMPANY */.gT.categoryType.CATEGORY_PREFAB_COMPANY);
            },
            children: "COMPANIES"
          }), "Venue Cocktail".split(",").find(function (i) {
            return i === "Animals";
          }) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "".concat((dataCategory === null || dataCategory === void 0 ? void 0 : dataCategory.toString()) === ((_Constants$categoryTy3 = config/* Constants.categoryType.CATEGORY_ANIMAL */.gT.categoryType.CATEGORY_ANIMAL) === null || _Constants$categoryTy3 === void 0 ? void 0 : _Constants$categoryTy3.toString()) ? "text-white ".concat((0,formatHelpers/* getClass */.ll)("bg-gray1-active-category", true), " font-bold") : "text-spliterLine font-bold", " text-lg text-center py-4 flex-1 rounded-full cursor-pointer"),
            onClick: function onClick() {
              setSortBy(config/* Constants.sortByAction.SORT_BY_RECOMMENDED */.gT.sortByAction.SORT_BY_RECOMMENDED);
              router.push("/explore/animals");
              setDataCategory(config/* Constants.categoryType.CATEGORY_ANIMAL */.gT.categoryType.CATEGORY_ANIMAL);
            },
            children: "ANIMALS"
          }), "Venue Cocktail".split(",").find(function (i) {
            return i === "Festivals";
          }) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "".concat((dataCategory === null || dataCategory === void 0 ? void 0 : dataCategory.toString()) === ((_Constants$categoryTy4 = config/* Constants.categoryType.CATEGORY_FESTIVAL */.gT.categoryType.CATEGORY_FESTIVAL) === null || _Constants$categoryTy4 === void 0 ? void 0 : _Constants$categoryTy4.toString()) ? "bg-grayBackground font-bold" : "font-bold", " text-lg text-white text-center py-4 flex-1 rounded-full cursor-pointer"),
            onClick: function onClick() {
              setSortBy(config/* Constants.sortByAction.SORT_BY_RECENT */.gT.sortByAction.SORT_BY_RECENT);
              router.push("/explore/festivals");
              setDataCategory(config/* Constants.categoryType.CATEGORY_FESTIVAL */.gT.categoryType.CATEGORY_FESTIVAL);
            },
            children: "FESTIVALS"
          }), "Venue Cocktail".split(",").find(function (i) {
            return i === "Events";
          }) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "".concat((dataCategory === null || dataCategory === void 0 ? void 0 : dataCategory.toString()) === ((_Constants$categoryTy5 = config/* Constants.categoryType.CATEGORY_EVENT */.gT.categoryType.CATEGORY_EVENT) === null || _Constants$categoryTy5 === void 0 ? void 0 : _Constants$categoryTy5.toString()) ? "bg-grayBackground font-bold" : "font-bold", " text-lg text-white text-center py-4 flex-1 rounded-full cursor-pointer"),
            onClick: function onClick() {
              setSortBy(config/* Constants.sortByAction.SORT_BY_RECENT */.gT.sortByAction.SORT_BY_RECENT);
              router.push("/explore/events");
              setDataCategory(config/* Constants.categoryType.CATEGORY_EVENT */.gT.categoryType.CATEGORY_EVENT);
            },
            children: "EVENTS"
          }), "Venue Cocktail".split(",").find(function (i) {
            return i === "Artists";
          }) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "".concat((dataCategory === null || dataCategory === void 0 ? void 0 : dataCategory.toString()) === ((_Constants$categoryTy6 = config/* Constants.categoryType.CATEGORY_ARTIST */.gT.categoryType.CATEGORY_ARTIST) === null || _Constants$categoryTy6 === void 0 ? void 0 : _Constants$categoryTy6.toString()) ? "bg-grayBackground font-bold" : "font-bold", " text-lg text-white text-center py-4 flex-1 rounded-full cursor-pointer"),
            onClick: function onClick() {
              setSortBy(config/* Constants.sortByAction.SORT_BY_POPULARITY */.gT.sortByAction.SORT_BY_POPULARITY);
              router.push("/explore/artists");
              setDataCategory(config/* Constants.categoryType.CATEGORY_ARTIST */.gT.categoryType.CATEGORY_ARTIST);
            },
            children: "ARTISTS"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "flex flex-row ".concat((0,formatHelpers/* getClass */.ll)("background", true), " pt-6 min-h-screen"),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "pt-6 lg:w-335px w-230px",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "sticky top-0",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(filter/* default */.Z, {
                isMobileVersion: false,
                setShowFilter: setShowFilter,
                category: dataCategory,
                setTabList: setTypeModeList,
                tabList: typeModeList,
                keyword: keyword,
                locationDistance: locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.distance,
                locationSelected: locationSelected,
                setLocationSelected: setLocationSelected,
                sortBy: sortBy || (dataCategory === config/* Constants.categoryType.CATEGORY_FESTIVAL */.gT.categoryType.CATEGORY_FESTIVAL || dataCategory === config/* Constants.categoryType.CATEGORY_EVENT */.gT.categoryType.CATEGORY_EVENT ? config/* Constants.sortByAction.SORT_BY_RECENT */.gT.sortByAction.SORT_BY_RECENT : config/* Constants.sortByAction.SORT_BY_POPULARITY */.gT.sortByAction.SORT_BY_POPULARITY),
                filterTabSelected: typeMode,
                filterCriteriaListOriginal: dataCategory === config/* Constants.categoryType.CATEGORY_FESTIVAL */.gT.categoryType.CATEGORY_FESTIVAL ? filterCriteriaListOriginalFestival : dataCategory === config/* Constants.categoryType.CATEGORY_EVENT */.gT.categoryType.CATEGORY_EVENT ? filterCriteriaListOriginalEvent : dataCategory === config/* Constants.categoryType.CATEGORY_ARTIST */.gT.categoryType.CATEGORY_ARTIST ? filterCriteriaListOriginalArtist : dataCategory === config/* Constants.categoryType.CATEGORY_VENUE */.gT.categoryType.CATEGORY_VENUE ? filterCriteriaListOriginalVenue : dataCategory === config/* Constants.categoryType.CATEGORY_ROOFTOP */.gT.categoryType.CATEGORY_ROOFTOP ? filterCriteriaListOriginalRooftop : dataCategory === config/* Constants.categoryType.CATEGORY_SPA */.gT.categoryType.CATEGORY_SPA ? filterCriteriaListOriginalSpa : dataCategory === config/* Constants.categoryType.CATEGORY_VENUE_BEACHFUL */.gT.categoryType.CATEGORY_VENUE_BEACHFUL ? filterCriteriaListOriginalVenueBeachful : dataCategory === config/* Constants.categoryType.CATEGORY_PREFAB_COMPANY */.gT.categoryType.CATEGORY_PREFAB_COMPANY ? filterCriteriaListOriginalPrefabCompany : dataCategory === config/* Constants.categoryType.CATEGORY_PREFAB_HOMES */.gT.categoryType.CATEGORY_PREFAB_HOMES ? filterCriteriaListOriginalPrefabHome : dataCategory === config/* Constants.categoryType.CATEGORY_ZOO */.gT.categoryType.CATEGORY_ZOO ? filterCriteriaListOriginalZoo : dataCategory === config/* Constants.categoryType.CATEGORY_ANIMAL */.gT.categoryType.CATEGORY_ANIMAL ? filterCriteriaListOriginalAnimal : dataCategory === config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL ? filterCriteriaListOriginalParkful : config/* Constants.categoryType.CATEGORY_CASINO */.gT.categoryType.CATEGORY_CASINO ? filterCriteriaListOriginalCasino : config/* Constants.categoryType.CATEGORY_CASTLE */.gT.categoryType.CATEGORY_CASTLE ? filterCriteriaListOriginalCastle : config/* Constants.categoryType.CATEGORY_RESORT */.gT.categoryType.CATEGORY_RESORT ? filterCriteriaListOriginalResort : config/* Constants.categoryType.CATEGORY_APARTHOTEL */.gT.categoryType.CATEGORY_APARTHOTEL ? filterCriteriaListOriginalAparthotel : dataCategory === config/* Constants.categoryType.CATEGORY_VENUE_COCKTAIL */.gT.categoryType.CATEGORY_VENUE_COCKTAIL ? filterCriteriaListOriginalVenueCocktail : filterCriteriaListOriginalVenue,
                setFilterCriteriaListOriginal: function setFilterCriteriaListOriginal(result) {
                  return dataCategory === config/* Constants.categoryType.CATEGORY_FESTIVAL */.gT.categoryType.CATEGORY_FESTIVAL ? setFilterCriteriaListOriginalFestival(result) : dataCategory === config/* Constants.categoryType.CATEGORY_EVENT */.gT.categoryType.CATEGORY_EVENT ? setFilterCriteriaListOriginalEvent(result) : dataCategory === config/* Constants.categoryType.CATEGORY_ARTIST */.gT.categoryType.CATEGORY_ARTIST ? setFilterCriteriaListOriginalArtist(result) : dataCategory === config/* Constants.categoryType.CATEGORY_VENUE */.gT.categoryType.CATEGORY_VENUE ? setFilterCriteriaListOriginalVenue(result) : dataCategory === config/* Constants.categoryType.CATEGORY_ROOFTOP */.gT.categoryType.CATEGORY_ROOFTOP ? setFilterCriteriaListOriginalRooftop(result) : dataCategory === config/* Constants.categoryType.CATEGORY_SPA */.gT.categoryType.CATEGORY_SPA ? setFilterCriteriaListOriginalSpa(result) : dataCategory === config/* Constants.categoryType.CATEGORY_VENUE_BEACHFUL */.gT.categoryType.CATEGORY_VENUE_BEACHFUL ? setFilterCriteriaListOriginalVenueBeachful(result) : dataCategory === config/* Constants.categoryType.CATEGORY_PREFAB_COMPANY */.gT.categoryType.CATEGORY_PREFAB_COMPANY ? setFilterCriteriaListOriginalPrefabCompany(result) : dataCategory === config/* Constants.categoryType.CATEGORY_PREFAB_HOMES */.gT.categoryType.CATEGORY_PREFAB_HOMES ? setFilterCriteriaListOriginalPrefabHome(result) : dataCategory === config/* Constants.categoryType.CATEGORY_ZOO */.gT.categoryType.CATEGORY_ZOO ? setFilterCriteriaListOriginalZoo(result) : dataCategory === config/* Constants.categoryType.CATEGORY_ANIMAL */.gT.categoryType.CATEGORY_ANIMAL ? setFilterCriteriaListOriginalAnimal(result) : dataCategory === config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL ? setFilterCriteriaListOriginalParkful(result) : config/* Constants.categoryType.CATEGORY_CASINO */.gT.categoryType.CATEGORY_CASINO ? setFilterCriteriaListOriginalCasino(result) : config/* Constants.categoryType.CATEGORY_CASTLE */.gT.categoryType.CATEGORY_CASTLE ? setFilterCriteriaListOriginalCastle(result) : config/* Constants.categoryType.CATEGORY_RESORT */.gT.categoryType.CATEGORY_RESORT ? setFilterCriteriaListOriginalResort(result) : config/* Constants.categoryType.CATEGORY_APARTHOTEL */.gT.categoryType.CATEGORY_APARTHOTEL ? setFilterCriteriaListOriginalAparthotel(result) : dataCategory === config/* Constants.categoryType.CATEGORY_VENUE_COCKTAIL */.gT.categoryType.CATEGORY_VENUE_COCKTAIL ? setFilterCriteriaListOriginalVenueCocktail(result) : setFilterCriteriaListOriginalVenue(result);
                },
                onApply: function onApply(filterSelected, filterSelectedOriginal, tabSelected) {
                  router.replace({
                    query: _category_objectSpread(_category_objectSpread({}, router.query), {}, {
                      page: 1
                    })
                  });

                  if (dataCategory === config/* Constants.categoryType.CATEGORY_FESTIVAL */.gT.categoryType.CATEGORY_FESTIVAL) {
                    setFilterCriteriaListSelectedFestival(filterSelected);
                    setFilterCriteriaListOriginalFestival(filterSelectedOriginal);
                    setFilterTabSelectedFestival(tabSelected === null || tabSelected === void 0 ? void 0 : tabSelected.id);
                  } else if (dataCategory === config/* Constants.categoryType.CATEGORY_EVENT */.gT.categoryType.CATEGORY_EVENT) {
                    setFilterCriteriaListSelectedEvent(filterSelected);
                    setFilterCriteriaListOriginalEvent(filterSelectedOriginal);
                    setFilterTabSelectedEvent(tabSelected === null || tabSelected === void 0 ? void 0 : tabSelected.id);
                  } else if (dataCategory === config/* Constants.categoryType.CATEGORY_ARTIST */.gT.categoryType.CATEGORY_ARTIST) {
                    setFilterCriteriaListSelectedArtist(filterSelected);
                    setFilterCriteriaListOriginalArtist(filterSelectedOriginal);
                    setFilterTabSelectedArtist(tabSelected === null || tabSelected === void 0 ? void 0 : tabSelected.id);
                  } else if (dataCategory === config/* Constants.categoryType.CATEGORY_VENUE */.gT.categoryType.CATEGORY_VENUE) {
                    setFilterCriteriaListSelectedVenue(filterSelected);
                    setFilterCriteriaListOriginalVenue(filterSelectedOriginal);
                    setFilterTabSelectedVenue(tabSelected === null || tabSelected === void 0 ? void 0 : tabSelected.id);
                  } else if (dataCategory === config/* Constants.categoryType.CATEGORY_ROOFTOP */.gT.categoryType.CATEGORY_ROOFTOP) {
                    setFilterCriteriaListSelectedRooftop(filterSelected);
                    setFilterCriteriaListOriginalRooftop(filterSelectedOriginal);
                    setFilterTabSelectedRooftop(tabSelected === null || tabSelected === void 0 ? void 0 : tabSelected.id);
                  } else if (dataCategory === config/* Constants.categoryType.CATEGORY_SPA */.gT.categoryType.CATEGORY_SPA) {
                    setFilterCriteriaListSelectedSpa(filterSelected);
                    setFilterCriteriaListOriginalSpa(filterSelectedOriginal);
                    setFilterTabSelectedSpa(tabSelected === null || tabSelected === void 0 ? void 0 : tabSelected.id);
                  } else if (dataCategory === config/* Constants.categoryType.CATEGORY_VENUE_BEACHFUL */.gT.categoryType.CATEGORY_VENUE_BEACHFUL) {
                    setFilterCriteriaListSelectedVenueBeachful(filterSelected);
                    setFilterCriteriaListOriginalVenueBeachful(filterSelectedOriginal);
                    setFilterTabSelectedVenueBeachful(tabSelected === null || tabSelected === void 0 ? void 0 : tabSelected.id);
                  } else if (dataCategory === config/* Constants.categoryType.CATEGORY_PREFAB_COMPANY */.gT.categoryType.CATEGORY_PREFAB_COMPANY) {
                    setFilterCriteriaListSelectedPrefabCompany(filterSelected);
                    setFilterCriteriaListOriginalPrefabCompany(filterSelectedOriginal);
                    setFilterTabSelectedPrefabCompany(tabSelected === null || tabSelected === void 0 ? void 0 : tabSelected.id);
                  } else if (dataCategory === config/* Constants.categoryType.CATEGORY_PREFAB_HOMES */.gT.categoryType.CATEGORY_PREFAB_HOMES) {
                    setFilterCriteriaListSelectedPrefabHome(filterSelected);
                    setFilterCriteriaListOriginalPrefabHome(filterSelectedOriginal);
                    setFilterTabSelectedPrefabHome(tabSelected === null || tabSelected === void 0 ? void 0 : tabSelected.id);
                  } else if (dataCategory === config/* Constants.categoryType.CATEGORY_ZOO */.gT.categoryType.CATEGORY_ZOO) {
                    setFilterCriteriaListSelectedZoo(filterSelected);
                    setFilterCriteriaListOriginalZoo(filterSelectedOriginal);
                    setFilterTabSelectedZoo(tabSelected === null || tabSelected === void 0 ? void 0 : tabSelected.id);
                  } else if (dataCategory === config/* Constants.categoryType.CATEGORY_ANIMAL */.gT.categoryType.CATEGORY_ANIMAL) {
                    setFilterCriteriaListSelectedAnimal(filterSelected);
                    setFilterCriteriaListOriginalAnimal(filterSelectedOriginal);
                    setFilterTabSelectedAnimal(tabSelected === null || tabSelected === void 0 ? void 0 : tabSelected.id);
                  } else if (dataCategory === config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL) {
                    setFilterCriteriaListSelectedParkful(filterSelected);
                    setFilterCriteriaListOriginalParkful(filterSelectedOriginal);
                    setFilterTabSelectedParkful(tabSelected === null || tabSelected === void 0 ? void 0 : tabSelected.id);
                  } else if (dataCategory === config/* Constants.categoryType.CATEGORY_CASINO */.gT.categoryType.CATEGORY_CASINO) {
                    setFilterCriteriaListSelectedCasino(filterSelected);
                    setFilterCriteriaListOriginalCasino(filterSelectedOriginal);
                    setFilterTabSelectedCasino(tabSelected === null || tabSelected === void 0 ? void 0 : tabSelected.id);
                  } else if (dataCategory === config/* Constants.categoryType.CATEGORY_CASTLE */.gT.categoryType.CATEGORY_CASTLE) {
                    setFilterCriteriaListSelectedCastle(filterSelected);
                    setFilterCriteriaListOriginalCastle(filterSelectedOriginal);
                    setFilterTabSelectedCastle(tabSelected === null || tabSelected === void 0 ? void 0 : tabSelected.id);
                  } else if (dataCategory === config/* Constants.categoryType.CATEGORY_RESORT */.gT.categoryType.CATEGORY_RESORT) {
                    setFilterCriteriaListSelectedResort(filterSelected);
                    setFilterCriteriaListOriginalResort(filterSelectedOriginal);
                    setFilterTabSelectedResort(tabSelected === null || tabSelected === void 0 ? void 0 : tabSelected.id);
                  } else if (dataCategory === config/* Constants.categoryType.CATEGORY_APARTHOTEL */.gT.categoryType.CATEGORY_APARTHOTEL) {
                    setFilterCriteriaListSelectedAparthotel(filterSelected);
                    setFilterCriteriaListOriginalAparthotel(filterSelectedOriginal);
                    setFilterTabSelectedAparthotel(tabSelected === null || tabSelected === void 0 ? void 0 : tabSelected.id);
                  } else if (dataCategory === config/* Constants.categoryType.CATEGORY_VENUE_COCKTAIL */.gT.categoryType.CATEGORY_VENUE_COCKTAIL) {
                    setFilterCriteriaListSelectedVenueCocktail(filterSelected);
                    setFilterCriteriaListOriginalVenueCocktail(filterSelectedOriginal);
                    setFilterTabSelectedVenueCocktail(tabSelected === null || tabSelected === void 0 ? void 0 : tabSelected.id);
                  }
                }
              })
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "flex-1",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "flex flex-row flex-1 items-center justify-between ".concat((0,formatHelpers/* getClass */.ll)("background", true), " pb-2 pt-5 pl-8 ").concat(viewMode === config/* Constants.viewType.VIEW_TYPE_OVERVIEW */.gT.viewType.VIEW_TYPE_OVERVIEW ? "pr-8" : ""),
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "relative",
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  // {...buttonPropsTypeMode}
                  className: "".concat((0,formatHelpers/* getClass */.ll)("bg-gray1", true), " text-base text-white font-semibold text-center capitalize py-2 mr-4 w-160px rounded-full"),
                  children: [typeModeList.find(function (item) {
                    return item.value === typeMode;
                  }) ? (_typeModeList$find = typeModeList.find(function (item) {
                    return item.value === typeMode;
                  })) === null || _typeModeList$find === void 0 ? void 0 : _typeModeList$find.title : "ALL", " ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    className: "font-semibold ".concat((0,formatHelpers/* getClass */.ll)("text-gray2", true)),
                    children: dataCategory === config/* Constants.categoryType.CATEGORY_FESTIVAL */.gT.categoryType.CATEGORY_FESTIVAL ? (0,helpers/* nFormatter */.pF)(countFestival) : dataCategory === config/* Constants.categoryType.CATEGORY_EVENT */.gT.categoryType.CATEGORY_EVENT ? (0,helpers/* nFormatter */.pF)(countEvent) : dataCategory === config/* Constants.categoryType.CATEGORY_ARTIST */.gT.categoryType.CATEGORY_ARTIST ? (0,helpers/* nFormatter */.pF)(countArtist) : dataCategory === config/* Constants.categoryType.CATEGORY_ROOFTOP */.gT.categoryType.CATEGORY_ROOFTOP ? (0,helpers/* nFormatter */.pF)(countRooftop) : dataCategory === config/* Constants.categoryType.CATEGORY_SPA */.gT.categoryType.CATEGORY_SPA ? (0,helpers/* nFormatter */.pF)(countSpa) : dataCategory === config/* Constants.categoryType.CATEGORY_VENUE_BEACHFUL */.gT.categoryType.CATEGORY_VENUE_BEACHFUL ? (0,helpers/* nFormatter */.pF)(countVenueBeachful) : dataCategory === config/* Constants.categoryType.CATEGORY_PREFAB_COMPANY */.gT.categoryType.CATEGORY_PREFAB_COMPANY ? (0,helpers/* nFormatter */.pF)(countPrefabCompany) : dataCategory === config/* Constants.categoryType.CATEGORY_PREFAB_HOMES */.gT.categoryType.CATEGORY_PREFAB_HOMES ? (0,helpers/* nFormatter */.pF)(countPrefabHome) : dataCategory === config/* Constants.categoryType.CATEGORY_ZOO */.gT.categoryType.CATEGORY_ZOO ? (0,helpers/* nFormatter */.pF)(countZoo) : dataCategory === config/* Constants.categoryType.CATEGORY_ANIMAL */.gT.categoryType.CATEGORY_ANIMAL ? (0,helpers/* nFormatter */.pF)(countAnimal) : dataCategory === config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL ? (0,helpers/* nFormatter */.pF)(countParkful) : dataCategory === config/* Constants.categoryType.CATEGORY_CASINO */.gT.categoryType.CATEGORY_CASINO ? (0,helpers/* nFormatter */.pF)(countCasino) : dataCategory === config/* Constants.categoryType.CATEGORY_CASTLE */.gT.categoryType.CATEGORY_CASTLE ? (0,helpers/* nFormatter */.pF)(countCastle) : dataCategory === config/* Constants.categoryType.CATEGORY_RESORT */.gT.categoryType.CATEGORY_RESORT ? (0,helpers/* nFormatter */.pF)(countResort) : dataCategory === config/* Constants.categoryType.CATEGORY_APARTHOTEL */.gT.categoryType.CATEGORY_APARTHOTEL ? (0,helpers/* nFormatter */.pF)(countAparthotel) : dataCategory === config/* Constants.categoryType.CATEGORY_VENUE_COCKTAIL */.gT.categoryType.CATEGORY_VENUE_COCKTAIL ? (0,helpers/* nFormatter */.pF)(countVenueCocktail) : (0,helpers/* nFormatter */.pF)(countVenue)
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "".concat(isOpenTypeMode ? "visible" : "", " flex flex-col ").concat((0,formatHelpers/* getClass */.ll)("background", true), " absolute top-[40px] left-0 rounded-2xl z-[999] w-160px border ").concat((0,formatHelpers/* getClass */.ll)("border-spliterLine", true), " py-4"),
                  role: "menu",
                  children: typeModeList.map(function (item, index) {
                    return /*#__PURE__*/(0,react.createElement)("div", _category_objectSpread(_category_objectSpread({}, itemPropsTypeMode[index]), {}, {
                      key: index,
                      className: "text-base font-regular text-center ".concat((0,formatHelpers/* getClass */.ll)("text-white", true), " py-2 cursor-pointer transition-all ").concat((0,formatHelpers/* getClass */.ll)("hover:bg-gray1", true), " ").concat(item.value === typeMode ? "".concat((0,formatHelpers/* getClass */.ll)("bg-gray1LightGray", true)) : ""),
                      onClick: item.onClick
                    }), item.title, " ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      className: "text-placeholder",
                      children: item.count > 99 ? "99+" : item.count || 0
                    }));
                  })
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row items-center",
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "relative",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", _category_objectSpread(_category_objectSpread({}, buttonPropsViewMode), {}, {
                    className: "".concat((0,formatHelpers/* getClass */.ll)("bg-gray1", true), " text-base text-white font-semibold text-center capitalize py-2 mr-4 w-190px rounded-full cursor-pointer"),
                    children: ((_viewModeList$find = viewModeList.find(function (item) {
                      return item.value === viewMode;
                    })) === null || _viewModeList$find === void 0 ? void 0 : _viewModeList$find.title) || "Grid"
                  })), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "".concat(isOpenViewMode ? "visible" : "", " flex flex-col ").concat((0,formatHelpers/* getClass */.ll)("background", true), " absolute top-[40px] left-0 rounded-2xl z-[999] w-190px border ").concat((0,formatHelpers/* getClass */.ll)("border-spliterLine", true), " py-4"),
                    role: "menu",
                    children: viewModeList.map(function (item, index) {
                      return /*#__PURE__*/(0,react.createElement)("div", _category_objectSpread(_category_objectSpread({}, itemPropsViewMode[index]), {}, {
                        key: index,
                        className: "text-base font-regular text-center ".concat((0,formatHelpers/* getClass */.ll)("text-white", true), " py-2 cursor-pointer transition-all ").concat((0,formatHelpers/* getClass */.ll)("hover:bg-gray1", true), " ").concat(item.value === viewMode ? "".concat((0,formatHelpers/* getClass */.ll)("bg-gray1LightGray", true)) : ""),
                        onClick: item.onClick
                      }), item.title);
                    })
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "relative",
                  children: [viewMode === config/* Constants.viewType.VIEW_TYPE_OVERVIEW */.gT.viewType.VIEW_TYPE_OVERVIEW ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "".concat((0,formatHelpers/* getClass */.ll)("bg-gray1", true), " text-base text-white font-semibold text-center capitalize py-2 mr-0 w-190px rounded-full"),
                    children: [sortList.find(function (item) {
                      return item.value === (sortBy || (dataCategory === config/* Constants.categoryType.CATEGORY_FESTIVAL */.gT.categoryType.CATEGORY_FESTIVAL || dataCategory === config/* Constants.categoryType.CATEGORY_EVENT */.gT.categoryType.CATEGORY_EVENT ? config/* Constants.sortByAction.SORT_BY_RECENT */.gT.sortByAction.SORT_BY_RECENT : config/* Constants.sortByAction.SORT_BY_POPULARITY */.gT.sortByAction.SORT_BY_POPULARITY));
                    }) ? (_sortList$find = sortList.find(function (item) {
                      return item.value === (sortBy || (dataCategory === config/* Constants.categoryType.CATEGORY_FESTIVAL */.gT.categoryType.CATEGORY_FESTIVAL || dataCategory === config/* Constants.categoryType.CATEGORY_EVENT */.gT.categoryType.CATEGORY_EVENT ? config/* Constants.sortByAction.SORT_BY_RECENT */.gT.sortByAction.SORT_BY_RECENT : config/* Constants.sortByAction.SORT_BY_POPULARITY */.gT.sortByAction.SORT_BY_POPULARITY));
                    })) === null || _sortList$find === void 0 ? void 0 : _sortList$find.title : "Popularity", " ", ((_sortList$find2 = sortList.find(function (item) {
                      return item.value === (sortBy || (dataCategory === config/* Constants.categoryType.CATEGORY_FESTIVAL */.gT.categoryType.CATEGORY_FESTIVAL || dataCategory === config/* Constants.categoryType.CATEGORY_EVENT */.gT.categoryType.CATEGORY_EVENT ? config/* Constants.sortByAction.SORT_BY_RECENT */.gT.sortByAction.SORT_BY_RECENT : config/* Constants.sortByAction.SORT_BY_POPULARITY */.gT.sortByAction.SORT_BY_POPULARITY));
                    })) === null || _sortList$find2 === void 0 ? void 0 : _sortList$find2.subtitle) && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      className: "text-placeholder",
                      children: (_sortList$find3 = sortList.find(function (item) {
                        return item.value === (sortBy || (dataCategory === config/* Constants.categoryType.CATEGORY_FESTIVAL */.gT.categoryType.CATEGORY_FESTIVAL || dataCategory === config/* Constants.categoryType.CATEGORY_EVENT */.gT.categoryType.CATEGORY_EVENT ? config/* Constants.sortByAction.SORT_BY_RECENT */.gT.sortByAction.SORT_BY_RECENT : config/* Constants.sortByAction.SORT_BY_POPULARITY */.gT.sortByAction.SORT_BY_POPULARITY));
                      })) === null || _sortList$find3 === void 0 ? void 0 : _sortList$find3.subtitle
                    })]
                  }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("div", _category_objectSpread(_category_objectSpread({}, buttonPropsSort), {}, {
                    className: "".concat((0,formatHelpers/* getClass */.ll)("bg-gray1", true), " text-base text-white font-semibold text-center capitalize py-2 mr-0 w-190px rounded-full cursor-pointer"),
                    children: [sortList.find(function (item) {
                      return item.value === (sortBy || (dataCategory === config/* Constants.categoryType.CATEGORY_FESTIVAL */.gT.categoryType.CATEGORY_FESTIVAL || dataCategory === config/* Constants.categoryType.CATEGORY_EVENT */.gT.categoryType.CATEGORY_EVENT ? config/* Constants.sortByAction.SORT_BY_RECENT */.gT.sortByAction.SORT_BY_RECENT : config/* Constants.sortByAction.SORT_BY_POPULARITY */.gT.sortByAction.SORT_BY_POPULARITY));
                    }) ? (_sortList$find4 = sortList.find(function (item) {
                      return item.value === (sortBy || (dataCategory === config/* Constants.categoryType.CATEGORY_FESTIVAL */.gT.categoryType.CATEGORY_FESTIVAL || dataCategory === config/* Constants.categoryType.CATEGORY_EVENT */.gT.categoryType.CATEGORY_EVENT ? config/* Constants.sortByAction.SORT_BY_RECENT */.gT.sortByAction.SORT_BY_RECENT : config/* Constants.sortByAction.SORT_BY_POPULARITY */.gT.sortByAction.SORT_BY_POPULARITY));
                    })) === null || _sortList$find4 === void 0 ? void 0 : _sortList$find4.title : "Popularity", " ", ((_sortList$find5 = sortList.find(function (item) {
                      return item.value === (sortBy || (dataCategory === config/* Constants.categoryType.CATEGORY_FESTIVAL */.gT.categoryType.CATEGORY_FESTIVAL || dataCategory === config/* Constants.categoryType.CATEGORY_EVENT */.gT.categoryType.CATEGORY_EVENT ? config/* Constants.sortByAction.SORT_BY_RECENT */.gT.sortByAction.SORT_BY_RECENT : config/* Constants.sortByAction.SORT_BY_POPULARITY */.gT.sortByAction.SORT_BY_POPULARITY));
                    })) === null || _sortList$find5 === void 0 ? void 0 : _sortList$find5.subtitle) && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      className: "text-placeholder",
                      children: (_sortList$find6 = sortList.find(function (item) {
                        return item.value === (sortBy || (dataCategory === config/* Constants.categoryType.CATEGORY_FESTIVAL */.gT.categoryType.CATEGORY_FESTIVAL || dataCategory === config/* Constants.categoryType.CATEGORY_EVENT */.gT.categoryType.CATEGORY_EVENT ? config/* Constants.sortByAction.SORT_BY_RECENT */.gT.sortByAction.SORT_BY_RECENT : config/* Constants.sortByAction.SORT_BY_POPULARITY */.gT.sortByAction.SORT_BY_POPULARITY));
                      })) === null || _sortList$find6 === void 0 ? void 0 : _sortList$find6.subtitle
                    })]
                  })), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "".concat(isOpenSort ? "visible" : "", " flex flex-col ").concat((0,formatHelpers/* getClass */.ll)("background", true), " absolute top-[40px] left-0 rounded-2xl z-[999] w-190px border ").concat((0,formatHelpers/* getClass */.ll)("border-spliterLine", true), " py-4"),
                    role: "menu",
                    children: sortList.map(function (item, index) {
                      return /*#__PURE__*/(0,react.createElement)("div", _category_objectSpread(_category_objectSpread({}, itemPropsSort[index]), {}, {
                        key: index,
                        className: "text-base font-regular text-center ".concat((0,formatHelpers/* getClass */.ll)("text-white", true), " py-2 cursor-pointer transition-all ").concat((0,formatHelpers/* getClass */.ll)("hover:bg-gray1"), " ").concat(item.value === (sortBy || (dataCategory === config/* Constants.categoryType.CATEGORY_FESTIVAL */.gT.categoryType.CATEGORY_FESTIVAL || dataCategory === config/* Constants.categoryType.CATEGORY_EVENT */.gT.categoryType.CATEGORY_EVENT ? config/* Constants.sortByAction.SORT_BY_RECENT */.gT.sortByAction.SORT_BY_RECENT : config/* Constants.sortByAction.SORT_BY_POPULARITY */.gT.sortByAction.SORT_BY_POPULARITY)) ? "".concat((0,formatHelpers/* getClass */.ll)("bg-gray1LightGray", true)) : ""),
                        onClick: item.onClick
                      }), item.title, " ", item.subtitle && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                        className: "text-placeholder",
                        children: item.subtitle
                      }));
                    })
                  })]
                })]
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "flex flex-row flex-1",
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "pl-8 ".concat(viewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP ? "" : "flex-1"),
                style: {
                  overflow: "hidden"
                },
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(explore_search/* default */.Z, {
                  mapFocused: mapFocused,
                  setMapFocused: setMapFocused,
                  listFestival: itemsFestival,
                  setListFestival: setItemsFestival,
                  listArtist: itemsArtist,
                  setListArtist: setItemsArtist,
                  listEvent: itemsEvent,
                  setListEvent: setItemsEvent,
                  listVenue: itemsVenue,
                  setListVenue: setItemsVenue,
                  listRooftop: itemsRooftop,
                  setListRooftop: setItemsRooftop,
                  listSpa: itemsSpa,
                  setListSpa: setItemsSpa,
                  listVenueBeachful: itemsVenueBeachful,
                  setListVenueBeachful: setItemsVenueBeachful,
                  listPrefabCompany: itemsPrefabCompany,
                  setListPrefabCompany: setItemsPrefabCompany,
                  listPrefabHome: itemsPrefabHome,
                  setListPrefabHome: setItemsPrefabHome,
                  listZoo: itemsZoo,
                  setListZoo: setItemsZoo,
                  listAnimal: itemsAnimal,
                  setListAnimal: setItemsAnimal,
                  listParkful: itemsParkful,
                  setListParkful: setItemsParkful,
                  listCasino: itemsCasino,
                  setListCasino: setItemsCasino,
                  listCastle: itemsCastle,
                  setListCastle: setItemsCastle,
                  listResort: itemsResort,
                  setListResort: setItemsResort,
                  listAparthotel: itemsAparthotel,
                  setListAparthotel: setItemsAparthotel,
                  listVenueCocktail: itemsVenueCocktail,
                  setListVenueCocktail: setItemsVenueCocktail,
                  currentPageIndex: page || 1,
                  countFestival: countFestival,
                  setCountFestival: setCountFestival,
                  countEvent: countEvent,
                  setCountEvent: setCountEvent,
                  countArtist: countArtist,
                  setCountArtist: setCountArtist,
                  countVenue: countVenue,
                  setCountVenue: setCountVenue,
                  countRooftop: countRooftop,
                  setCountRooftop: setCountRooftop,
                  countSpa: countSpa,
                  setCountSpa: setCountSpa,
                  countVenueBeachful: countVenueBeachful,
                  setCountVenueBeachful: setCountVenueBeachful,
                  countPrefabCompany: countPrefabCompany,
                  setCountPrefabCompany: setCountPrefabCompany,
                  countPrefabHome: countPrefabHome,
                  setCountPrefabHome: setCountPrefabHome,
                  countZoo: countZoo,
                  setCountZoo: setCountZoo,
                  countAnimal: countAnimal,
                  setCountAnimal: setCountAnimal,
                  countParkful: countParkful,
                  setCountParkful: setCountParkful,
                  countCasino: countCasino,
                  setCountCasino: setCountCasino,
                  countCastle: countCastle,
                  setCountCastle: setCountCastle,
                  countResort: countResort,
                  setCountResort: setCountResort,
                  countAparthotel: countAparthotel,
                  setCountAparthotel: setCountAparthotel,
                  countVenueCocktail: countVenueCocktail,
                  setCountVenueCocktail: setCountVenueCocktail,
                  passViewMode: viewMode,
                  keyword: keyword,
                  setKeyword: setKeyword,
                  dataCategory: dataCategory,
                  setDataCategory: setDataCategory,
                  locationSelected: locationSelected,
                  setLocationSelected: setLocationSelected,
                  isMobileVersion: false,
                  sortBy: getSortBy(),
                  typeMode: typeMode,
                  setSortBy: setSortBy // Festival
                  ,
                  filterCriteriaListOriginalFestival: filterCriteriaListOriginalFestival,
                  setFilterCriteriaListOriginalFestival: setFilterCriteriaListOriginalFestival,
                  filterCriteriaListSelectedFestival: filterCriteriaListSelectedFestival,
                  setFilterCriteriaListSelectedFestival: setFilterCriteriaListSelectedFestival,
                  filterTabSelectedFestival: typeMode,
                  setFilterTabSelectedFestival: setFilterTabSelectedFestival // Artist
                  ,
                  filterCriteriaListOriginalArtist: filterCriteriaListOriginalArtist,
                  setFilterCriteriaListOriginalArtist: setFilterCriteriaListOriginalArtist,
                  filterCriteriaListSelectedArtist: filterCriteriaListSelectedArtist,
                  setFilterCriteriaListSelectedArtist: setFilterCriteriaListSelectedArtist,
                  filterTabSelectedArtist: typeMode,
                  setFilterTabSelectedArtist: setFilterTabSelectedArtist // Venue
                  ,
                  filterCriteriaListOriginalVenue: filterCriteriaListOriginalVenue,
                  setFilterCriteriaListOriginalVenue: setFilterCriteriaListOriginalVenue,
                  filterCriteriaListSelectedVenue: filterCriteriaListSelectedVenue,
                  setFilterCriteriaListSelectedVenue: setFilterCriteriaListSelectedVenue,
                  filterTabSelectedVenue: typeMode,
                  setFilterTabSelectedVenue: setFilterTabSelectedVenue // Rooftop
                  ,
                  filterCriteriaListOriginalRooftop: filterCriteriaListOriginalRooftop,
                  setFilterCriteriaListOriginalRooftop: setFilterCriteriaListOriginalRooftop,
                  filterCriteriaListSelectedRooftop: filterCriteriaListSelectedRooftop,
                  setFilterCriteriaListSelectedRooftop: setFilterCriteriaListSelectedRooftop,
                  filterTabSelectedRooftop: typeMode,
                  setFilterTabSelectedRooftop: setFilterTabSelectedRooftop // Spa
                  ,
                  filterCriteriaListOriginalSpa: filterCriteriaListOriginalSpa,
                  setFilterCriteriaListOriginalSpa: setFilterCriteriaListOriginalSpa,
                  filterCriteriaListSelectedSpa: filterCriteriaListSelectedSpa,
                  setFilterCriteriaListSelectedSpa: setFilterCriteriaListSelectedSpa,
                  filterTabSelectedSpa: typeMode,
                  setFilterTabSelectedSpa: setFilterTabSelectedSpa // Venue Beachful
                  ,
                  filterCriteriaListOriginalVenueBeachful: filterCriteriaListOriginalVenueBeachful,
                  setFilterCriteriaListOriginalVenueBeachful: setFilterCriteriaListOriginalVenueBeachful,
                  filterCriteriaListSelectedVenueBeachful: filterCriteriaListSelectedVenueBeachful,
                  setFilterCriteriaListSelectedVenueBeachful: setFilterCriteriaListSelectedVenueBeachful,
                  filterTabSelectedVenueBeachful: typeMode,
                  setFilterTabSelectedVenueBeachful: setFilterTabSelectedVenueBeachful // Prefab Company
                  ,
                  filterCriteriaListOriginalPrefabCompany: filterCriteriaListOriginalPrefabCompany,
                  setFilterCriteriaListOriginalPrefabCompany: setFilterCriteriaListOriginalPrefabCompany,
                  filterCriteriaListSelectedPrefabCompany: filterCriteriaListSelectedPrefabCompany,
                  setFilterCriteriaListSelectedPrefabCompany: setFilterCriteriaListSelectedPrefabCompany,
                  filterTabSelectedPrefabCompany: typeMode,
                  setFilterTabSelectedPrefabCompany: setFilterTabSelectedPrefabCompany // Prefab Home
                  ,
                  filterCriteriaListOriginalPrefabHome: filterCriteriaListOriginalPrefabHome,
                  setFilterCriteriaListOriginalPrefabHome: setFilterCriteriaListOriginalPrefabHome,
                  filterCriteriaListSelectedPrefabHome: filterCriteriaListSelectedPrefabHome,
                  setFilterCriteriaListSelectedPrefabHome: setFilterCriteriaListSelectedPrefabHome,
                  filterTabSelectedPrefabHome: typeMode,
                  setFilterTabSelectedPrefabHome: setFilterTabSelectedPrefabHome // Zoo
                  ,
                  filterCriteriaListOriginalZoo: filterCriteriaListOriginalZoo,
                  setFilterCriteriaListOriginalZoo: setFilterCriteriaListOriginalZoo,
                  filterCriteriaListSelectedZoo: filterCriteriaListSelectedZoo,
                  setFilterCriteriaListSelectedZoo: setFilterCriteriaListSelectedZoo,
                  filterTabSelectedZoo: typeMode,
                  setFilterTabSelectedZoo: setFilterTabSelectedZoo // Animal
                  ,
                  filterCriteriaListOriginalAnimal: filterCriteriaListOriginalAnimal,
                  setFilterCriteriaListOriginalAnimal: setFilterCriteriaListOriginalAnimal,
                  filterCriteriaListSelectedAnimal: filterCriteriaListSelectedAnimal,
                  setFilterCriteriaListSelectedAnimal: setFilterCriteriaListSelectedAnimal,
                  filterTabSelectedAnimal: typeMode,
                  setFilterTabSelectedAnimal: setFilterTabSelectedAnimal // Parkful
                  ,
                  filterCriteriaListOriginalParkful: filterCriteriaListOriginalParkful,
                  setFilterCriteriaListOriginalParkful: setFilterCriteriaListOriginalParkful,
                  filterCriteriaListSelectedParkful: filterCriteriaListSelectedParkful,
                  setFilterCriteriaListSelectedParkful: setFilterCriteriaListSelectedParkful,
                  filterTabSelectedParkful: typeMode,
                  setFilterTabSelectedParkful: setFilterTabSelectedParkful // Casino
                  ,
                  filterCriteriaListOriginalCasino: filterCriteriaListOriginalCasino,
                  setFilterCriteriaListOriginalCasino: setFilterCriteriaListOriginalCasino,
                  filterCriteriaListSelectedCasino: filterCriteriaListSelectedCasino,
                  setFilterCriteriaListSelectedCasino: setFilterCriteriaListSelectedCasino,
                  filterTabSelectedCasino: typeMode,
                  setFilterTabSelectedCasino: setFilterTabSelectedCasino // Castle
                  ,
                  filterCriteriaListOriginalCastle: filterCriteriaListOriginalCastle,
                  setFilterCriteriaListOriginalCastle: setFilterCriteriaListOriginalCastle,
                  filterCriteriaListSelectedCastle: filterCriteriaListSelectedCastle,
                  setFilterCriteriaListSelectedCastle: setFilterCriteriaListSelectedCastle,
                  filterTabSelectedCastle: typeMode,
                  setFilterTabSelectedCastle: setFilterTabSelectedCastle // Resort
                  ,
                  filterCriteriaListOriginalResort: filterCriteriaListOriginalResort,
                  setFilterCriteriaListOriginalResort: setFilterCriteriaListOriginalResort,
                  filterCriteriaListSelectedResort: filterCriteriaListSelectedResort,
                  setFilterCriteriaListSelectedResort: setFilterCriteriaListSelectedResort,
                  filterTabSelectedResort: typeMode,
                  setFilterTabSelectedResort: setFilterTabSelectedResort // Aparthotel
                  ,
                  filterCriteriaListOriginalAparthotel: filterCriteriaListOriginalAparthotel,
                  setFilterCriteriaListOriginalAparthotel: setFilterCriteriaListOriginalAparthotel,
                  filterCriteriaListSelectedAparthotel: filterCriteriaListSelectedAparthotel,
                  setFilterCriteriaListSelectedAparthotel: setFilterCriteriaListSelectedAparthotel,
                  filterTabSelectedAparthotel: typeMode,
                  setFilterTabSelectedAparthotel: setFilterTabSelectedAparthotel // Venue Cocktail
                  ,
                  filterCriteriaListOriginalVenueCocktail: filterCriteriaListOriginalVenueCocktail,
                  setFilterCriteriaListOriginalVenueCocktail: setFilterCriteriaListOriginalVenueCocktail,
                  filterCriteriaListSelectedVenueCocktail: filterCriteriaListSelectedVenueCocktail,
                  setFilterCriteriaListSelectedVenueCocktail: setFilterCriteriaListSelectedVenueCocktail,
                  filterTabSelectedVenueCocktail: typeMode,
                  setFilterTabSelectedVenueCocktail: setFilterTabSelectedVenueCocktail
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  style: {
                    marginTop: 80
                  }
                })]
              }), viewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "flex-1 pl-3",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "sticky top-0 h-550px w-full py-4",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(DynamicMap, {
                    region: {
                      latitude: 51.495907,
                      longitude: -0.180144,
                      latitudeDelta: 0.0922,
                      longitudeDelta: 0.0421
                    },
                    items: dataCategory === config/* Constants.categoryType.CATEGORY_FESTIVAL */.gT.categoryType.CATEGORY_FESTIVAL ? itemsFestival.filter(function (i) {
                      return i.latitude;
                    }) : dataCategory === config/* Constants.categoryType.CATEGORY_EVENT */.gT.categoryType.CATEGORY_EVENT ? itemsEvent.filter(function (i) {
                      return i.latitude;
                    }) : dataCategory === config/* Constants.categoryType.CATEGORY_ROOFTOP */.gT.categoryType.CATEGORY_ROOFTOP ? itemsRooftop.filter(function (i) {
                      return i.latitude;
                    }) : dataCategory === config/* Constants.categoryType.CATEGORY_SPA */.gT.categoryType.CATEGORY_SPA ? itemsSpa.filter(function (i) {
                      return i.latitude;
                    }) : dataCategory === config/* Constants.categoryType.CATEGORY_VENUE_BEACHFUL */.gT.categoryType.CATEGORY_VENUE_BEACHFUL ? itemsVenueBeachful.filter(function (i) {
                      return i.latitude;
                    }) : dataCategory === config/* Constants.categoryType.CATEGORY_PREFAB_COMPANY */.gT.categoryType.CATEGORY_PREFAB_COMPANY ? itemsPrefabCompany.filter(function (i) {
                      return i.latitude;
                    }) : dataCategory === config/* Constants.categoryType.CATEGORY_PREFAB_HOMES */.gT.categoryType.CATEGORY_PREFAB_HOMES ? itemsPrefabHome.filter(function (i) {
                      return i.latitude;
                    }) : dataCategory === config/* Constants.categoryType.CATEGORY_ZOO */.gT.categoryType.CATEGORY_ZOO ? itemsZoo.filter(function (i) {
                      return i.latitude;
                    }) : dataCategory === config/* Constants.categoryType.CATEGORY_ANIMAL */.gT.categoryType.CATEGORY_ANIMAL ? itemsAnimal.filter(function (i) {
                      return i.latitude;
                    }) : dataCategory === config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL ? itemsParkful.filter(function (i) {
                      return i.latitude;
                    }) : dataCategory === config/* Constants.categoryType.CATEGORY_CASINO */.gT.categoryType.CATEGORY_CASINO ? itemsCasino.filter(function (i) {
                      return i.latitude;
                    }) : dataCategory === config/* Constants.categoryType.CATEGORY_CASTLE */.gT.categoryType.CATEGORY_CASTLE ? itemsCastle.filter(function (i) {
                      return i.latitude;
                    }) : dataCategory === config/* Constants.categoryType.CATEGORY_RESORT */.gT.categoryType.CATEGORY_RESORT ? itemsResort.filter(function (i) {
                      return i.latitude;
                    }) : dataCategory === config/* Constants.categoryType.CATEGORY_APARTHOTEL */.gT.categoryType.CATEGORY_APARTHOTEL ? itemsAparthotel.filter(function (i) {
                      return i.latitude;
                    }) : dataCategory === config/* Constants.categoryType.CATEGORY_VENUE_COCKTAIL */.gT.categoryType.CATEGORY_VENUE_COCKTAIL ? itemsVenueCocktail.filter(function (i) {
                      return i.latitude;
                    }) : itemsVenue.filter(function (i) {
                      return i.latitude;
                    }),
                    category: dataCategory,
                    selectedItem: mapFocused,
                    setSelectedItem: setMapFocused
                  })
                })
              })]
            })]
          })]
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "sm:block hidden",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      id: "btn-back-to-top",
      href: "#",
      className: "".concat((0,formatHelpers/* getClass */.ll)("bg-arrow-top", true), " hidden justify-center items-center w-12 h-12 fixed bottom-0 shadow right-0 z-10 mx-4 my-8 cursor-pointer rounded-full"),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        src: "/icons/".concat( true ? ((_process$env$NEXT_PUB2 = "Cocktayl") === null || _process$env$NEXT_PUB2 === void 0 ? void 0 : (_process$env$NEXT_PUB3 = _process$env$NEXT_PUB2.replace(" ", "")) === null || _process$env$NEXT_PUB3 === void 0 ? void 0 : _process$env$NEXT_PUB3.toLowerCase()) + "/" : 0, "ic_arrow_top.png"),
        width: "16",
        alt: "icon back to top"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* LocationModal */.F8, {
      ref: locationModal,
      category: dataCategory,
      locationSelected: locationSelected,
      distanceValue: locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.distance,
      isDistance: true,
      isShowState: true,
      onPressApply: function onPressApply(location, distance) {
        router.replace({
          query: _category_objectSpread(_category_objectSpread({}, router.query), {}, {
            page: 1
          })
        });
        setLocationSelected(_category_objectSpread(_category_objectSpread({}, location), {}, {
          distance: distance
        }));

        if (locationModal) {
          locationModal.current.hideModal();
        }
      },
      onPressCancel: function onPressCancel() {
        if (locationModal) {
          locationModal.current.hideModal();
        }
      },
      isMobileVersion: true
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* SingleSelectModal */.c2, {
      ref: sortMenuModal,
      icon: config/* Images.iconSortColored */.rU.iconSortColored,
      title: t("key_sort"),
      checkedItemId: sortBy,
      items: sortMenu.filter(function (item) {
        return item.isHide === false;
      }),
      onPressItem: function onPressItem(item) {
        setSortBy(item.id);

        if (sortMenuModal) {
          sortMenuModal.current.hideModal();
        }
      },
      isMobileVersion: true
    }), config/* Values.deviceWidth */.$m.deviceWidth < 640 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "md:hidden ".concat(showFilter ? "fixed" : "hidden", " w-full h-full top-0 left-0 z-999"),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(filter/* default */.Z, {
        isMobileVersion: true,
        setShowFilter: setShowFilter,
        category: dataCategory,
        setTabList: setTypeModeList,
        tabList: typeModeList,
        keyword: keyword,
        locationDistance: locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.distance,
        locationSelected: locationSelected,
        setLocationSelected: setLocationSelected,
        sortBy: sortBy || (dataCategory === config/* Constants.categoryType.CATEGORY_FESTIVAL */.gT.categoryType.CATEGORY_FESTIVAL || dataCategory === config/* Constants.categoryType.CATEGORY_EVENT */.gT.categoryType.CATEGORY_EVENT ? config/* Constants.sortByAction.SORT_BY_RECENT */.gT.sortByAction.SORT_BY_RECENT : config/* Constants.sortByAction.SORT_BY_POPULARITY */.gT.sortByAction.SORT_BY_POPULARITY),
        filterTabSelected: typeMode,
        filterCriteriaListOriginal: dataCategory === config/* Constants.categoryType.CATEGORY_FESTIVAL */.gT.categoryType.CATEGORY_FESTIVAL ? filterCriteriaListOriginalFestival : dataCategory === config/* Constants.categoryType.CATEGORY_EVENT */.gT.categoryType.CATEGORY_EVENT ? filterCriteriaListOriginalEvent : dataCategory === config/* Constants.categoryType.CATEGORY_ARTIST */.gT.categoryType.CATEGORY_ARTIST ? filterCriteriaListOriginalArtist : dataCategory === config/* Constants.categoryType.CATEGORY_VENUE */.gT.categoryType.CATEGORY_VENUE ? filterCriteriaListOriginalVenue : dataCategory === config/* Constants.categoryType.CATEGORY_ROOFTOP */.gT.categoryType.CATEGORY_ROOFTOP ? filterCriteriaListOriginalRooftop : dataCategory === config/* Constants.categoryType.CATEGORY_SPA */.gT.categoryType.CATEGORY_SPA ? filterCriteriaListOriginalSpa : dataCategory === config/* Constants.categoryType.CATEGORY_VENUE_BEACHFUL */.gT.categoryType.CATEGORY_VENUE_BEACHFUL ? filterCriteriaListOriginalVenueBeachful : dataCategory === config/* Constants.categoryType.CATEGORY_PREFAB_COMPANY */.gT.categoryType.CATEGORY_PREFAB_COMPANY ? filterCriteriaListOriginalPrefabCompany : dataCategory === config/* Constants.categoryType.CATEGORY_PREFAB_HOMES */.gT.categoryType.CATEGORY_PREFAB_HOMES ? filterCriteriaListOriginalPrefabHome : dataCategory === config/* Constants.categoryType.CATEGORY_ZOO */.gT.categoryType.CATEGORY_ZOO ? filterCriteriaListOriginalZoo : dataCategory === config/* Constants.categoryType.CATEGORY_ANIMAL */.gT.categoryType.CATEGORY_ANIMAL ? filterCriteriaListOriginalAnimal : dataCategory === config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL ? filterCriteriaListOriginalParkful : dataCategory === config/* Constants.categoryType.CATEGORY_CASINO */.gT.categoryType.CATEGORY_CASINO ? filterCriteriaListOriginalCasino : dataCategory === config/* Constants.categoryType.CATEGORY_CASTLE */.gT.categoryType.CATEGORY_CASTLE ? filterCriteriaListOriginalCastle : dataCategory === config/* Constants.categoryType.CATEGORY_RESORT */.gT.categoryType.CATEGORY_RESORT ? filterCriteriaListOriginalResort : dataCategory === config/* Constants.categoryType.CATEGORY_APARTHOTEL */.gT.categoryType.CATEGORY_APARTHOTEL ? filterCriteriaListOriginalAparthotel : dataCategory === config/* Constants.categoryType.CATEGORY_VENUE_COCKTAIL */.gT.categoryType.CATEGORY_VENUE_COCKTAIL ? filterCriteriaListOriginalVenueCocktail : filterCriteriaListOriginalVenue,
        setFilterCriteriaListOriginal: function setFilterCriteriaListOriginal(result) {
          return dataCategory === config/* Constants.categoryType.CATEGORY_FESTIVAL */.gT.categoryType.CATEGORY_FESTIVAL ? setFilterCriteriaListOriginalFestival(result) : dataCategory === config/* Constants.categoryType.CATEGORY_EVENT */.gT.categoryType.CATEGORY_EVENT ? setFilterCriteriaListOriginalEvent(result) : dataCategory === config/* Constants.categoryType.CATEGORY_ARTIST */.gT.categoryType.CATEGORY_ARTIST ? setFilterCriteriaListOriginalArtist(result) : dataCategory === config/* Constants.categoryType.CATEGORY_VENUE */.gT.categoryType.CATEGORY_VENUE ? setFilterCriteriaListOriginalVenue(result) : dataCategory === config/* Constants.categoryType.CATEGORY_ROOFTOP */.gT.categoryType.CATEGORY_ROOFTOP ? setFilterCriteriaListOriginalRooftop(result) : dataCategory === config/* Constants.categoryType.CATEGORY_SPA */.gT.categoryType.CATEGORY_SPA ? setFilterCriteriaListOriginalSpa(result) : dataCategory === config/* Constants.categoryType.CATEGORY_VENUE_BEACHFUL */.gT.categoryType.CATEGORY_VENUE_BEACHFUL ? setFilterCriteriaListOriginalVenueBeachful(result) : dataCategory === config/* Constants.categoryType.CATEGORY_PREFAB_COMPANY */.gT.categoryType.CATEGORY_PREFAB_COMPANY ? setFilterCriteriaListOriginalPrefabCompany(result) : dataCategory === config/* Constants.categoryType.CATEGORY_PREFAB_HOMES */.gT.categoryType.CATEGORY_PREFAB_HOMES ? setFilterCriteriaListOriginalPrefabHome(result) : dataCategory === config/* Constants.categoryType.CATEGORY_ZOO */.gT.categoryType.CATEGORY_ZOO ? setFilterCriteriaListOriginalZoo(result) : dataCategory === config/* Constants.categoryType.CATEGORY_ANIMAL */.gT.categoryType.CATEGORY_ANIMAL ? setFilterCriteriaListOriginalAnimal(result) : dataCategory === config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL ? setFilterCriteriaListOriginalParkful(result) : dataCategory === config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL ? setFilterCriteriaListOriginalParkful(result) : dataCategory === config/* Constants.categoryType.CATEGORY_VENUE_COCKTAIL */.gT.categoryType.CATEGORY_VENUE_COCKTAIL ? setFilterCriteriaListOriginalVenueCocktail(result) : setFilterCriteriaListOriginalVenue(result);
        },
        onApply: function onApply(filterSelected, filterSelectedOriginal, tabSelected) {
          router.replace({
            query: _category_objectSpread(_category_objectSpread({}, router.query), {}, {
              page: 1
            })
          });

          if (dataCategory === config/* Constants.categoryType.CATEGORY_FESTIVAL */.gT.categoryType.CATEGORY_FESTIVAL) {
            setFilterCriteriaListSelectedFestival(filterSelected);
            setFilterCriteriaListOriginalFestival(filterSelectedOriginal);
            setFilterTabSelectedFestival(tabSelected === null || tabSelected === void 0 ? void 0 : tabSelected.id);
          } else if (dataCategory === config/* Constants.categoryType.CATEGORY_EVENT */.gT.categoryType.CATEGORY_EVENT) {
            setFilterCriteriaListSelectedEvent(filterSelected);
            setFilterCriteriaListOriginalEvent(filterSelectedOriginal);
            setFilterTabSelectedEvent(tabSelected === null || tabSelected === void 0 ? void 0 : tabSelected.id);
          } else if (dataCategory === config/* Constants.categoryType.CATEGORY_ARTIST */.gT.categoryType.CATEGORY_ARTIST) {
            setFilterCriteriaListSelectedArtist(filterSelected);
            setFilterCriteriaListOriginalArtist(filterSelectedOriginal);
            setFilterTabSelectedArtist(tabSelected === null || tabSelected === void 0 ? void 0 : tabSelected.id);
          } else if (dataCategory === config/* Constants.categoryType.CATEGORY_VENUE */.gT.categoryType.CATEGORY_VENUE) {
            setFilterCriteriaListSelectedVenue(filterSelected);
            setFilterCriteriaListOriginalVenue(filterSelectedOriginal);
            setFilterTabSelectedVenue(tabSelected === null || tabSelected === void 0 ? void 0 : tabSelected.id);
          } else if (dataCategory === config/* Constants.categoryType.CATEGORY_ROOFTOP */.gT.categoryType.CATEGORY_ROOFTOP) {
            setFilterCriteriaListSelectedRooftop(filterSelected);
            setFilterCriteriaListOriginalRooftop(filterSelectedOriginal);
            setFilterTabSelectedRooftop(tabSelected === null || tabSelected === void 0 ? void 0 : tabSelected.id);
          } else if (dataCategory === config/* Constants.categoryType.CATEGORY_SPA */.gT.categoryType.CATEGORY_SPA) {
            setFilterCriteriaListSelectedSpa(filterSelected);
            setFilterCriteriaListOriginalSpa(filterSelectedOriginal);
            setFilterTabSelectedSpa(tabSelected === null || tabSelected === void 0 ? void 0 : tabSelected.id);
          } else if (dataCategory === config/* Constants.categoryType.CATEGORY_VENUE_BEACHFUL */.gT.categoryType.CATEGORY_VENUE_BEACHFUL) {
            setFilterCriteriaListSelectedVenueBeachful(filterSelected);
            setFilterCriteriaListOriginalVenueBeachful(filterSelectedOriginal);
            setFilterTabSelectedVenueBeachful(tabSelected === null || tabSelected === void 0 ? void 0 : tabSelected.id);
          } else if (dataCategory === config/* Constants.categoryType.CATEGORY_PREFAB_COMPANY */.gT.categoryType.CATEGORY_PREFAB_COMPANY) {
            setFilterCriteriaListSelectedPrefabCompany(filterSelected);
            setFilterCriteriaListOriginalPrefabCompany(filterSelectedOriginal);
            setFilterTabSelectedPrefabCompany(tabSelected === null || tabSelected === void 0 ? void 0 : tabSelected.id);
          } else if (dataCategory === config/* Constants.categoryType.CATEGORY_PREFAB_HOMES */.gT.categoryType.CATEGORY_PREFAB_HOMES) {
            setFilterCriteriaListSelectedPrefabHome(filterSelected);
            setFilterCriteriaListOriginalPrefabHome(filterSelectedOriginal);
            setFilterTabSelectedPrefabHome(tabSelected === null || tabSelected === void 0 ? void 0 : tabSelected.id);
          } else if (dataCategory === config/* Constants.categoryType.CATEGORY_ZOO */.gT.categoryType.CATEGORY_ZOO) {
            setFilterCriteriaListSelectedZoo(filterSelected);
            setFilterCriteriaListOriginalZoo(filterSelectedOriginal);
            setFilterTabSelectedZoo(tabSelected === null || tabSelected === void 0 ? void 0 : tabSelected.id);
          } else if (dataCategory === config/* Constants.categoryType.CATEGORY_ANIMAL */.gT.categoryType.CATEGORY_ANIMAL) {
            setFilterCriteriaListSelectedAnimal(filterSelected);
            setFilterCriteriaListOriginalAnimal(filterSelectedOriginal);
            setFilterTabSelectedAnimal(tabSelected === null || tabSelected === void 0 ? void 0 : tabSelected.id);
          } else if (dataCategory === config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL) {
            setFilterCriteriaListSelectedParkful(filterSelected);
            setFilterCriteriaListOriginalParkful(filterSelectedOriginal);
            setFilterTabSelectedParkful(tabSelected === null || tabSelected === void 0 ? void 0 : tabSelected.id);
          } else if (dataCategory === config/* Constants.categoryType.CATEGORY_CASINO */.gT.categoryType.CATEGORY_CASINO) {
            setFilterCriteriaListSelectedCasino(filterSelected);
            setFilterCriteriaListOriginalCasino(filterSelectedOriginal);
            setFilterTabSelectedCasino(tabSelected === null || tabSelected === void 0 ? void 0 : tabSelected.id);
          } else if (dataCategory === config/* Constants.categoryType.CATEGORY_CASTLE */.gT.categoryType.CATEGORY_CASTLE) {
            setFilterCriteriaListSelectedCastle(filterSelected);
            setFilterCriteriaListOriginalCastle(filterSelectedOriginal);
            setFilterTabSelectedCastle(tabSelected === null || tabSelected === void 0 ? void 0 : tabSelected.id);
          } else if (dataCategory === config/* Constants.categoryType.CATEGORY_RESORT */.gT.categoryType.CATEGORY_RESORT) {
            setFilterCriteriaListSelectedResort(filterSelected);
            setFilterCriteriaListOriginalResort(filterSelectedOriginal);
            setFilterTabSelectedResort(tabSelected === null || tabSelected === void 0 ? void 0 : tabSelected.id);
          } else if (dataCategory === config/* Constants.categoryType.CATEGORY_APARTHOTEL */.gT.categoryType.CATEGORY_APARTHOTEL) {
            setFilterCriteriaListSelectedAparthotel(filterSelected);
            setFilterCriteriaListOriginalAparthotel(filterSelectedOriginal);
            setFilterTabSelectedAparthotel(tabSelected === null || tabSelected === void 0 ? void 0 : tabSelected.id);
          } else if (dataCategory === config/* Constants.categoryType.CATEGORY_VENUE_COCKTAIL */.gT.categoryType.CATEGORY_VENUE_COCKTAIL) {
            setFilterCriteriaListSelectedVenueCocktail(filterSelected);
            setFilterCriteriaListOriginalVenueCocktail(filterSelectedOriginal);
            setFilterTabSelectedVenueCocktail(tabSelected === null || tabSelected === void 0 ? void 0 : tabSelected.id);
          }
        }
      })
    })]
  });
};

var __N_SSP = true;
/* harmony default export */ var _category_ = (Festivals);

/***/ }),

/***/ 47275:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/explore/[category]",
      function () {
        return __webpack_require__(72281);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 45338:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QS": function() { return /* binding */ useSwipeable; }
/* harmony export */ });
/* unused harmony exports DOWN, LEFT, RIGHT, UP */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


const LEFT = "Left";
const RIGHT = "Right";
const UP = "Up";
const DOWN = "Down";

/* global document */
const defaultProps = {
    delta: 10,
    preventScrollOnSwipe: false,
    rotationAngle: 0,
    trackMouse: false,
    trackTouch: true,
    swipeDuration: Infinity,
    touchEventOptions: { passive: true },
};
const initialState = {
    first: true,
    initial: [0, 0],
    start: 0,
    swiping: false,
    xy: [0, 0],
};
const mouseMove = "mousemove";
const mouseUp = "mouseup";
const touchEnd = "touchend";
const touchMove = "touchmove";
const touchStart = "touchstart";
function getDirection(absX, absY, deltaX, deltaY) {
    if (absX > absY) {
        if (deltaX > 0) {
            return RIGHT;
        }
        return LEFT;
    }
    else if (deltaY > 0) {
        return DOWN;
    }
    return UP;
}
function rotateXYByAngle(pos, angle) {
    if (angle === 0)
        return pos;
    const angleInRadians = (Math.PI / 180) * angle;
    const x = pos[0] * Math.cos(angleInRadians) + pos[1] * Math.sin(angleInRadians);
    const y = pos[1] * Math.cos(angleInRadians) - pos[0] * Math.sin(angleInRadians);
    return [x, y];
}
function getHandlers(set, handlerProps) {
    const onStart = (event) => {
        const isTouch = "touches" in event;
        // if more than a single touch don't track, for now...
        if (isTouch && event.touches.length > 1)
            return;
        set((state, props) => {
            // setup mouse listeners on document to track swipe since swipe can leave container
            if (props.trackMouse && !isTouch) {
                document.addEventListener(mouseMove, onMove);
                document.addEventListener(mouseUp, onUp);
            }
            const { clientX, clientY } = isTouch ? event.touches[0] : event;
            const xy = rotateXYByAngle([clientX, clientY], props.rotationAngle);
            props.onTouchStartOrOnMouseDown &&
                props.onTouchStartOrOnMouseDown({ event });
            return Object.assign(Object.assign(Object.assign({}, state), initialState), { initial: xy.slice(), xy, start: event.timeStamp || 0 });
        });
    };
    const onMove = (event) => {
        set((state, props) => {
            const isTouch = "touches" in event;
            // Discount a swipe if additional touches are present after
            // a swipe has started.
            if (isTouch && event.touches.length > 1) {
                return state;
            }
            // if swipe has exceeded duration stop tracking
            if (event.timeStamp - state.start > props.swipeDuration) {
                return state.swiping ? Object.assign(Object.assign({}, state), { swiping: false }) : state;
            }
            const { clientX, clientY } = isTouch ? event.touches[0] : event;
            const [x, y] = rotateXYByAngle([clientX, clientY], props.rotationAngle);
            const deltaX = x - state.xy[0];
            const deltaY = y - state.xy[1];
            const absX = Math.abs(deltaX);
            const absY = Math.abs(deltaY);
            const time = (event.timeStamp || 0) - state.start;
            const velocity = Math.sqrt(absX * absX + absY * absY) / (time || 1);
            const vxvy = [deltaX / (time || 1), deltaY / (time || 1)];
            const dir = getDirection(absX, absY, deltaX, deltaY);
            // if swipe is under delta and we have not started to track a swipe: skip update
            const delta = typeof props.delta === "number"
                ? props.delta
                : props.delta[dir.toLowerCase()] ||
                    defaultProps.delta;
            if (absX < delta && absY < delta && !state.swiping)
                return state;
            const eventData = {
                absX,
                absY,
                deltaX,
                deltaY,
                dir,
                event,
                first: state.first,
                initial: state.initial,
                velocity,
                vxvy,
            };
            // call onSwipeStart if present and is first swipe event
            eventData.first && props.onSwipeStart && props.onSwipeStart(eventData);
            // call onSwiping if present
            props.onSwiping && props.onSwiping(eventData);
            // track if a swipe is cancelable (handler for swiping or swiped(dir) exists)
            // so we can call preventDefault if needed
            let cancelablePageSwipe = false;
            if (props.onSwiping ||
                props.onSwiped ||
                props[`onSwiped${dir}`]) {
                cancelablePageSwipe = true;
            }
            if (cancelablePageSwipe &&
                props.preventScrollOnSwipe &&
                props.trackTouch &&
                event.cancelable) {
                event.preventDefault();
            }
            return Object.assign(Object.assign({}, state), { 
                // first is now always false
                first: false, eventData, swiping: true });
        });
    };
    const onEnd = (event) => {
        set((state, props) => {
            let eventData;
            if (state.swiping && state.eventData) {
                // if swipe is less than duration fire swiped callbacks
                if (event.timeStamp - state.start < props.swipeDuration) {
                    eventData = Object.assign(Object.assign({}, state.eventData), { event });
                    props.onSwiped && props.onSwiped(eventData);
                    const onSwipedDir = props[`onSwiped${eventData.dir}`];
                    onSwipedDir && onSwipedDir(eventData);
                }
            }
            else {
                props.onTap && props.onTap({ event });
            }
            props.onTouchEndOrOnMouseUp && props.onTouchEndOrOnMouseUp({ event });
            return Object.assign(Object.assign(Object.assign({}, state), initialState), { eventData });
        });
    };
    const cleanUpMouse = () => {
        // safe to just call removeEventListener
        document.removeEventListener(mouseMove, onMove);
        document.removeEventListener(mouseUp, onUp);
    };
    const onUp = (e) => {
        cleanUpMouse();
        onEnd(e);
    };
    /**
     * The value of passive on touchMove depends on `preventScrollOnSwipe`:
     * - true => { passive: false }
     * - false => { passive: true } // Default
     *
     * NOTE: When preventScrollOnSwipe is true, we attempt to call preventDefault to prevent scroll.
     *
     * props.touchEventOptions can also be set for all touch event listeners,
     * but for `touchmove` specifically when `preventScrollOnSwipe` it will
     * supersede and force passive to false.
     *
     */
    const attachTouch = (el, props) => {
        let cleanup = () => { };
        if (el && el.addEventListener) {
            const baseOptions = Object.assign(Object.assign({}, defaultProps.touchEventOptions), props.touchEventOptions);
            // attach touch event listeners and handlers
            const tls = [
                [touchStart, onStart, baseOptions],
                // preventScrollOnSwipe option supersedes touchEventOptions.passive
                [
                    touchMove,
                    onMove,
                    Object.assign(Object.assign({}, baseOptions), (props.preventScrollOnSwipe ? { passive: false } : {})),
                ],
                [touchEnd, onEnd, baseOptions],
            ];
            tls.forEach(([e, h, o]) => el.addEventListener(e, h, o));
            // return properly scoped cleanup method for removing listeners, options not required
            cleanup = () => tls.forEach(([e, h]) => el.removeEventListener(e, h));
        }
        return cleanup;
    };
    const onRef = (el) => {
        // "inline" ref functions are called twice on render, once with null then again with DOM element
        // ignore null here
        if (el === null)
            return;
        set((state, props) => {
            // if the same DOM el as previous just return state
            if (state.el === el)
                return state;
            const addState = {};
            // if new DOM el clean up old DOM and reset cleanUpTouch
            if (state.el && state.el !== el && state.cleanUpTouch) {
                state.cleanUpTouch();
                addState.cleanUpTouch = void 0;
            }
            // only attach if we want to track touch
            if (props.trackTouch && el) {
                addState.cleanUpTouch = attachTouch(el, props);
            }
            // store event attached DOM el for comparison, clean up, and re-attachment
            return Object.assign(Object.assign(Object.assign({}, state), { el }), addState);
        });
    };
    // set ref callback to attach touch event listeners
    const output = {
        ref: onRef,
    };
    // if track mouse attach mouse down listener
    if (handlerProps.trackMouse) {
        output.onMouseDown = onStart;
    }
    return [output, attachTouch];
}
function updateTransientState(state, props, previousProps, attachTouch) {
    // if trackTouch is off or there is no el, then remove handlers if necessary and exit
    if (!props.trackTouch || !state.el) {
        if (state.cleanUpTouch) {
            state.cleanUpTouch();
        }
        return Object.assign(Object.assign({}, state), { cleanUpTouch: undefined });
    }
    // trackTouch is on, so if there are no handlers attached, attach them and exit
    if (!state.cleanUpTouch) {
        return Object.assign(Object.assign({}, state), { cleanUpTouch: attachTouch(state.el, props) });
    }
    // trackTouch is on and handlers are already attached, so if preventScrollOnSwipe changes value,
    // remove and reattach handlers (this is required to update the passive option when attaching
    // the handlers)
    if (props.preventScrollOnSwipe !== previousProps.preventScrollOnSwipe ||
        props.touchEventOptions.passive !== previousProps.touchEventOptions.passive) {
        state.cleanUpTouch();
        return Object.assign(Object.assign({}, state), { cleanUpTouch: attachTouch(state.el, props) });
    }
    return state;
}
function useSwipeable(options) {
    const { trackMouse } = options;
    const transientState = react__WEBPACK_IMPORTED_MODULE_0__.useRef(Object.assign({}, initialState));
    const transientProps = react__WEBPACK_IMPORTED_MODULE_0__.useRef(Object.assign({}, defaultProps));
    // track previous rendered props
    const previousProps = react__WEBPACK_IMPORTED_MODULE_0__.useRef(Object.assign({}, transientProps.current));
    previousProps.current = Object.assign({}, transientProps.current);
    // update current render props & defaults
    transientProps.current = Object.assign(Object.assign({}, defaultProps), options);
    // Force defaults for config properties
    let defaultKey;
    for (defaultKey in defaultProps) {
        if (transientProps.current[defaultKey] === void 0) {
            transientProps.current[defaultKey] = defaultProps[defaultKey];
        }
    }
    const [handlers, attachTouch] = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => getHandlers((stateSetter) => (transientState.current = stateSetter(transientState.current, transientProps.current)), { trackMouse }), [trackMouse]);
    transientState.current = updateTransientState(transientState.current, transientProps.current, previousProps.current, attachTouch);
    return handlers;
}


//# sourceMappingURL=index.js.map


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,1664,2427,9319,7304,2738,2460,793,3732,3172,9774,2888,179], function() { return __webpack_exec__(47275); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);